
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4DJgG", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $917b9bb03b3149d5$var$logger = (0, $7W8i8.getLogger)('inline-comment');
const $917b9bb03b3149d5$export$dbde27c406dff8e8 = ({ content: content, contentId: contentId, commentToReattach: commentToReattach, actions: actions })=>{
    let selectionObj = {
        numMatches: 0,
        matchIndex: -1,
        selectedText: '',
        timestamp: 0
    };
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        $917b9bb03b3149d5$var$logger.debug`No text selected. Creating inline comment at cursor position.`;
        return selectionObj;
    }
    if (selection) {
        // TODO clean up after above FG is removed
        const range = selection.getRangeAt(0);
        const legacySelection = (0, $aUTn5.convertSelectionToLegacyFormat)(content.current, range, contentId);
        const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = legacySelection;
        selectionObj = {
            numMatches: numMatches,
            matchIndex: matchIndex,
            selectedText: selectedText,
            timestamp: Date.now()
        };
        /**
     * We generate the annotation step for the upcoming new collab service
     * to consume. This means we will eventually started sending markerRef
     * ids from the FE.
     */ try {
            const markerRef = commentToReattach ? commentToReattach.inlineMarkerRef : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            if (actions) {
                const proseMirrorStep = actions.annotate(range, markerRef, 'inlineComment');
                const { step: { from: from, to: to, mark: mark } } = proseMirrorStep;
                selectionObj['step'] = {
                    from: from,
                    to: to,
                    mark: {
                        type: 'annotation',
                        attrs: {
                            key: mark.attrs?.annotationType,
                            value: mark.attrs?.id
                        }
                    }
                };
            }
        } catch (e) {
            $917b9bb03b3149d5$var$logger.error`An error occurred when generating a step - ${e}`;
        }
    }
    return selectionObj;
};
module.exports["getLegacyConvertedSelectionObj"] = $917b9bb03b3149d5$export$dbde27c406dff8e8;

});

parcelRegister("7rLBD", function(module, exports) {

var $hpFQM = parcelRequire("hpFQM");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("aKDZB", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $8akfd = parcelRequire("8akfd");


var $8GyO5 = parcelRequire("8GyO5");


var $gRoSG = parcelRequire("gRoSG");


var $aXWtB = parcelRequire("aXWtB");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $jyA9t = parcelRequire("jyA9t");


var $3OD5k = parcelRequire("3OD5k");


var $3rRes = parcelRequire("3rRes");

const $9dc19d5e68a65b89$var$machineToRendererPhase = {
    thinking: 'thinking',
    ready: 'ready',
    previewing: 'previewing',
    inserting: 'submitting',
    error: 'error',
    aborted: 'aborted'
};
const $9dc19d5e68a65b89$export$b1a7146262519ea1 = (phase)=>phase === undefined ? 'inactive' : $9dc19d5e68a65b89$var$machineToRendererPhase[phase];



var $25qMx = parcelRequire("25qMx");


var $iMLPM = parcelRequire("iMLPM");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");

function $738409fb11353f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $738409fb11353f61$var$rendererHighlightStyles = {
    name: "18r8tnl",
    styles: "::highlight(remix-thinking-renderer){background-color:var(--ds-background-accent-purple-subtler, #EED7FC);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $738409fb11353f61$export$533b8d7a5499bf49 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: $738409fb11353f61$var$rendererHighlightStyles
    }));
};



var $eqqiF = parcelRequire("eqqiF");








var $caVF7 = parcelRequire("caVF7");

const $2e4059893c92a637$export$654bbdda10638776 = ({ entryPoint: entryPoint, experienceTracker: experienceTracker, dynamicUiType: dynamicUiType, selectedSubTypeRef: selectedSubTypeRef, openAIFCStagingModalRef: openAIFCStagingModalRef, isRemixCancelledRef: isRemixCancelledRef, conversationIdRef: conversationIdRef, shouldOpenPreview: shouldOpenPreview, onAfterOpenPreview: onAfterOpenPreview })=>{
    const openPreview = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: 'confluence',
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: entryPoint,
                conversationChannelId: conversationIdRef?.current
            }
        });
        openAIFCStagingModalRef.current();
        onAfterOpenPreview?.();
    }, [
        entryPoint,
        experienceTracker,
        dynamicUiType,
        selectedSubTypeRef,
        openAIFCStagingModalRef,
        conversationIdRef,
        onAfterOpenPreview
    ]);
    const openPreviewIfAllowed = (0, $cozmU.useCallback)(()=>{
        if (shouldOpenPreview?.() === false) return;
        openPreview();
    }, [
        openPreview,
        shouldOpenPreview
    ]);
    const abortRendersInModal = (0, $cozmU.useCallback)(()=>{
        const reason = 'User closed modal before render completed';
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
    }, [
        experienceTracker
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, signalActionReady: signalActionReady, resetCompletion: resetCompletion } = (0, $caVF7.useRemixThinkingBarProgress)({
        onOpenPreview: openPreviewIfAllowed
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelledRef.current) {
            if (dynamicUiType !== 'diagram' && dynamicUiType !== 'whiteboard') (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            signalActionReady();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ref identity is stable; reading .current does not need to be a dep
    }, [
        dynamicUiType,
        signalActionReady
    ]);
    return {
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        onActionReady: onActionReady,
        abortRendersInModal: abortRendersInModal,
        resetCompletion: resetCompletion
    };
};






var $lEf8v = parcelRequire("lEf8v");

const $7320d3edb50fb9c8$export$d4909a6f4c87ce20 = (isAdmittedRemixId, { onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    const handledRef = (0, $cozmU.useRef)({
        remixId: undefined,
        commands: new Set()
    });
    (0, $lEf8v.useRemixCommands)((command)=>{
        if (!isAdmittedRemixId(command.remixId)) return;
        if (handledRef.current.remixId !== command.remixId) handledRef.current = {
            remixId: command.remixId,
            commands: new Set()
        };
        let claim;
        switch(command.type){
            case 'RemixReady':
            case 'RemixErrored':
            case 'RemixAborted':
                claim = command.type;
                break;
            case 'RemixGenerationEnded':
                claim = `${command.type}:${command.reason}`;
                break;
            default:
                return;
        }
        if (handledRef.current.commands.has(claim)) return;
        handledRef.current.commands.add(claim);
        switch(command.type){
            case 'RemixReady':
                onReady(command);
                break;
            case 'RemixErrored':
                onErrored(command);
                break;
            case 'RemixAborted':
                onAborted(command);
                break;
            case 'RemixGenerationEnded':
                onGenerationEnded(command);
                break;
        }
    });
};



var $alDoy = parcelRequire("alDoy");


var $7eOZ4 = parcelRequire("7eOZ4");




const $5ae98e04c533e5e9$var$HIGHLIGHT_NAME = 'remix-thinking-renderer';
const $5ae98e04c533e5e9$export$443e8aeb4c392a84 = ()=>{
    const savedRangeRef = (0, $cozmU.useRef)(null);
    const [isHighlighting, setIsHighlighting] = (0, $cozmU.useState)(false);
    const clearHighlight = (0, $cozmU.useCallback)(()=>{
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) CSS.highlights.delete($5ae98e04c533e5e9$var$HIGHLIGHT_NAME);
        savedRangeRef.current = null;
        setIsHighlighting(false);
    }, []);
    const startHighlight = (0, $cozmU.useCallback)(()=>{
        // Drop any highlight left over from an earlier Remix before looking for the new one.
        // Without this, starting a Remix of a different piece of content while there is no live
        // text selection would leave the earlier content highlighted, pointing at content that is
        // no longer the one being Remixed.
        clearHighlight();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const sel = document.getSelection();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
        const range = sel.getRangeAt(0).cloneRange();
        savedRangeRef.current = range;
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) {
            const highlight = new Highlight(range);
            CSS.highlights.set($5ae98e04c533e5e9$var$HIGHLIGHT_NAME, highlight);
            sel.removeAllRanges();
            setIsHighlighting(true);
        }
    }, [
        clearHighlight
    ]);
    return {
        startHighlight: startHighlight,
        clearHighlight: clearHighlight,
        isHighlighting: isHighlighting,
        savedRange: savedRangeRef
    };
};






var $9HkI0 = parcelRequire("9HkI0");


var $9DHhW = parcelRequire("9DHhW");


var $hwgBi = parcelRequire("hwgBi");


var $bWlOZ = parcelRequire("bWlOZ");



const $e7504183f26ea064$var$readMachineTerminalPhase = (remixId)=>{
    const phase = (0, $bWlOZ.getRemixMachine)(remixId)?.state();
    return phase === 'aborted' || phase === 'error' ? phase : undefined;
};
const $e7504183f26ea064$export$80b3b48a0293a136 = ({ onAdmissionRejected: onAdmissionRejected } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const logLifecycleOperationError = (0, $cozmU.useCallback)((operation, error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'rendererRemixLifecycleOperation',
                source: 'rendererRemix',
                attributes: {
                    operation: operation,
                    errorName: error instanceof Error ? error.name : typeof error
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const reportUnresolvedTransition = (0, $cozmU.useCallback)((origin, machinePhase)=>{
        try {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'rendererRemixLifecycleOperation',
                    source: 'rendererRemix',
                    attributes: {
                        operation: 'unresolved-transition',
                        surface: 'renderer',
                        origin: origin,
                        machinePhase: machinePhase
                    }
                }
            }).fire();
        } catch  {
        // Reporting must never block the caller's UI and experience cleanup.
        }
    }, [
        createAnalyticsEvent
    ]);
    const runLifecycleSafely = (0, $cozmU.useCallback)((operationName, operation)=>{
        try {
            operation();
            return true;
        } catch (error) {
            logLifecycleOperationError(operationName, error);
            return false;
        }
    }, [
        logLifecycleOperationError
    ]);
    const [remixId, setRemixId] = (0, $cozmU.useState)();
    const phase = (0, $gRoSG.useMachinePhase)(remixId ?? '');
    const phaseRef = (0, $cozmU.useRef)(phase);
    phaseRef.current = phase;
    const remixIdRef = (0, $cozmU.useRef)(undefined);
    const commandRemixIdRef = (0, $cozmU.useRef)(undefined);
    const cancellationSessionIdRef = (0, $cozmU.useRef)(undefined);
    const pendingIntentRef = (0, $cozmU.useRef)(undefined);
    const finalizedRef = (0, $cozmU.useRef)(true);
    const claimFinalization = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return undefined;
        // Detach the claimed flow before invoking any external callback. A command handler reached
        // through `sendRemixEvent` or `endRemix` may synchronously start another flow, and finalizing
        // this flow must not clear that new owner's identity or cancellation session.
        const cancellationSessionId = cancellationSessionIdRef.current;
        finalizedRef.current = true;
        remixIdRef.current = undefined;
        cancellationSessionIdRef.current = undefined;
        pendingIntentRef.current = undefined;
        return {
            remixId: activeRemixId,
            cancellationSessionId: cancellationSessionId
        };
    }, []);
    const releaseClaimedFlow = (0, $cozmU.useCallback)((finalization)=>{
        if (commandRemixIdRef.current === finalization.remixId) commandRemixIdRef.current = undefined;
        if (finalization.cancellationSessionId) (0, $hwgBi.unregisterRemixCancellationSession)(finalization.cancellationSessionId);
    }, []);
    const safelyEndRemix = (0, $cozmU.useCallback)((id, reason)=>{
        runLifecycleSafely('endRemix', ()=>(0, $bWlOZ.endRemix)(id, reason));
    }, [
        runLifecycleSafely
    ]);
    const endObservedTerminal = (0, $cozmU.useCallback)((reason)=>{
        const finalization = claimFinalization();
        if (!finalization) return;
        try {
            safelyEndRemix(finalization.remixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
    }, [
        claimFinalization,
        releaseClaimedFlow,
        safelyEndRemix
    ]);
    const endWith = (0, $cozmU.useCallback)(({ event: event, reason: reason, origin: origin })=>{
        const finalization = claimFinalization();
        if (!finalization) return 'no-active-flow';
        const activeRemixId = finalization.remixId;
        let result = 'unresolved';
        let unresolvedPhase = 'missing';
        let didSendTerminalEvent = false;
        try {
            const terminalPhaseBeforeSend = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            didSendTerminalEvent = runLifecycleSafely('sendTerminalEvent', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: event
                }));
            if (terminalPhaseBeforeSend !== undefined) result = 'already-terminal';
            else if ($e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId) !== undefined) result = 'applied';
            else unresolvedPhase = (0, $bWlOZ.getRemixMachine)(activeRemixId)?.state() ?? 'missing';
            safelyEndRemix(activeRemixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
        // A send that threw is already reported as `sendTerminalEvent`.
        if (result === 'unresolved' && didSendTerminalEvent) reportUnresolvedTransition(origin, unresolvedPhase);
        return result;
    }, [
        claimFinalization,
        releaseClaimedFlow,
        reportUnresolvedTransition,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const startFlow = (0, $cozmU.useCallback)(({ conversationId: requestedConversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, source: source })=>{
        const conversationId = requestedConversationId ?? (0, $9HkI0.v4)();
        // Preserve any existing admitted flow. SINGLE_ACTIVE_POLICY owns rejection.
        if (remixIdRef.current && !finalizedRef.current) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        const cancellationSessionId = (0, $hwgBi.registerRemixCancellationSession)({
            conversationId: conversationId
        });
        if (!cancellationSessionId) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        try {
            const result = (0, $bWlOZ.startRemix)({
                kind: 'create',
                conversationId: conversationId,
                cancellationSessionId: cancellationSessionId,
                metadata: {
                    dynamicUiType: dynamicUiType,
                    dynamicUiSubtype: dynamicUiSubtype,
                    source: source
                },
                useCommandBus: true
            });
            if (!result) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'active-flow'
                };
            }
            if (result.conversationId !== conversationId) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                logLifecycleOperationError('validateAdmissionIdentity', new Error('Machine admission returned a different conversation identity'));
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('identity-mismatch'));
                safelyEndRemix(result.remixId, 'cancelled');
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'identity-mismatch'
                };
            }
            finalizedRef.current = false;
            remixIdRef.current = result.remixId;
            commandRemixIdRef.current = result.remixId;
            cancellationSessionIdRef.current = cancellationSessionId;
            pendingIntentRef.current = undefined;
            setRemixId(result.remixId);
            return {
                conversationId: conversationId,
                admitted: true,
                cancellationSessionId: cancellationSessionId
            };
        } catch (error) {
            (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
            logLifecycleOperationError('startRemix', error);
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('error'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'error'
            };
        }
    }, [
        logLifecycleOperationError,
        onAdmissionRejected,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const reconcileIntent = (0, $cozmU.useCallback)((intent)=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return;
        const currentPhase = phaseRef.current;
        if (intent === 'preview-opened' && currentPhase === 'ready') {
            pendingIntentRef.current = undefined;
            if (!runLifecycleSafely('sendPreviewOpened', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: 'PREVIEW_OPENED'
                }))) {
                const finalization = claimFinalization();
                if (finalization) try {
                    safelyEndRemix(finalization.remixId, 'cancelled');
                } finally{
                    releaseClaimedFlow(finalization);
                }
            }
            return;
        }
    }, [
        claimFinalization,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>{
        if (remixIdRef.current && !finalizedRef.current) {
            pendingIntentRef.current = 'preview-opened';
            reconcileIntent('preview-opened');
        }
    }, [
        reconcileIntent
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled',
            origin: 'preview-dismissed'
        });
    }, [
        endWith
    ]);
    const onStopThinking = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        const currentPhase = activeRemixId ? (0, $bWlOZ.getRemixMachine)(activeRemixId)?.state() : undefined;
        return endWith({
            event: currentPhase === 'thinking' ? 'GENERATION_ABORTED' : 'CANCELLED',
            reason: 'aborted',
            origin: 'local-stop'
        });
    }, [
        endWith
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('aborted');
    }, [
        endObservedTerminal
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('cancelled');
    }, [
        endObservedTerminal
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'GENERATION_ERROR',
            reason: 'error',
            origin: 'send-rejected'
        });
    }, [
        endWith
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled',
            origin: 'navigation'
        });
    }, [
        endWith
    ]);
    (0, $cozmU.useEffect)(()=>{
        const pendingIntent = pendingIntentRef.current;
        if (!pendingIntent) return;
        // Reconcile the queued renderer intent only after the watcher exposes a legal machine phase.
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        reconcileIntent(pendingIntent);
    }, [
        phase,
        reconcileIntent
    ]);
    // Component teardown cancels the flow and releases machine admission.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const finalization = claimFinalization();
            if (!finalization) return;
            const activeRemixId = finalization.remixId;
            try {
                runLifecycleSafely('sendUnmountCancelled', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                        type: 'CANCELLED'
                    }));
                safelyEndRemix(activeRemixId, 'cancelled');
            } finally{
                releaseClaimedFlow(finalization);
            }
        };
    }, [
        claimFinalization,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const isAdmittedRemixId = (0, $cozmU.useCallback)((id)=>commandRemixIdRef.current === id, []);
    return {
        phase: phase,
        remixId: remixId,
        isAdmittedRemixId: isAdmittedRemixId,
        startFlow: startFlow,
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: onPreviewDismissed,
        onStopThinking: onStopThinking,
        onRovoAborted: onRovoAborted,
        onErrorDismissed: onErrorDismissed,
        onSendRejected: onSendRejected,
        onNavigation: onNavigation
    };
};



var $hxqA6 = parcelRequire("hxqA6");

const $c9c8b9d550aa1c05$var$constructDynamicUiSource = (adfDocument, selectionContext, contentType)=>{
    const fragmentAdf = (0, $3rRes.prepareRemixFragmentNodes)(selectionContext?.selectionFragment ?? null);
    return {
        contentType: contentType,
        startLocalId: selectionContext?.localIds?.[0] ?? '',
        endLocalId: selectionContext?.localIds?.[selectionContext.localIds.length - 1] ?? '',
        startIndex: selectionContext?.startIndex ?? 0,
        endIndex: selectionContext?.endIndex ?? -1,
        // When the entire page is selected (e.g. cmd+a), selectionContext is null and
        // selectionFragment is not populated. Fall back to the full document content
        // so that Remix still receives the source content it needs.
        fragmentAdf: fragmentAdf ?? adfDocument.content,
        fullAdf: adfDocument
    };
};
const $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY = 'renderer-selection-remix';
const $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed = ()=>{
    // `rovo-remix-handoff-failed` is not in the merged PubSub Payload union yet,
    // so TypeScript will not accept it as a `publish()` argument without a cast.
    (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
        type: 'rovo-remix-handoff-failed',
        source: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    });
};
const $c9c8b9d550aa1c05$var$isRendererSelectionSubmit = (payload)=>payload.type === 'submit-rovo-remix' && payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection';
const $c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit = ({ currentContentId: currentContentId, hasGenerationStarted: hasGenerationStarted, onAcceptSubmit: onAcceptSubmit, onDisarm: onDisarm, originContentIdRef: originContentIdRef })=>{
    const currentContentIdRef = (0, $cozmU.useRef)(currentContentId);
    currentContentIdRef.current = currentContentId;
    const hasGenerationStartedRef = (0, $cozmU.useRef)(hasGenerationStarted);
    hasGenerationStartedRef.current = hasGenerationStarted;
    const acceptedSubmitRef = (0, $cozmU.useRef)(false);
    const onAcceptSubmitRef = (0, $cozmU.useRef)(onAcceptSubmit);
    onAcceptSubmitRef.current = onAcceptSubmit;
    const onDisarmRef = (0, $cozmU.useRef)(onDisarm);
    onDisarmRef.current = onDisarm;
    const disarmIfIdle = (0, $cozmU.useCallback)(()=>{
        if (hasGenerationStartedRef.current || acceptedSubmitRef.current) return;
        onDisarmRef.current();
    }, []);
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).ROVO_REMIX,
        consumeOnceKey: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    }, (payload)=>{
        if (!$c9c8b9d550aa1c05$var$isRendererSelectionSubmit(payload) || payload.type !== 'submit-rovo-remix') return;
        const originContentId = originContentIdRef.current;
        if (originContentId && currentContentIdRef.current && originContentId !== currentContentIdRef.current) return;
        if (acceptedSubmitRef.current || hasGenerationStartedRef.current) return;
        acceptedSubmitRef.current = true;
        onAcceptSubmitRef.current({
            type: payload.data.remixOption,
            subType: payload.data.remixSubType,
            userPrompt: payload.data.userPrompt,
            conversationId: payload.data.conversationId
        }).then((result)=>{
            if (result.status === 'rejected') acceptedSubmitRef.current = false;
        }).catch(()=>{
            // Keep the listener retryable if an unexpected callback failure escapes.
            acceptedSubmitRef.current = false;
        });
    });
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).AI_MATE
    }, (payload)=>{
        if (payload.type === 'chat-close') {
            disarmIfIdle();
            return;
        }
        if (payload.type === 'chat-new' && payload.data.resetActiveMenu) {
            disarmIfIdle();
            return;
        }
        if (payload.type !== 'open-rovo-remix-sidebar') return;
        if (payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection') return;
        disarmIfIdle();
    });
    return null;
};
/**
 * Runs the Remix clean-up when the user closes the Rovo panel before choosing a Remix
 * option.
 *
 * Closing the Rovo panel sends no message that Confluence can listen for, so the only
 * way to notice it is to watch whether the panel is currently showing.
 *
 * The same click that arms the Remix flow also asks the panel to open, so there is a
 * short moment where the panel is not showing yet. Treating that moment as a close would
 * cancel the flow the instant it started, so a close is only acted on once the panel has
 * been seen showing at least once.
 */ const $c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses = ({ onRovoPanelClosed: onRovoPanelClosed })=>{
    const { isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, mode: mode } = (0, $1AJi3.useToggleConversationAssistant)();
    const isConversationAssistantOpen = isConversationAssistantSidebarActive || mode !== undefined;
    const hasSeenRovoPanelOpen = (0, $cozmU.useRef)(false);
    const onRovoPanelClosedRef = (0, $cozmU.useRef)(onRovoPanelClosed);
    onRovoPanelClosedRef.current = onRovoPanelClosed;
    (0, $cozmU.useEffect)(()=>{
        if (isConversationAssistantOpen) {
            hasSeenRovoPanelOpen.current = true;
            return;
        }
        if (!hasSeenRovoPanelOpen.current) return;
        onRovoPanelClosedRef.current();
    }, [
        isConversationAssistantOpen
    ]);
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixCommandEffects = ({ isAdmittedRemixId: isAdmittedRemixId, onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    (0, $7320d3edb50fb9c8$export$d4909a6f4c87ce20)(isAdmittedRemixId, {
        onReady: onReady,
        onErrored: onErrored,
        onAborted: onAborted,
        onGenerationEnded: onGenerationEnded
    });
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixModal = ({ adfDocument: adfDocument, selectionContext: selectionContext, interactionSource: interactionSource, onClose: onClose, onFinalizeCommandSession: onFinalizeCommandSession, onStartThinking: onStartThinking, onStopThinking: onStopThinking, hiddenOptions: hiddenOptions, isEphemeralViewVisible: isEphemeralViewVisible, isRendererOverlayOpen: isRendererOverlayOpen, currentContentId: currentContentId, anchorRect: anchorRect, anchorElement: anchorElement, machineLifecycle: machineLifecycle })=>{
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackGenerationFailed: trackGenerationFailed, trackGenerationStarted: trackGenerationStarted, trackGenerationStopped: trackGenerationStopped, trackGenerationSucceeded: trackGenerationSucceeded, trackRemixSubmitted: trackRemixSubmitted } = (0, $alDoy.useRemixGenerationAnalytics)();
    const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)();
    const mergedHiddenOptions = unavailableSpaceOptions.length > 0 ? [
        ...hiddenOptions,
        ...unavailableSpaceOptions
    ] : hiddenOptions;
    const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
    const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
    const conversationIdRef = (0, $cozmU.useRef)(undefined);
    const remixOriginContentIdRef = (0, $cozmU.useRef)(undefined);
    const abortOriginRef = (0, $cozmU.useRef)();
    const [positionedAnchorRect, setPositionedAnchorRect] = (0, $cozmU.useState)(anchorRect);
    const [popupRepositionKey, setPopupRepositionKey] = (0, $cozmU.useState)(0);
    const restartExperiencesAfterRejectedStart = (0, $cozmU.useCallback)((rejectionReason)=>{
        const restartAttributes = {
            entryPoint: 'renderer',
            remixSource: 'rejectedRemixStart',
            product: 'confluence',
            rejectionReason: rejectionReason,
            ...interactionSource !== undefined ? {
                originalRemixSource: interactionSource
            } : {}
        };
        hasCommittedRemixCreateTerminal.current = false;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: restartAttributes
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: restartAttributes
        });
    }, [
        experienceTracker,
        interactionSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (remixOriginContentIdRef.current === undefined) remixOriginContentIdRef.current = currentContentId;
    }, [
        currentContentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        setPositionedAnchorRect(anchorRect);
    }, [
        anchorRect
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!anchorElement) return;
        let animationFrameId;
        const updateAnchorPosition = ()=>{
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
            animationFrameId = window.requestAnimationFrame(()=>{
                // Keep the last known rect: the anchor can detach while the picker is opening.
                if (!anchorElement.isConnected) return;
                setPositionedAnchorRect(anchorElement.getBoundingClientRect());
                setPopupRepositionKey((key)=>key + 1);
            });
        };
        // `anchorRect` positions the initial render, so only follow on scroll/resize.
        const unbindScroll = (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: updateAnchorPosition,
            options: {
                capture: true,
                passive: true
            }
        });
        const unbindResize = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: updateAnchorPosition
        });
        return ()=>{
            unbindScroll();
            unbindResize();
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
        };
    }, [
        anchorElement
    ]);
    const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>machineLifecycle.onPreviewOpened(), [
        machineLifecycle
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle.onPreviewDismissed(), [
        machineLifecycle
    ]);
    const stopMachineThinking = (0, $cozmU.useCallback)(()=>machineLifecycle.onStopThinking(), [
        machineLifecycle
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>machineLifecycle.onRovoAborted(), [
        machineLifecycle
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle.onErrorDismissed(), [
        machineLifecycle
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>machineLifecycle.onSendRejected(), [
        machineLifecycle
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>machineLifecycle.onNavigation(), [
        machineLifecycle
    ]);
    const dismissRendererRemixUiAfterNavigation = (0, $cozmU.useCallback)(()=>{
        const reason = 'User navigated away before renderer remix preview opened';
        isRemixCancelled.current = true;
        abortOriginRef.current = 'navigation';
        if (onNavigation() === 'applied') return;
        onStopThinking();
        onClose();
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
    }, [
        experienceTracker,
        onClose,
        onNavigation,
        onStopThinking
    ]);
    const shouldOpenPreview = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) return false;
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return true;
        const originContentId = remixOriginContentIdRef.current;
        return !originContentId || !currentContentId || originContentId === currentContentId;
    }, [
        currentContentId
    ]);
    // Collapse the highlight overlay after the preview opens.
    const onAfterOpenPreview = (0, $cozmU.useCallback)(()=>{
        onClose({
            preservePreviewSession: true
        });
    }, [
        onClose
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: handlePreviewActionReady, abortRendersInModal: abortRendersInModal, resetCompletion: resetCompletion } = (0, $2e4059893c92a637$export$654bbdda10638776)({
        entryPoint: 'renderer',
        experienceTracker: experienceTracker,
        dynamicUiType: dynamicUiType,
        selectedSubTypeRef: selectedSubTypeRef,
        openAIFCStagingModalRef: openAIFCStagingModalRef,
        isRemixCancelledRef: isRemixCancelled,
        conversationIdRef: conversationIdRef,
        shouldOpenPreview: shouldOpenPreview,
        onAfterOpenPreview: onAfterOpenPreview
    });
    const handlePreviewDismissed = (0, $cozmU.useCallback)(()=>{
        abortOriginRef.current = 'preview-dismissed';
        abortRendersInModal();
        onPreviewDismissed();
    }, [
        abortRendersInModal,
        onPreviewDismissed
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isWaitingForInput: isWaitingForInput, remixStoreError: remixStoreError, remixConversationId: remixConversationId, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: handlePreviewDismissed,
        trackRemixConversationById: true
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    const rendererPhase = (0, $9dc19d5e68a65b89$export$b1a7146262519ea1)(machineLifecycle.phase);
    const isRendererRemixInProgress = rendererPhase === 'thinking' || rendererPhase === 'ready';
    const handleCommandReady = (0, $cozmU.useCallback)((command)=>{
        abortOriginRef.current = undefined;
        handlePreviewActionReady();
        if (!isRemixCancelled.current) trackGenerationSucceeded({
            conversationChannelId: command.conversationId
        });
    }, [
        handlePreviewActionReady,
        trackGenerationSucceeded
    ]);
    const handleCommandErrored = (0, $cozmU.useCallback)((command)=>{
        const commandStoreError = remixConversationId === command.conversationId ? remixStoreError : null;
        const errorMessage = commandStoreError?.content ?? 'Rovo agent error during remix';
        if (isEphemeralViewVisible) closeAIFCStagingModal();
        onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        openConversationAssistant('sidebar');
        resetRemixConversationId();
        experienceTracker.fail({
            teamName: 'CC CE MAU',
            name: (0, $irnO2.ExperienceName).REMIX_START,
            error: new Error(errorMessage),
            attributes: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId,
                errorStatusCode: commandStoreError?.status_code
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).failure({
            metadata: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId
            }
        });
        trackGenerationFailed({
            conversationChannelId: command.conversationId
        });
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        openConversationAssistant,
        remixConversationId,
        remixStoreError,
        resetRemixConversationId,
        trackGenerationFailed
    ]);
    const handleCommandAborted = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        resetCompletion();
        if (abortOrigin === 'preview-dismissed' || abortOrigin === 'send-rejected') return;
        if (abortOrigin === 'navigation') {
            const reason = 'User navigated away before renderer remix preview opened';
            onClose({
                preserveCommandSession: true,
                preserveThinking: true
            });
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: reason,
                attributes: {
                    reason: reason
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: reason
                }
            });
            return;
        }
        const reason = abortOrigin === 'local-stop' ? 'User cancelled remix thinking' : 'User stopped from Rovo side chat';
        if (abortOrigin !== 'local-stop') {
            // The modal store can lag the terminal conversation snapshot, so closing is
            // intentionally idempotent even when render-time visibility is still false.
            if ((0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) {
                isRemixCancelled.current = true;
                closeAIFCStagingModal();
            } else if (isEphemeralViewVisible) closeAIFCStagingModal();
        }
        const closesRendererUi = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop');
        if (closesRendererUi) onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        try {
            if (abortOrigin === 'local-stop') {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: reason,
                    attributes: {
                        reason: reason
                    }
                });
                (0, $irnO2.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: reason
                    }
                });
            }
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            trackGenerationStopped({
                conversationChannelId: command.conversationId
            });
        } finally{
            if (!closesRendererUi) {
                const restartAttributes = {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: restartAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: restartAttributes
                });
            }
        }
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleCommandGenerationEnded = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        const closesCommandSession = command.reason === 'error' || command.reason === 'aborted' && abortOrigin !== 'preview-dismissed' && abortOrigin !== 'send-rejected' && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop'));
        if (abortOrigin !== 'preview-dismissed') onStopThinking({
            reopenModal: command.reason === 'ready' || abortOrigin === 'send-rejected' || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            abortOrigin === 'local-stop' && !(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')
        });
        if (command.reason === 'error') onErrorDismissed();
        else if (command.reason === 'aborted' && abortOrigin === undefined) onRovoAborted();
        if (closesCommandSession) onFinalizeCommandSession();
        abortOriginRef.current = undefined;
    }, [
        onErrorDismissed,
        onFinalizeCommandSession,
        onRovoAborted,
        onStopThinking
    ]);
    (0, $cozmU.useEffect)(()=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const originContentId = remixOriginContentIdRef.current;
        if (!originContentId || !currentContentId || originContentId === currentContentId) return;
        dismissRendererRemixUiAfterNavigation();
    }, [
        currentContentId,
        dismissRendererRemixUiAfterNavigation
    ]);
    // Abort experience on unmount (overlay closed without selecting an option).
    // Uses a ref so the cleanup always calls the latest tracker reference.
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
            (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasCommittedRemixCreateTerminal.current);
        };
    }, []);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            abortOriginRef.current = undefined;
            // Clear stale completion state from any previous flow.
            resetCompletion();
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            // A stopped flow can already have reached the completed-progress interval.
            // Clear it before reopening so the picker does not render a stale ready state.
            resetCompletion();
            abortOriginRef.current = 'local-stop';
            remixOriginContentIdRef.current = undefined;
            let terminalResult = 'no-active-flow';
            try {
                stopRemixing();
            } finally{
                terminalResult = stopMachineThinking();
            }
            if (terminalResult !== 'applied') {
                const reason = 'User cancelled remix thinking';
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                if ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
                else onStopThinking({
                    reopenModal: true
                });
                try {
                    experienceTracker.abort({
                        name: (0, $irnO2.ExperienceName).REMIX_START,
                        reason: reason,
                        attributes: {
                            reason: reason
                        }
                    });
                    (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
                    (0, $irnO2.remixGeneratePreviewExperience).abort({
                        metadata: {
                            reason: reason
                        }
                    });
                    trackGenerationStopped({
                        conversationChannelId: conversationIdRef.current
                    });
                } finally{
                    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                    if (!(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) {
                        const restartAttributes = {
                            entryPoint: 'renderer',
                            remixSource: 'cancelledRemixThinking',
                            originalRemixSource: 'selectionToolbar',
                            product: 'confluence'
                        };
                        experienceTracker.start({
                            name: (0, $irnO2.ExperienceName).REMIX_START,
                            id: (0, $irnO2.ExperienceName).REMIX_START,
                            attributes: restartAttributes
                        });
                        (0, $kDDrf.startRemixCreateExperience)({
                            experienceTracker: experienceTracker,
                            attributes: restartAttributes
                        });
                    }
                }
            }
        }
    }, [
        onStartThinking,
        stopRemixing,
        stopMachineThinking,
        onClose,
        onStopThinking,
        experienceTracker,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt, conversationId: conversationId })=>{
        // Only a submission from the Rovo sidebar carries a conversationId, and the Rovo
        // sidebar is only shown to the variant2 cohort. Its `userPrompt` is already the
        // complete sentence shown in the chat input, so passing that sentence as
        // `promptText` stops `sendAIFCPrompt` from writing a second copy of the same
        // sentence and joining the two together. Checking the cohort as well as the
        // conversationId guarantees that anyone outside the experiment keeps the original
        // behaviour, even if some future caller starts supplying a conversationId.
        const isRovoChatSubmission = conversationId !== undefined && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
        remixOriginContentIdRef.current = remixOriginContentIdRef.current ?? currentContentId;
        selectedSubTypeRef.current = subType;
        const dynamicUiSource = $c9c8b9d550aa1c05$var$constructDynamicUiSource(adfDocument, selectionContext, (0, $3OD5k.resolveRemixDynamicUiContentType)(currentContentType));
        const admission = machineLifecycle.startFlow({
            conversationId: conversationId,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            source: interactionSource
        });
        if (!admission.admitted) {
            if (admission.reason !== 'active-flow') {
                const admissionError = new Error(`Renderer Remix machine admission was rejected: ${admission.reason}`);
                experienceTracker.fail({
                    teamName: 'CC CE MAU',
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    error: admissionError,
                    attributes: {
                        reason: admissionError.message,
                        rejectionReason: admission.reason
                    }
                });
                (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, admissionError.message);
                restartExperiencesAfterRejectedStart(admission.reason);
            }
            onStopThinking({
                reopenModal: true
            });
            return {
                status: 'rejected',
                reason: 'admission-rejected'
            };
        }
        const { conversationId: authoritativeConversationId, cancellationSessionId: cancellationSessionId } = admission;
        if (remixConversationId !== undefined) resetRemixConversationId();
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).start();
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
            product: 'confluence',
            interactionSource: interactionSource,
            entryPoint: 'renderer',
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt,
            ...type === 'infographic' ? {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
            } : {}
        });
        const generationAnalyticsAttributes = {
            contentId: currentContentId,
            ...conversationId && {
                conversationChannelId: conversationId
            },
            entryPoint: 'renderer',
            includesFreegenPrompt: !!userPrompt,
            product: 'confluence',
            remixSource: interactionSource,
            remixSubtype: subType,
            remixType: type
        };
        trackRemixSubmitted(generationAnalyticsAttributes);
        trackGenerationStarted(generationAnalyticsAttributes);
        let conversationChannelId;
        try {
            conversationChannelId = await sendAIFCPrompt({
                userPrompt: isRovoChatSubmission ? undefined : userPrompt,
                promptText: isRovoChatSubmission ? userPrompt : undefined,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: interactionSource,
                conversationId: authoritativeConversationId,
                remixCancellationSessionId: cancellationSessionId
            });
        } catch (error) {
            abortOriginRef.current = 'send-rejected';
            if (onSendRejected() !== 'applied') onStopThinking({
                reopenModal: true
            });
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed();
            const sendError = error instanceof Error ? error : new Error('Failed to send renderer Remix prompt');
            const reason = 'Failed to send renderer Remix prompt';
            experienceTracker.fail({
                teamName: 'CC CE MAU',
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: sendError,
                attributes: {
                    reason: reason,
                    rejectionReason: 'send-failed'
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    reason: reason
                }
            });
            trackGenerationFailed();
            (0, $kDDrf.failRemixCreateExperience)(experienceTracker, sendError, {
                reason: reason,
                rejectionReason: 'send-failed'
            });
            restartExperiencesAfterRejectedStart('send-failed');
            return {
                status: 'rejected',
                reason: 'send-failed'
            };
        }
        // Stash the conversationId so `useRemixPreviewFlow` can include it as
        // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
        // once `onActionReady` fires.
        conversationIdRef.current = conversationChannelId;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                conversationChannelId: conversationChannelId
            }
        });
        hasCommittedRemixCreateTerminal.current = true;
        (0, $kDDrf.trackRemixCreateOptionSelected)({
            experienceTracker: experienceTracker,
            conversationId: conversationChannelId,
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt
        });
        return {
            status: 'started'
        };
    }, [
        sendAIFCPrompt,
        adfDocument,
        selectionContext,
        currentContentType,
        interactionSource,
        experienceTracker,
        currentContentId,
        machineLifecycle,
        remixConversationId,
        onSendRejected,
        onStopThinking,
        resetRemixConversationId,
        restartExperiencesAfterRejectedStart,
        trackGenerationFailed,
        trackGenerationStarted,
        trackRemixSubmitted
    ]);
    const acceptRovoRemixSubmit = (0, $cozmU.useCallback)((params)=>{
        onRemixFlowActiveChange(true);
        return handleOptionSelect(params);
    }, [
        handleOptionSelect,
        onRemixFlowActiveChange
    ]);
    const shouldShowOriginalRemixPopUpWindow = isRendererRemixInProgress || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixCommandEffects, {
        isAdmittedRemixId: machineLifecycle.isAdmittedRemixId,
        onReady: handleCommandReady,
        onErrored: handleCommandErrored,
        onAborted: handleCommandAborted,
        onGenerationEnded: handleCommandGenerationEnded
    }), isRendererOverlayOpen && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit, {
        currentContentId: currentContentId,
        hasGenerationStarted: isRendererRemixInProgress,
        onAcceptSubmit: acceptRovoRemixSubmit,
        onDisarm: onClose,
        originContentIdRef: remixOriginContentIdRef
    }), isRendererOverlayOpen && shouldShowOriginalRemixPopUpWindow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        showLabsLozenge: !(0, $iDrrr.fg)('cc_maui_ga_labs_removal'),
        onClose: ()=>onClose(),
        hiddenOptions: mergedHiddenOptions,
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        isWaitingForInput: isWaitingForInput,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        // Classic view page: center the fixed thinking bar over the rendered content area.
        // Safe here because the view page has a stable layout (unlike the editor, whose
        // reflows would make the one-shot content measurement drift).
        shouldMeasureContentBounds: true,
        // The view floating toolbar provides a live element that is remeasured as it moves.
        // Snapshot-only renderer entries, such as the nudge, still close on external scroll.
        anchorRect: positionedAnchorRect,
        popupRepositionKey: popupRepositionKey,
        shouldCloseOnScroll: !anchorElement,
        isThinking: isRendererRemixInProgress,
        // The nudge icon sits at the top-right of a block; flying the popup out to the right
        // would frequently clip against the viewport edge, so it opens to the left instead.
        popupPlacement: interactionSource === 'remixModalFromViewPageNudge' ? 'bottom-end' : 'bottom-start',
        // Match the view selection toolbar's ellipsis DropdownMenu default offset.
        popupOffset: [
            0,
            8
        ]
    }));
};
const $c9c8b9d550aa1c05$var$idleRemixContextValue = {
    openRemixModal: ()=>{},
    closeRemixModal: ()=>{},
    clearRemixHighlight: ()=>{},
    isRemixDisabled: false,
    isRemixing: false,
    isRemixInProgress: false,
    isRemixBlockingNewTargets: false,
    isAnyRemixing: false,
    remixInteractionSource: undefined,
    registerOnModalClose: ()=>()=>{}
};
const $c9c8b9d550aa1c05$var$RendererRemixContext = /*#__PURE__*/ (0, $cozmU.createContext)($c9c8b9d550aa1c05$var$idleRemixContextValue);
const $c9c8b9d550aa1c05$export$c881c5d3c5870780 = ()=>{
    return (0, $cozmU.useContext)($c9c8b9d550aa1c05$var$RendererRemixContext);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerImpl = ({ children: children, contentId: contentId })=>{
    const isRemixAvailable = (0, $eqqiF.useIsRemixAvailable)();
    // Prefetch only attachment permission. Existing space-type checks remain modal-local.
    const hiddenOptions = (0, $hxqA6.useShouldHideAttachmentRemixOptions)({
        enabled: isRemixAvailable,
        contentId: contentId
    });
    const machineLifecycle = (0, $e7504183f26ea064$export$80b3b48a0293a136)();
    const isAnyRemixing = (0, $gRoSG.useIsAnyRemixing)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [adfDocument, setAdfDocument] = (0, $cozmU.useState)(null);
    const [selectionContext, setSelectionContext] = (0, $cozmU.useState)(null);
    const [isThinking, setIsThinking] = (0, $cozmU.useState)(false);
    const [anchorRect, setAnchorRect] = (0, $cozmU.useState)(undefined);
    const [anchorElement, setAnchorElement] = (0, $cozmU.useState)(undefined);
    const [remixInteractionSource, setRemixInteractionSource] = (0, $cozmU.useState)(undefined);
    const { startHighlight: startHighlight, clearHighlight: clearHighlight } = (0, $5ae98e04c533e5e9$export$443e8aeb4c392a84)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const onModalCloseCallbacks = (0, $cozmU.useRef)(new Set());
    const registerOnModalClose = (0, $cozmU.useCallback)((callback)=>{
        onModalCloseCallbacks.current.add(callback);
        return ()=>{
            onModalCloseCallbacks.current.delete(callback);
        };
    }, []);
    const clearModalSession = (0, $cozmU.useCallback)(()=>{
        setAdfDocument(null);
        setSelectionContext(null);
        setRemixInteractionSource(undefined);
        setAnchorRect(undefined);
        setAnchorElement(undefined);
    }, []);
    const prevShowSmartCreationModal = (0, $cozmU.useRef)(showSmartCreationModal);
    (0, $cozmU.useEffect)(()=>{
        if (prevShowSmartCreationModal.current && !showSmartCreationModal) {
            clearHighlight();
            // Smart Creation owns the preview and can close outside this container's closeModal path.
            // Release the renderer session when that external modal-store transition completes.
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
            clearModalSession();
        }
        prevShowSmartCreationModal.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        clearHighlight,
        clearModalSession
    ]);
    const openModal = (0, $cozmU.useCallback)((newAdfDocument, selection, interactionSource, newAnchorRect, newAnchorElement)=>{
        if (contentId && (0, $6mKj3.expVal)('cc-ce-maui-close-object-sidebar-on-selection-remix', 'isEnabled', false)) (0, $25qMx.closeObjectSidebarRemixPicker)(contentId);
        // Record the Remix menu experiment exposure here. This is the one point that the
        // selection toolbar and the nudge both call for every cohort, and it is where the
        // cohort decides which Remix picker the person is about to see. Recording it further
        // downstream, once each cohort's own picker had appeared, undercounted the variant2
        // group, because their picker only appears after the Rovo side panel and two lazily
        // loaded chunks have all arrived.
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        // The background-phase watcher host may not have loaded yet on a fresh page, so start its
        // fetch now for the flow this modal is about to admit.
        (0, $iMLPM.preloadRemixWatcherHost)();
        setAdfDocument(newAdfDocument);
        startHighlight();
        setSelectionContext(selection);
        setRemixInteractionSource(interactionSource);
        setAnchorRect(newAnchorRect);
        setAnchorElement(newAnchorElement);
        setIsModalOpen(true);
    }, [
        contentId,
        startHighlight
    ]);
    const closeModal = (0, $cozmU.useCallback)((options)=>{
        if (!options?.preservePreviewSession) clearHighlight();
        onModalCloseCallbacks.current.forEach((cb)=>cb());
        setIsModalOpen(false);
        if (!options?.preserveThinking) setIsThinking(false);
        // Keep the phase-consuming modal subtree mounted while the Smart Creation preview is open,
        // so watcher terminal phases can drive renderer UX before teardown.
        if (!options?.preservePreviewSession && !options?.preserveCommandSession) clearModalSession();
    }, [
        clearHighlight,
        clearModalSession
    ]);
    const onStartThinking = (0, $cozmU.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $cozmU.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const rendererPhase = (0, $9dc19d5e68a65b89$export$b1a7146262519ea1)(machineLifecycle.phase);
    const isRemixInProgress = rendererPhase === 'thinking' || rendererPhase === 'ready';
    const isRemixCommitted = showSmartCreationModal || isRemixInProgress || rendererPhase === 'previewing' || rendererPhase === 'submitting';
    // Variant 2 alone keeps its local picker active while the user chooses a target. Every
    // other cohort, and every committed flow, keeps the existing single-target policy.
    const context = (0, $cozmU.useMemo)(()=>{
        const isRemixing = isModalOpen || isRemixCommitted;
        const isRemixBlockingNewTargets = isAnyRemixing || isRemixing && (isRemixCommitted || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2'));
        return {
            openRemixModal: openModal,
            closeRemixModal: closeModal,
            clearRemixHighlight: clearHighlight,
            isRemixDisabled: false,
            isRemixing: // These values describe how far along a Remix is, and they deliberately differ from
            // one another:
            //
            // - `isRemixing` becomes true as soon as any Remix flow opens, which includes the time
            //   the person spends looking at the list of Remix choices before picking one.
            // - `isRemixInProgress` is true only while content is being generated or has just
            //   finished being generated.
            // - `isRemixBlockingNewTargets` is true when another entry point must not replace the
            //   currently targeted content.
            isRemixing,
            isRemixInProgress: isRemixInProgress,
            isRemixBlockingNewTargets: isRemixBlockingNewTargets,
            isAnyRemixing: isAnyRemixing,
            remixInteractionSource: remixInteractionSource,
            registerOnModalClose: registerOnModalClose
        };
    }, [
        openModal,
        closeModal,
        clearHighlight,
        isModalOpen,
        isRemixCommitted,
        isRemixInProgress,
        isAnyRemixing,
        remixInteractionSource,
        registerOnModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $738409fb11353f61$export$533b8d7a5499bf49), null), children, isModalOpen && !isThinking && !isRemixCommitted && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses, {
        onRovoPanelClosed: closeModal
    }), adfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixModal, {
        adfDocument: adfDocument,
        hiddenOptions: hiddenOptions,
        selectionContext: selectionContext,
        interactionSource: remixInteractionSource,
        onClose: closeModal,
        onFinalizeCommandSession: clearModalSession,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        isRendererOverlayOpen: isModalOpen || isThinking,
        currentContentId: contentId,
        anchorRect: anchorRect,
        anchorElement: anchorElement,
        machineLifecycle: machineLifecycle
    })));
};
// Only mount the machine lifecycle where Remix can run. Elsewhere the shared lifecycle activity must
// not reach consumers such as the inline comment nudge, so they see the idle context instead.
const $c9c8b9d550aa1c05$var$RendererRemixAvailabilityGate = ({ children: children, contentId: contentId })=>{
    const isRemixAvailable = (0, $eqqiF.useIsRemixAvailable)();
    if (!isRemixAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: $c9c8b9d550aa1c05$var$idleRemixContextValue
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId
    }, children);
};
const $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue = (reason)=>({
        openRemixModal: ()=>{},
        closeRemixModal: ()=>{},
        clearRemixHighlight: ()=>{},
        isRemixDisabled: true,
        isRemixing: false,
        isRemixInProgress: false,
        isRemixBlockingNewTargets: false,
        isAnyRemixing: false,
        remixInteractionSource: undefined,
        remixDisabledReason: reason,
        registerOnModalClose: ()=>()=>{}
    });
const $c9c8b9d550aa1c05$var$disabledRemixContextValue = $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue();
const $c9c8b9d550aa1c05$export$62131e16a1db8364 = ({ children: children, contentId: contentId, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason })=>{
    if (isDisabled) {
        const contextValue = remixDisabledReason ? $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue(remixDisabledReason) : $c9c8b9d550aa1c05$var$disabledRemixContextValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
            value: contextValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixAvailabilityGate, {
        contentId: contentId
    }, children);
};
module.exports["useRendererRemixContext"] = $c9c8b9d550aa1c05$export$c881c5d3c5870780;
module.exports["RendererRemixContainer"] = $c9c8b9d550aa1c05$export$62131e16a1db8364;

});

parcelRegister("25qMx", function(module, exports) {
const $b329fc9fbdd4c9d0$var$listeners = new Set();
const $b329fc9fbdd4c9d0$export$454df7083738ec61 = (listener)=>{
    $b329fc9fbdd4c9d0$var$listeners.add(listener);
    return ()=>$b329fc9fbdd4c9d0$var$listeners.delete(listener);
};
const $b329fc9fbdd4c9d0$export$e271a0e97c658d3f = (contentId)=>{
    $b329fc9fbdd4c9d0$var$listeners.forEach((listener)=>listener(contentId));
};
const $b329fc9fbdd4c9d0$export$f1acfa297c9ac53d = ()=>{
    $b329fc9fbdd4c9d0$var$listeners.clear();
};
module.exports["subscribeToObjectSidebarRemixPickerClose"] = $b329fc9fbdd4c9d0$export$454df7083738ec61;
module.exports["closeObjectSidebarRemixPicker"] = $b329fc9fbdd4c9d0$export$e271a0e97c658d3f;

});

parcelRegister("eqqiF", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $HmpUb = parcelRequire("HmpUb");

const $a508accc6badaf43$export$4739f60b2e0ffe71 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    if ((0, $6mKj3.isExperimentEnabled)('cc-maui-feature-encoding-sdk-exp')) {
        if (!(0, $3ricL.isFeatureEnabled)('confluence', 'confluence-remix')) return false;
    }
    return isRovoLLMEnabled && !(0, $HmpUb.isRemixOptedOut)() && (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment');
};
module.exports["useIsRemixAvailable"] = $a508accc6badaf43$export$4739f60b2e0ffe71;

});

parcelRegister("2Awp2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $ad7Ou = parcelRequire("ad7Ou");


var $6t3CY = parcelRequire("6t3CY");


var $lslMH = parcelRequire("lslMH");


var $eDtFr = parcelRequire("eDtFr");


var $a1ZzW = parcelRequire("a1ZzW");


var $5AKbu = parcelRequire("5AKbu");


var $cE5a1 = parcelRequire("cE5a1");


var $gFEZF = parcelRequire("gFEZF");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");

/**
 * We re-export this because products may have multiple versions of
 * `@atlaskit/modal-dialog`.
 *
 * If a consumer uses the onboarding `Modal` with the `ModalTransition` from an
 * incompatible version of `@atlaskit/modal-dialog`, then the modal can get
 * stuck in an open state.
 *
 * See https://product-fabric.atlassian.net/browse/DSP-796 for more details
 * and a reproduction.
 *
 */ 
var $aRGok = parcelRequire("aRGok");

var /**
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ $96ca290bd1749542$export$2e2bcd8739ae039 = (0, $aRGok.default);



var $8lt1a = parcelRequire("8lt1a");


var $8Iwqw = parcelRequire("8Iwqw");


var $9DHhW = parcelRequire("9DHhW");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");


var $fNTq8 = parcelRequire("fNTq8");


var $lTECB = parcelRequire("lTECB");


var $3N2DH = parcelRequire("3N2DH");


var $kQqCc = parcelRequire("kQqCc");


var $i8Nmr = parcelRequire("i8Nmr");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");




const $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    lastModificationDate: null
});
$dae2c2bf6a5fe745$export$6d9b0a4fb48787a7.displayName = 'ContentBodyContext';



var $beAFO = parcelRequire("beAFO");


var $hl1Kw = parcelRequire("hl1Kw");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $kRW4Y = parcelRequire("kRW4Y");


var $jmjWc = parcelRequire("jmjWc");


var $7W8i8 = parcelRequire("7W8i8");


var $2Jxlo = parcelRequire("2Jxlo");





const $371bfa624b8f4825$export$d9088a53cb7c38b4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "W_5EK",
    name: "ReadingAidsChangeboardingModal",
    loader: async ()=>(await (parcelRequire("ghCl1"))).ReadingAidsChangeboardingModal
});






const $ade6da7539ba5902$export$1942ca99b3c33b66 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B2kdC",
    name: "ReadingAidsChangeboardingSpotlight",
    loader: async ()=>(await (parcelRequire("1pom1"))).ReadingAidsChangeboardingSpotlight
});



var $lS27Y = parcelRequire("lS27Y");


var $7rLBD = parcelRequire("7rLBD");


var $bjVRl = parcelRequire("bjVRl");


var $9oxdN = parcelRequire("9oxdN");


var $7Sm4c = parcelRequire("7Sm4c");


var $eDk57 = parcelRequire("eDk57");


var $98CLM = parcelRequire("98CLM");

parcelRequire("aiS08");
var $dVJc1 = parcelRequire("dVJc1");


var $jln20 = parcelRequire("jln20");


var $7mpOv = parcelRequire("7mpOv");


var $dnfJM = parcelRequire("dnfJM");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $cZa7r = parcelRequire("cZa7r");


var $b0EGa = parcelRequire("b0EGa");


var $aKDZB = parcelRequire("aKDZB");








var $b35Wv = parcelRequire("b35Wv");














var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $dklIa = parcelRequire("dklIa");

const $96891b810f2a7438$var$messages = (0, $kSwu1.defineMessages)({
    reactTooltip: {
        id: "experiment-inline-reactions.inline-reaction.tooltip",
        defaultMessage: "React"
    },
    reactLabel: {
        id: "experiment-inline-reactions.inline-reaction.label",
        defaultMessage: "React"
    }
});
const $96891b810f2a7438$export$9e9c4b5df2f723ad = ({ isAnnotationAllowed: isAnnotationAllowed = true, disabledTooltip: disabledTooltip })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { triggerOpen: triggerOpen } = (0, $dklIa.useInlineReactionActions)();
    const tooltipContent = !isAnnotationAllowed && disabledTooltip ? disabledTooltip : formatMessage($96891b810f2a7438$var$messages.reactTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-react",
        onClick: ()=>{
            if (pageId) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'createInlineReactionFromHighlightActionsMenu',
                    source: 'highlightActionsMenu',
                    attributes: {
                        contentId: pageId,
                        pageMode: pageMode,
                        isInlineReaction: true
                    }
                }
            }).fire();
            triggerOpen();
        },
        isDisabled: !isAnnotationAllowed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $96891b810f2a7438$var$messages.reactLabel))));
};



var $eqqiF = parcelRequire("eqqiF");

















var $1pCE4 = parcelRequire("1pCE4");
















const $62937d50f24b4234$export$6ed15331bd2f0776 = '[data-highlight-actions-remix-trigger="true"]';
const $62937d50f24b4234$var$remixTriggerWrapperStyle = null;
const $62937d50f24b4234$var$messages = (0, $kSwu1.defineMessages)({
    remixInProgressTooltip: {
        id: "highlight-actions.remix-action.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    },
    remixToolbarTooltip: {
        id: "highlight-actions.remix-action.toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarTooltipUpdated: {
        id: "highlight-actions.remix-action.toolbar-tooltip.updated",
        defaultMessage: "Create a diagram, infographic, and more from this content"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix-action.toolbar-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix-action.disabled-tooltip-archived",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix-action.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    }
});
const $62937d50f24b4234$var$getRemixDisabledTooltip = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipArchived);
    }
};
const $62937d50f24b4234$export$750386901eee7bd0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onClick: onClick, onMouseDown: onMouseDown, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelMessage = $62937d50f24b4234$var$messages.remixToolbarLabel;
    let tooltipContent;
    if (isRemixInProgress) {
        let t1;
        if ($[0] !== formatMessage) {
            t1 = formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip);
            $[0] = formatMessage;
            $[1] = t1;
        } else t1 = $[1];
        tooltipContent = t1;
    } else if (isDisabled) {
        let t1;
        if ($[2] !== formatMessage || $[3] !== remixDisabledReason) {
            t1 = $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason);
            $[2] = formatMessage;
            $[3] = remixDisabledReason;
            $[4] = t1;
        } else t1 = $[4];
        tooltipContent = t1;
    } else {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $9wGTI.fg)("cc_maui_updated_remix_tooltip_text") ? $62937d50f24b4234$var$messages.remixToolbarTooltipUpdated : $62937d50f24b4234$var$messages.remixToolbarTooltip;
            $[5] = t1;
        } else t1 = $[5];
        let t2;
        if ($[6] !== formatMessage) {
            t2 = formatMessage(t1);
            $[6] = formatMessage;
            $[7] = t2;
        } else t2 = $[7];
        tooltipContent = t2;
    }
    let t1;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            label: "",
            size: "small"
        });
        $[8] = t1;
    } else t1 = $[8];
    const t2 = isDisabled || isRemixInProgress;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), labelMessage);
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== onClick || $[11] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            iconBefore: t1,
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: t2
        }, t3));
        $[10] = onClick;
        $[11] = t2;
        $[12] = t4;
    } else t4 = $[12];
    const button = t4;
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("cc-ce-maui-remix-menu-multivariant", "cohort", "variant1")) {
        let t5;
        if ($[13] !== button || $[14] !== tooltipContent) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
                content: tooltipContent
            }, button);
            $[13] = button;
            $[14] = tooltipContent;
            $[15] = t5;
        } else t5 = $[15];
        return t5;
    }
    let t5;
    if ($[16] !== onMouseDown) {
        t5 = (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        };
        $[16] = onMouseDown;
        $[17] = t5;
    } else t5 = $[17];
    const handleMouseDownCapture = t5;
    const t6 = tooltipContent;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_3iDTPbccYA"
        ]);
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== button || $[20] !== handleMouseDownCapture) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-highlight-actions-remix-trigger": "true",
            onMouseDownCapture: handleMouseDownCapture,
            className: t7
        }, button);
        $[19] = button;
        $[20] = handleMouseDownCapture;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t8 || $[23] !== tooltipContent) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: t6
        }, t8);
        $[22] = t8;
        $[23] = tooltipContent;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ onClick: onClick, onMouseDown: onMouseDown, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelMessage = $62937d50f24b4234$var$messages.remixToolbarLabel;
    let tooltipContent;
    if (isRemixInProgress) tooltipContent = formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip);
    else if (isDisabled) tooltipContent = $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason);
    else tooltipContent = formatMessage(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('cc_maui_updated_remix_tooltip_text') ? $62937d50f24b4234$var$messages.remixToolbarTooltipUpdated : $62937d50f24b4234$var$messages.remixToolbarTooltip);
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), labelMessage)));
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, button);
     // The anchored menu opens from this trigger, so the text selection it remixes must
    // survive the click. Preventing the default mousedown keeps the selection intact;
    // the ADS button does not forward mousedown in every toolbar variant, so capture it
    // on a wrapper instead.
    const handleMouseDownCapture = (event)=>{
        event.preventDefault();
        onMouseDown?.(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-highlight-actions-remix-trigger": "true",
        onMouseDownCapture: handleMouseDownCapture,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA"
        ])
    }, button));
};



var $4DJgG = parcelRequire("4DJgG");

















var $1o3CH = parcelRequire("1o3CH");


var $dVKvM = parcelRequire("dVKvM");


var $iRFKG = parcelRequire("iRFKG");


var $f1iv3 = parcelRequire("f1iv3");


var $cFVPs = parcelRequire("cFVPs");





var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");





var $dAg4H = parcelRequire("dAg4H");


var $2ay9q = parcelRequire("2ay9q");

const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};



var $cSSgB = parcelRequire("cSSgB");


var $ai7NK = parcelRequire("ai7NK");


var $cAdj8 = parcelRequire("cAdj8");





var $04e9M = parcelRequire("04e9M");


var $aUTn5 = parcelRequire("aUTn5");

const $fc9c79783a6d919a$export$b5c53601259f278e = (container, contentId, lastModified)=>()=>{
        const selection = window.getSelection();
        if (selection) {
            // Send an event to track the user clicking the JIRA Link
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendUIEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'jiraIssueLink',
                    source: 'HighlightContextMenu'
                });
            });
            window.dispatchEvent(new CustomEvent('create-jira-issue-summary', // Convert window.getSelection() to legacy format used in jira issue summary.
            // Once we Reactified it this should be deleted.
            {
                detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
            }));
        }
    };
const $fc9c79783a6d919a$export$92ec81e7ac5e7973 = (container, contentId, lastModified)=>{
    const selection = window.getSelection();
    if (selection) {
        window.dispatchEvent(new CustomEvent('create-jira-issue-summary', {
            detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
        }));
        const observer = new MutationObserver((_mutations, observer)=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const createMultipleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-multiple-issues');
            if (createMultipleButton) {
                createMultipleButton.click();
                observer.disconnect();
            }
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const createSingleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-single-issue');
            if (createSingleButton) createSingleButton.style.display = 'none';
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};






var $3TWPv = parcelRequire("3TWPv");


var $2ViZo = parcelRequire("2ViZo");


var $6fW2K = parcelRequire("6fW2K");




const $4d90dab75b68bf7b$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $4d90dab75b68bf7b$export$233a92718b28d19e = 254;
const $4d90dab75b68bf7b$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $4d90dab75b68bf7b$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $4d90dab75b68bf7b$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $4d90dab75b68bf7b$export$2878cc467c8be8fe(selectionString, $4d90dab75b68bf7b$export$233a92718b28d19e);
    /*
   The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
   and replaces them all with a single space. (We only consider whitespace characters because
   these are the only ones that ultimately stick when parsing the summary.)
   */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $i8Nmr.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $4d90dab75b68bf7b$export$358d16442308a1f3 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    actions.setIsCreatedWithAi(false);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $4d90dab75b68bf7b$export$5378c6b60bde04bf = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, fireAiAnalytics: fireAiAnalytics, lastModified: lastModified, pressTracing: pressTracing, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    fireAiAnalytics();
    actions.setIsCreatedWithAi(true);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
    pressTracing?.();
};
const $4d90dab75b68bf7b$export$83a48a684a9c82ca = ({ actions: actions, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, rightSidebarContext: rightSidebarContext, pressTracing: pressTracing, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode })=>{
    const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
        actions: actions,
        activeSelection: activeSelection,
        contentId: contentId,
        pageMode: pageMode,
        hasEditPermission: hasEditPermission,
        container: container,
        lastModified: lastModified,
        setIsCreatedFromTable: setIsCreatedFromTable,
        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
    if (result === (0, $2ViZo.BulkSelectionResult).None) return;
    rightSidebarContext.open((0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};


const $ae4b6329110effd0$export$67bda1dbd5f0074c = {
    SINGLE_ISSUE: 'SINGLE_ISSUE',
    MULTIPLE_ISSUE: 'MULTIPLE_ISSUE',
    AI_ISSUE: 'AI_ISSUE'
};
// Helper function to find the parent <table> element of a given node
const $ae4b6329110effd0$var$findParentTable = (node)=>{
    let currentNode = node;
    while(currentNode){
        if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName === 'TABLE') return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
};
// Use this helper function when we have the modernized bulk create ready.
const $ae4b6329110effd0$var$isMultiRowTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Helper function to find the parent <tr> element of a given node
    const findParentTableRow = (node)=>{
        while(node){
            if (node.tagName === 'TR') return node;
            node = node.parentNode;
        }
        return null;
    };
    // Find the closest <tr> ancestor for both start and end of the selection
    const startRow = findParentTableRow(startContainer);
    const endRow = findParentTableRow(endContainer);
    if (!startRow || !endRow) return false;
    // If the start and end are not in the same row, it's a multi-row selection
    return startRow !== endRow;
};
/**
 * isTableSelection: returns true if the user highlights over only
 * table content.
 * @param selection
 * @returns {boolean}
 */ const $ae4b6329110effd0$var$isTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Check if both the start and end container are within a table
    const startInTable = $ae4b6329110effd0$var$findParentTable(startContainer) !== null;
    const endInTable = $ae4b6329110effd0$var$findParentTable(endContainer) !== null;
    return startInTable && endInTable;
};
const $ae4b6329110effd0$export$50d84a2be082120 = (selection)=>{
    if (!selection || selection.rangeCount === 0) return 0;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return 0;
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    const startInActionContainer = (0, $cSSgB.findActionItemElement)(startContainer);
    const endInActionContainer = (0, $cSSgB.findActionItemElement)(endContainer);
    let commonAncestor;
    if (startInActionContainer || endInActionContainer) {
        const actionItemRange = range.cloneRange();
        actionItemRange.setStart(startInActionContainer || startContainer, 0);
        actionItemRange.setEnd(endInActionContainer || endContainer, 0);
        commonAncestor = actionItemRange.commonAncestorContainer;
    } else // the selection might span across different containers
    // or be in between the start and end highlight
    commonAncestor = range.commonAncestorContainer;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const walker = document.createTreeWalker(commonAncestor, NodeFilter.SHOW_ELEMENT, null);
    let node = walker.currentNode;
    let actionItemsInSelection = 0;
    while(node){
        if (range.intersectsNode(node)) {
            const element = node;
            if (element.dataset?.taskLocalId !== undefined) actionItemsInSelection++;
        }
        node = walker.nextNode();
    }
    return actionItemsInSelection;
};
const $ae4b6329110effd0$var$getIssueCreationType = ({ isAIIssueCreationEnabled: isAIIssueCreationEnabled })=>{
    if (isAIIssueCreationEnabled) return $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE;
    else return $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE;
};
const $ae4b6329110effd0$var$userHasEditPermission = (pageInfo)=>{
    if (!pageInfo) return false;
    const contentType = pageInfo.type;
    return pageInfo.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType) || false;
};
const $ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows } = t0;
    let t1;
    if ($[0] !== completeKey || $[1] !== handleCreateIssueItemClicked || $[2] !== isAIIssueCreationEnabled || $[3] !== isSelectionMultipleRows) {
        const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
            isAIIssueCreationEnabled: isAIIssueCreationEnabled
        });
        const getIconAIFC = (iconProps)=>{
            if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                ...iconProps,
                size: "small",
                label: ""
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
                ...iconProps,
                size: "small",
                label: ""
            });
        };
        const getButtonText = ()=>{
            if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.create-multiple-jira-work-items",
                defaultMessage: "Create Jira work items"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.create-jira-work-item",
                defaultMessage: "Create Jira work item"
            });
        };
        let t2;
        if ($[5] !== getIconAIFC) {
            t2 = getIconAIFC({});
            $[5] = getIconAIFC;
            $[6] = t2;
        } else t2 = $[6];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            testId: "consolidated-create-jira-issue-button",
            "data-key": completeKey,
            shouldTitleWrap: false,
            elemBefore: t2,
            onClick: handleCreateIssueItemClicked(issueCreationType)
        }, getButtonText());
        $[0] = completeKey;
        $[1] = handleCreateIssueItemClicked;
        $[2] = isAIIssueCreationEnabled;
        $[3] = isSelectionMultipleRows;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows })=>{
    const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
        isAIIssueCreationEnabled: isAIIssueCreationEnabled
    });
    const getIconAIFC = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            ...iconProps,
            size: "small",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            ...iconProps,
            size: "small",
            label: ""
        });
    };
    const getButtonText = ()=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-multiple-jira-work-items",
            defaultMessage: "Create Jira work items"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-jira-work-item",
            defaultMessage: "Create Jira work item"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIconAIFC({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText());
};
const $ae4b6329110effd0$export$f91cf3aef874f6f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen } = t0;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1o3CH.default)("highlight-actions.ai-issue-create.dropdown-item-click");
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $ae678835b2293c93$export$58de3335a79e10d3)();
    let t1;
    if ($[0] !== activeSelection) {
        t1 = $ae4b6329110effd0$var$isTableSelection(activeSelection);
        $[0] = activeSelection;
        $[1] = t1;
    } else t1 = $[1];
    const isSelectionInTable = t1;
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable;
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable;
    let t2;
    if ($[2] !== activeSelection || $[3] !== isMultiActionItemsInSelection) {
        t2 = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
        $[2] = activeSelection;
        $[3] = isMultiActionItemsInSelection;
        $[4] = t2;
    } else t2 = $[4];
    const isSelectionMultipleRows = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fetchPolicy: "cache-first"
        };
        $[5] = t3;
    } else t3 = $[5];
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)(t3);
    let t4;
    if ($[6] !== pageInfo) {
        t4 = $ae4b6329110effd0$var$userHasEditPermission(pageInfo);
        $[6] = pageInfo;
        $[7] = t4;
    } else t4 = $[7];
    const hasEditPermission = t4;
    let t5;
    if ($[8] !== createAnalyticsEvent || $[9] !== hasEditPermission) {
        t5 = (issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluenceHighlightActionsMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "jiraIssueLink",
                    type: "ui",
                    attributes: {
                        issueCreationType: issueCreationType,
                        isDropdownItem: false,
                        isCreatedFromTable: isCreatedFromTable,
                        isCreatedFromActionItems: isCreatedFromActionItems,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }
                }
            }).fire();
        };
        $[8] = createAnalyticsEvent;
        $[9] = hasEditPermission;
        $[10] = t5;
    } else t5 = $[10];
    const fireCreateIssueButtonClickedAnalytics = t5;
    let t6;
    if ($[11] !== actions || $[12] !== activeSelection || $[13] !== container || $[14] !== contentId || $[15] !== contentType || $[16] !== fireCreateIssueButtonClickedAnalytics || $[17] !== hasEditPermission || $[18] !== isActionItemInSelection || $[19] !== isSelectionInTable || $[20] !== isSidePanelOpen || $[21] !== lastModified || $[22] !== pressTracing || $[23] !== rightSidebarContext || $[24] !== setIsCreatedFromActionItems || $[25] !== setIsCreatedFromTable || $[26] !== setIsWarningDialogOpen || $[27] !== setRecordedClick || $[28] !== trackAIInteractionInit) {
        t6 = (issueCreationType_0)=>()=>{
                if (!isSidePanelOpen) bb21: switch(issueCreationType_0){
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $4d90dab75b68bf7b$export$358d16442308a1f3)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            isActionItemInSelection: isActionItemInSelection,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        });
                        break bb21;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        !(0, $1xpoY.default).getBoolean("confluence_legacy_bulk_jira_work_create", false) ? (0, $4d90dab75b68bf7b$export$83a48a684a9c82ca)({
                            rightSidebarContext: rightSidebarContext,
                            pressTracing: pressTracing,
                            activeSelection: activeSelection,
                            actions: actions,
                            setIsCreatedFromTable: setIsCreatedFromTable,
                            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                            contentId: contentId,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        }) : (0, $fc9c79783a6d919a$export$92ec81e7ac5e7973)(container, contentId, lastModified);
                        break bb21;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $4d90dab75b68bf7b$export$5378c6b60bde04bf)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            fireAiAnalytics: trackAIInteractionInit,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW,
                            isActionItemInSelection: isActionItemInSelection
                        });
                        pressTracing();
                }
                else {
                    const aiData = {
                        contentType: contentType,
                        fireAiAnalytics: trackAIInteractionInit
                    };
                    const tempData = {
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                    };
                    setRecordedClick(tempData);
                    setIsWarningDialogOpen(true);
                }
            };
        $[11] = actions;
        $[12] = activeSelection;
        $[13] = container;
        $[14] = contentId;
        $[15] = contentType;
        $[16] = fireCreateIssueButtonClickedAnalytics;
        $[17] = hasEditPermission;
        $[18] = isActionItemInSelection;
        $[19] = isSelectionInTable;
        $[20] = isSidePanelOpen;
        $[21] = lastModified;
        $[22] = pressTracing;
        $[23] = rightSidebarContext;
        $[24] = setIsCreatedFromActionItems;
        $[25] = setIsCreatedFromTable;
        $[26] = setIsWarningDialogOpen;
        $[27] = setRecordedClick;
        $[28] = trackAIInteractionInit;
        $[29] = t6;
    } else t6 = $[29];
    const handleCreateIssueItemClicked = t6;
    let t7;
    if ($[30] !== completeKey || $[31] !== handleCreateIssueItemClicked || $[32] !== isAIIssueCreationEnabled || $[33] !== isSelectionMultipleRows) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
            completeKey: completeKey,
            handleCreateIssueItemClicked: handleCreateIssueItemClicked,
            isAIIssueCreationEnabled: isAIIssueCreationEnabled,
            isSelectionMultipleRows: isSelectionMultipleRows
        });
        $[30] = completeKey;
        $[31] = handleCreateIssueItemClicked;
        $[32] = isAIIssueCreationEnabled;
        $[33] = isSelectionMultipleRows;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : ({ activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen })=>{
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1o3CH.default)('highlight-actions.ai-issue-create.dropdown-item-click');
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $ae678835b2293c93$export$58de3335a79e10d3)();
    const isSelectionInTable = $ae4b6329110effd0$var$isTableSelection(activeSelection);
    // table creation has higher priority than action item creation
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable;
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable;
    const isSelectionMultipleRows = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>$ae4b6329110effd0$var$userHasEditPermission(pageInfo), [
        pageInfo
    ]);
    const fireCreateIssueButtonClickedAnalytics = (0, $cozmU.useCallback)((issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: issueCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    hasEditPermission: hasEditPermission,
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasEditPermission
    ]);
    const handleCreateIssueItemClicked = (0, $cozmU.useCallback)((issueCreationType_0)=>()=>{
            if (!isSidePanelOpen) switch(issueCreationType_0){
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $4d90dab75b68bf7b$export$358d16442308a1f3)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        isActionItemInSelection: isActionItemInSelection,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    });
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    !(0, $1xpoY.default).getBoolean('confluence_legacy_bulk_jira_work_create', false) ? (0, $4d90dab75b68bf7b$export$83a48a684a9c82ca)({
                        rightSidebarContext: rightSidebarContext,
                        pressTracing: pressTracing,
                        activeSelection: activeSelection,
                        actions: actions,
                        setIsCreatedFromTable: setIsCreatedFromTable,
                        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }) : (0, $fc9c79783a6d919a$export$92ec81e7ac5e7973)(container, contentId, lastModified);
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $4d90dab75b68bf7b$export$5378c6b60bde04bf)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        fireAiAnalytics: trackAIInteractionInit,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW,
                        isActionItemInSelection: isActionItemInSelection
                    });
                    pressTracing();
                    break;
            }
            else {
                // ai specific data
                const aiData = {
                    contentType: contentType,
                    fireAiAnalytics: trackAIInteractionInit
                };
                // record temp data
                const tempData = {
                    rightSidebarContext: rightSidebarContext,
                    actions: actions,
                    activeSelection: activeSelection,
                    contentId: contentId,
                    container: container,
                    lastModified: lastModified,
                    hasEditPermission: hasEditPermission,
                    ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                };
                setRecordedClick(tempData);
                setIsWarningDialogOpen(true);
            }
        }, [
        isSidePanelOpen,
        fireCreateIssueButtonClickedAnalytics,
        isSelectionInTable,
        rightSidebarContext,
        actions,
        activeSelection,
        contentId,
        contentType,
        container,
        lastModified,
        pressTracing,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        trackAIInteractionInit,
        setRecordedClick,
        setIsWarningDialogOpen,
        hasEditPermission,
        isActionItemInSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
        completeKey: completeKey,
        handleCreateIssueItemClicked: handleCreateIssueItemClicked,
        isAIIssueCreationEnabled: isAIIssueCreationEnabled,
        isSelectionMultipleRows: isSelectionMultipleRows
    });
};





















var $7aRa9 = parcelRequire("7aRa9");


var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");


var $9ujb2 = parcelRequire("9ujb2");

const $ed7cf63fc877d47c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $ed7cf63fc877d47c$var$getHighlightedText = (selection)=>{
    if (!selection || selection.rangeCount === 0) return '';
    return selection.toString().trim();
};
const $ed7cf63fc877d47c$var$i18n = (0, $kSwu1.defineMessages)({
    trelloLabel: {
        id: "highlight-actions.create-trello-card",
        defaultMessage: "Send to your Trello Inbox"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});
const $ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent = ({ activeSelection: activeSelection, completeKey: completeKey, contentId: contentId, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: trelloAccessLoading } = (0, $9ujb2.useTrelloAccess)();
    const fireTrelloCardCreatedAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'trelloInboxCard',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    hasSelection: Boolean(activeSelection && activeSelection.toString().trim())
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        activeSelection
    ]);
    const showCreateErrorFlag = (0, $cozmU.useCallback)(()=>{
        flags.showFlag({
            id: 'trello-inbox-create-error',
            type: 'error',
            title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.errorTitle),
            close: 'auto'
        });
    }, [
        flags,
        intl
    ]);
    const makeHandleCreateTrelloCardClick = (0, $cozmU.useCallback)(async ()=>{
        const highlightedText = $ed7cf63fc877d47c$var$getHighlightedText(activeSelection);
        if (!highlightedText) return;
        try {
            fireTrelloCardCreatedAnalytics();
            const result = await (0, $lpGuF.createTrelloCardHandle)({
                text: highlightedText,
                contentId: contentId
            });
            if (result && result.success) {
                const actions = result.cardUrl ? [
                    {
                        content: intl.formatMessage($ed7cf63fc877d47c$var$i18n.openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ] : undefined;
                flags.showFlag({
                    id: 'trello-inbox-create-success',
                    type: 'success-circle',
                    title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.successTitle),
                    actions: actions,
                    close: 'auto'
                });
            } else showCreateErrorFlag();
        } catch  {
            $ed7cf63fc877d47c$var$logger.error`Error creating Trello card for contentId=${contentId}`;
            showCreateErrorFlag();
        }
    }, [
        activeSelection,
        contentId,
        fireTrelloCardCreatedAnalytics,
        flags,
        showCreateErrorFlag,
        intl
    ]);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('quick_capture_trello_inbox')) return null;
    if (trelloAccessLoading) return null;
    if (!hasTrelloAccess) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "create-trello-card-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
};
const $ed7cf63fc877d47c$export$12f6e4d1b0812953 = (0, $7aRa9.withFlags)($ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent);






var $lEDve = parcelRequire("lEDve");


var $bEdUx = parcelRequire("bEdUx");





const $79f107ddc4d1b489$var$defaultState = {
    firstHighlightShown: false
};
const $79f107ddc4d1b489$export$ca9047e33beaf8b2 = (0, $cozmU.createContext)($79f107ddc4d1b489$var$defaultState);
$79f107ddc4d1b489$export$ca9047e33beaf8b2.displayName = 'HighlightActionsContext';



var $2zMIV = parcelRequire("2zMIV");

/* OtherActions.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag */ 









var $6TaGl = parcelRequire("6TaGl");


var $cJ0FD = parcelRequire("cJ0FD");








var $jgJIe = parcelRequire("jgJIe");





var $a6nzD = parcelRequire("a6nzD");


var $6Ec6w = parcelRequire("6Ec6w");








var $4vC63 = parcelRequire("4vC63");


var $9fBoq = parcelRequire("9fBoq");


var $4GDP8 = parcelRequire("4GDP8");







const $f5df649ae1312176$var$i18n = (0, $kSwu1.defineMessages)({
    selectApp: {
        id: "highlight-actions.select.app",
        defaultMessage: "Select app"
    },
    apps: {
        id: "highlight-actions.dropdown-group.apps",
        defaultMessage: "Apps"
    }
});
const $f5df649ae1312176$var$iconImageStyle = null;
const $f5df649ae1312176$export$c01fdef1354c759b = ({ builtInActions: builtInActions = [], connectItems: connectItems, forgeItems: forgeItems = [], selectForgeExtension: selectForgeExtension = ()=>{} })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireOverflowMenuAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                name: 'button clicked - highlightActionsMenuOverflow',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuOverflow',
                source: 'highlightActionsMenu',
                type: 'ui',
                attributes: {
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const connectComponents = (0, $cozmU.useMemo)(()=>connectItems.map((item)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $dVKvM.ToolbarDropdownItem), {
                key: item.completeKey,
                "data-vc": "link-item",
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    src: item.icon.path,
                    alt: (0, $6mKj3.expValEquals)('confluence_renderer_toolbar_remove_duplicate_label', 'isEnabled', true) ? item.label : '',
                    className: (0, $hekY6.default)([
                        "_0jFU0VoWWg _39xV02oWWg"
                    ])
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    size: "small",
                    label: ""
                })
            }, item.label);
        }), [
        connectItems
    ]);
    const forgeComponents = (0, $cozmU.useMemo)(()=>forgeItems.map((item)=>{
            const appTitle = (0, $9fBoq.extensionTitle)(item);
            return /*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $cozmU.createElement((0, $dVKvM.ToolbarDropdownItem), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    size: "small",
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle));
        }), [
        forgeItems,
        selectForgeExtension,
        experienceTracker
    ]);
    const forgeKeyboardShortcuts = (0, $cozmU.useMemo)(()=>forgeItems.map((module)=>/*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcut), {
                key: module.id,
                module: module,
                action: ()=>{
                    (0, $4GDP8.openContextMenuClick)();
                    (0, $4GDP8.simulateItemClick)(module.id);
                    (0, $4GDP8.simulateItemMouseOver)(module.id);
                }
            })), [
        forgeItems
    ]);
    const dropDownComponents = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $jgJIe.ToolbarDropdownItemSection), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $cozmU.createElement((0, $jgJIe.ToolbarDropdownItemSection), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)), [
        builtInActions,
        connectItems.length,
        forgeItems.length,
        intl,
        connectComponents,
        forgeComponents
    ]);
    if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
            size: "small"
        }),
        id: "context-menu-other-apps",
        testId: "context-menu-other-apps",
        onClick: fireOverflowMenuAnalytics,
        tooltipComponent: /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
            content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
        })
    }, dropDownComponents, forgeKeyboardShortcuts);
};



var $dj3mI = parcelRequire("dj3mI");


var $6zmDz = parcelRequire("6zmDz");


const $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD = 100;
const $9755f908a54a6c5b$var$BUILT_IN_ITEMS = [
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary',
    'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
];
const $9755f908a54a6c5b$export$9205c47465d0942 = [
    'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary'
];
const $9755f908a54a6c5b$var$i18n = (0, $kSwu1.defineMessages)({
    commentTooltip: {
        id: "highlight-actions.inline.comment.tooltip",
        defaultMessage: "Comment"
    },
    defineTooltip: {
        id: "highlight-actions.define.tooltip",
        defaultMessage: "Define"
    }
});
const $9755f908a54a6c5b$var$logger = (0, $7W8i8.getLogger)('inline-comment');

const $9755f908a54a6c5b$var$ForgeAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wTC7w",
    name: "ForgeAction",
    loader: async ()=>(await (parcelRequire("3QARf"))).ForgeAction
});

const $9755f908a54a6c5b$var$DefinitionAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wKsW8",
    name: "DefinitionAction",
    loader: async ()=>(await (parcelRequire("5UUHQ"))).DefinitionAction
});
function $9755f908a54a6c5b$var$trapFocusInSelectionToolbar(event) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const highlightActionsToolbar = document.querySelector('#highlightActionsPopup');
    if (highlightActionsToolbar && event.key === 'Tab' && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
        event.stopPropagation(); // Get all focusable elements in the toolbar
        const elements = Array.from(highlightActionsToolbar.querySelectorAll('button, a')).filter((curr)=>{
            if (curr instanceof HTMLButtonElement) return !curr.disabled;
            if (curr instanceof HTMLAnchorElement) return !!curr.href;
            return false;
        }); // Find the index of the currently focused element
        let idx = event.shiftKey ? elements.length : -1; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedElement = document.activeElement;
        if (highlightActionsToolbar.contains(focusedElement)) {
            for(let i = 0; i < elements.length; i++)if (elements[i] === focusedElement) {
                idx = i;
                break;
            }
        } // Focus the next element to focus
        event.shiftKey ? idx-- : idx++;
        if (idx < 0) idx = elements.length - 1;
        else if (idx >= elements.length) idx = 0;
        const next = elements[idx];
        if (next && (next instanceof HTMLButtonElement || next instanceof HTMLAnchorElement)) next.focus();
    }
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $1B9Aq.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEvwv6 _2mHwu82ADO _2uo31fgozt _0bjKvDzXzM _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _1mT5xdRAKS _1UtDYze5R3 _1kk5Tku7m9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $1B9Aq.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEvwv6 _2mHwu82ADO _2uo31fgozt _0bjKvDzXzM _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _1mT5xdRAKS _1UtDYze5R3 _1kk5Tku7m9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $1B9Aq.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEvwv6 _2mHwu82ADO _2uo31fgozt _0bjKvDKxmn _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _1mT5xdRAKS _1UtDYze5R3 _1kk5Tku7m9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $1B9Aq.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEvwv6 _2mHwu82ADO _2uo31fgozt _0bjKvDKxmn _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _1mT5xdRAKS _1UtDYze5R3 _1kk5Tku7m9",
            __cmplp.className
        ])
    });
});
const $9755f908a54a6c5b$var$getIsHighlightValid = ({ content: content, isFabric: isFabric, isAnnotationAllowed: isAnnotationAllowed, contentId: contentId })=>{
    if (!content) return false;
    if (isFabric) return Boolean(isAnnotationAllowed);
    return (0, $2zMIV.isHighlightValidForInlineComment)(content, contentId);
};
const $9755f908a54a6c5b$export$a6299569dd2a354f = ({ contentId: contentId, children: children, actions: actions, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, onRemixButtonPress: onRemixButtonPress, onRemixButtonMouseDown: onRemixButtonMouseDown, remixDisabledReason: remixDisabledReason, isSelectionUnremixable: isSelectionUnremixable = false, isFabric: isFabric, contentType: contentType, inlineNodeTypes: inlineNodeTypes, onCommentButtonMount: onCommentButtonMount, snippetSlots: snippetSlots, preloadedCanAddComments: preloadedCanAddComments })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isRemixAvailable = (0, $eqqiF.useIsRemixAvailable)();
    const [actionStates, setActionStates] = (0, $cozmU.useState)({
        firstHighlightShown: false,
        show: false,
        top: 0,
        left: 0,
        forgeExtension: null,
        activeSelection: null,
        selectionRect: null,
        isReadingAidsOpen: false,
        readingAidsChangeboardingStep: 'disabled'
    });
    const [position, setPosition] = (0, $cozmU.useState)(null);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach, isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const { setReattachHighlight: setReattachHighlight } = (0, $brNvA.useReattachCommentDispatch)();
    const { lastModificationDate: lastModificationDate } = (0, $cozmU.useContext)((0, $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId, false, preloadedCanAddComments);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
    });
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [isWarningDialogOpen, setIsWarningDialogOpen] = (0, $cozmU.useState)(false);
    const [recordedClick, setRecordedClick] = (0, $cozmU.useState)();
    const shouldDisableCommentWhenDocumentNeedsUpdate = inlineNodeTypes?.length === 1 && [
        'status',
        'date',
        'mention',
        'inlineCard'
    ].includes(inlineNodeTypes[0]);
    const needsUpdateToComment = shouldDisableCommentWhenDocumentNeedsUpdate && (Boolean(documentNeedsUpdate) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)); // Flag to trigger text comment creation after media comment cleanup
    const [pendingTextComment, setPendingTextComment] = (0, $cozmU.useState)(false);
    const { setDefineDefinitionOpen: setDefineDefinitionOpen } = (0, $bjVRl.useReadingAidsActions)();
    const { hoverProps: hoverProps } = (0, $cZa7r.useAnnotations)();
    const { setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { isRemixing: isRemixingFromContext, isRemixInProgress: isRemixInProgress, isRemixBlockingNewTargets: isRemixBlockingNewTargets, isAnyRemixing: isAnyRemixing } = (0, $aKDZB.useRendererRemixContext)();
    const isRemixing = isRemixingFromContext; // Variant 1 retains its local picker control, but no local exception can replace a target
    // while another treatment surface owns an admitted Remix flow.
    const shouldDisableRemix = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant1') ? isRemixInProgress || isAnyRemixing : isRemixBlockingNewTargets;
    const { firstHighlightShown: firstHighlightShown, show: show, top: top, left: left, forgeExtension: forgeExtension, activeSelection: activeSelection, selectionRect: selectionRect, isReadingAidsOpen: isReadingAidsOpen, readingAidsChangeboardingStep: readingAidsChangeboardingStep } = actionStates;
    const mountedRef = (0, $cozmU.useRef)(false);
    const screenEventFiredRef = (0, $cozmU.useRef)(false);
    const highlightActionsShownRef = (0, $cozmU.useRef)(false);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const [showReadingAidsChangeboarding, stopReadingAidsChangeboarding] = (0, $9oxdN.useFeatureDiscovery)('highlight-actions.reading-aids.changeboarding');
    const isReadingAidsChangeboardingActive = readingAidsChangeboardingStep.match(/^modal|spotlight/); // Sync popup visibility to OmniBar's visibility store (counter-based)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    const shouldHideOmniBar = show || isReadingAidsOpen || !!forgeExtension;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (shouldHideOmniBar) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        shouldHideOmniBar,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const highlightActionsContextValue = (0, $cozmU.useMemo)(()=>({
            firstHighlightShown: firstHighlightShown
        }), [
        firstHighlightShown
    ]); // start the reading aids changeboarding
    (0, $cozmU.useEffect)(()=>{
        setActionStates((prevState)=>({
                ...prevState,
                readingAidsChangeboardingStep: showReadingAidsChangeboarding && isAIEnabledForContent ? 'idle' : 'disabled'
            }));
    }, [
        showReadingAidsChangeboarding,
        isAIEnabledForContent
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Manually trigger resize to ensure spotlight is properly aligned
        window.setTimeout(()=>window.dispatchEvent(new Event('resize')), 0);
        if (!show) {
            // Force a redraw of portalContainer, which fixes an issue where the popup is removed from DOM but is
            // still visible on the page __in Safari__. (https://product-fabric.atlassian.net/browse/COMMENTS-5335)
            // This rendering issue occurring in Safari's WebKit engine seems to be known and has a long history.
            // Only do this when `show === false`, since the issue only occurs when attepmting to hide the popup.
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
            if (portalContainer) {
                portalContainer.style.transform = 'translateZ(0)'; // This line below reads this layout property, which triggers a reflow + redraw as side effect.
                portalContainer.offsetHeight; // NOSONAR - Sonar would complain: "Expected an assignment or function call and instead saw an expression"
                portalContainer.style.transform = '';
            }
        }
    }, [
        show
    ]); // freeze the user's selection while reading aids changeboarding is active
    (0, $cozmU.useEffect)(()=>{
        const akPortalContainer = document.querySelector('.atlaskit-portal-container');
        if (akPortalContainer) {
            if (isReadingAidsChangeboardingActive) {
                akPortalContainer.style.userSelect = 'none';
                return ()=>{
                    akPortalContainer.style.userSelect = 'auto';
                };
            } else akPortalContainer.style.userSelect = 'auto';
        }
    }, [
        isReadingAidsChangeboardingActive
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        document.addEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
        return ()=>{
            document.removeEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('highlight-actions.container.resized', onContainerResized);
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('highlight-actions.container.resized', onContainerResized);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentToReattach,
        isReadingAidsChangeboardingActive,
        isRemixing
    ]); /* When nudgebar improvement is on: hide toolbar when selection was set by comment nudge (e.g. on hover). */ 
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
        const onSelectionChange = ()=>{
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && mountedRef.current) setActionStates((prev)=>({
                    ...prev,
                    show: false
                }));
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>document.removeEventListener('selectionchange', onSelectionChange);
    }, []); // Close reading aids popup when navigating to another page
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        };
    }, [
        contentId,
        setDefineDefinitionOpen
    ]); // Handle text comment creation after media comment cleanup is complete
    (0, $cozmU.useEffect)(()=>{
        if (pendingTextComment && !hoverProps) {
            setPendingTextComment(false);
            if (isFabric) onCommentButtonPress?.();
            else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach,
                actions: actions
            }));
        }
    }, [
        pendingTextComment,
        hoverProps,
        isFabric,
        onCommentButtonPress,
        createComment,
        content,
        contentId,
        commentToReattach,
        actions
    ]);
    const onContainerResized = ()=>{
        setActionStates((prevState)=>({
                ...prevState,
                show: false,
                forgeExtension: null
            }));
    };
    function getScrollParent(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
        else return getScrollParent(node.parentNode);
    }
    function getParentNode(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE) return node;
        else return getParentNode(node.parentNode);
    }
    const getPosition = (range)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
        const portalRect = portalContainer?.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        const { left: leftRect, top: topRect, width: width, height: height } = range.getBoundingClientRect(); // Popup can't be rendered outside the body area
        const contentRect = getParentNode(range.commonAncestorContainer).getBoundingClientRect();
        let leftLimit = contentRect.left;
        let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
        // The popup is limited to be shown within the scrollable area.
        const firstParentThatCanScroll = getScrollParent(range.startContainer);
        if (firstParentThatCanScroll) {
            const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
            leftLimit = Math.max(leftLimit, scrollParentRect.left);
            rightLimit = Math.min(rightLimit, scrollParentRect.right);
        }
        let x = width / 2 + leftRect; // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
        return {
            pos: {
                left: x - portalRect.left,
                top: topRect - portalRect.top
            },
            selectionRect: {
                left: x - portalRect.left,
                top: topRect - portalRect.top,
                width: width,
                height: height
            }
        };
    };
    (0, $cozmU.useEffect)(()=>{
        if (range) {
            /* When nudgebar improvement is on, never show toolbar for selection set by nudge (range can come from parent when we set selection on comment hover). */ if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) {
                setPosition(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const { pos: pos, selectionRect: selectionRectangle } = getPosition(range);
            highlightActionsShownRef.current = false;
            setPosition(pos);
            setActionStates((prevState)=>({
                    ...prevState,
                    selectionRect: selectionRectangle,
                    show: true
                }));
        } else {
            setPosition(null);
            setActionStates((prevState)=>({
                    ...prevState,
                    show: false
                }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const updatePosition = (0, $cozmU.useCallback)(()=>{
        if (range) {
            const { pos: pos } = getPosition(range);
            setPosition(pos);
            return pos;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const prepareAndSetHighlightForReattachMode = ()=>{
        const convertedSelectionObj = (0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }); // Only set the highlight if it's valid
        if (convertedSelectionObj.numMatches > 0 && convertedSelectionObj.matchIndex !== -1) setReattachHighlight(convertedSelectionObj);
    };
    const isDatasourceHighlighted = (range)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const datasourceContainers = document.querySelectorAll('.datasource-table');
        return Array.from(datasourceContainers).some((container)=>container.contains(range.startContainer) || container.contains(range.endContainer));
    };
    const onMouseUp = (e)=>{
        return requestAnimationFrame(()=>{
            if (!mountedRef.current) return;
             // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if ((0, $9wGTI.fg)('quick_capture_trello_inbox')) (0, $9ujb2.prefetchTrelloAccess)();
            const range = (0, $2zMIV.getRange)(); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`); // WS-1576/WS-2355 - Ignore any highlights in the Inline Comments sidebar
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const inlineCommentSidebarContainer = document.querySelector('#inline-comment-sidebar'); // InlineCommentNudge handles its own content selection and opening of the Comment Editor.
            // Check both event target and element under cursor so we don't show toolbar when pointer is over nudge (e.g. portal/overlay edge cases).
            const elementUnderCursor = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            typeof document.elementFromPoint === 'function' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.elementFromPoint(e.clientX, e.clientY) : null;
            const isOverCommentNudge = e.target && e.target.closest?.('#inline-comment-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-comment-nudge');
            const isOverRemixNudge = e.target && e.target.closest?.('#inline-remix-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-remix-nudge');
            if (isOverCommentNudge) return;
            if (isOverRemixNudge) return;
             // When nudgebar improvement is on, only show toolbar when user selected text (not when selection was set by nudge hover).
            if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
             // freeze the actions popup if reading aids changeboarding is active
            if (isReadingAidsChangeboardingActive) return;
             // freeze the actions popup if the input is clicked in the rovo chat more options popup
            if (e.target.closest('#context-menu-rovo-chat-custom-prompt')) return;
            const isCommentButtonDisabledAndClicked = e.target.closest('button[disabled]');
            const isContextMenuOtherAppsButtonClicked = e.target.closest('#context-menu-other-apps');
            const isCreateJiraIssueButtonClicked = e.target.closest('#create-jira-issue-trigger');
            const isRovoChatMoreOptionsButtonClicked = e.target.closest('#context-menu-rovo-chat-more-options');
            const isNotesButtonClicked = e.target.closest('#highlight-actions-notes-button'); // The anchored menu opens in place, so clicking its trigger must not dismiss the
            // toolbar the menu is anchored to. Clicking it can also collapse the browser
            // selection before getRange() is read, which would hit the generic `!range`
            // dismissal path below.
            if (e.target.closest((0, $62937d50f24b4234$export$6ed15331bd2f0776)) && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant1')) return;
            const shouldHideContextMenu = !(isCommentButtonDisabledAndClicked || isContextMenuOtherAppsButtonClicked || isCreateJiraIssueButtonClicked || isRovoChatMoreOptionsButtonClicked || isNotesButtonClicked);
            if (!range || !portalContainer || !content.current || inlineCommentSidebarContainer?.contains(range.startContainer) || inlineCommentSidebarContainer?.contains(range.endContainer) || isDatasourceHighlighted(range) || !content.current.contains(e.target) && content.current !== e.target && shouldHideContextMenu) {
                if (isInReattachMode()) setReattachHighlight(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // COMMENTS-332 - In reattach mode, skip the measuring of the screen, just set the mode with the highlight
            if (isInReattachMode()) {
                prepareAndSetHighlightForReattachMode();
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const portalRect = portalContainer.getBoundingClientRect();
            const contentRect = content.current.getBoundingClientRect();
            const rects = range.getClientRects();
            if (!rects || !rects.length) {
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // Find first selection area that width is not 0
            // Sometimes there is a chance that user is selecting an empty DOM node.
            const rect = Array.from(rects).find((rect)=>rect.width !== 0 && rect.height !== 0);
            if (rect) {
                const { left: left, right: right, top: top, width: width, height: height } = rect;
                const mouseUpX = e.clientX; // This is a LEGACY disable statement after rule addition. Use `Math.floor(width/2)` next time
                // eslint-disable-next-line no-bitwise
                const selectedLineCenter = left + (width >> 1); // Popup can't be rendered outside the body area
                let leftLimit = contentRect.left;
                let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
                // The popup is limited to be shown within the scrollable area.
                const firstParentThatCanScroll = getScrollParent(range.startContainer);
                if (firstParentThatCanScroll) {
                    const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
                    leftLimit = Math.max(leftLimit, scrollParentRect.left);
                    rightLimit = Math.min(rightLimit, scrollParentRect.right);
                } // Use the X-axis position if the center of selected line is POPUP_MOUSEUP_DISTANCE_THRESHOLD away from mouse up position.
                // POPUP_MOUSEUP_DISTANCE_THRESHOLD is an arbitrary number I made up.
                // The idea is the popup will always show up within POPUP_MOUSEUP_DISTANCE_THRESHOLD of the end of the selection.
                // Right near what user selects. However when the selection is too short - like a phase,
                // it will show up at the middle of the selection because it looks better.
                let x = Math.abs(mouseUpX - selectedLineCenter) > $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD && left <= mouseUpX && mouseUpX <= right ? mouseUpX : selectedLineCenter; // However it is still bounded by the left and right boundary of the first line.
                // This is because the mouse up can be off screen.
                // For example: Make selection, then drag on a scroll bar.
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
                if (!isFabric) highlightActionsShownRef.current = false;
                setActionStates((prevState)=>({
                        ...prevState,
                        firstHighlightShown: true,
                        // COMMENTS-332 - Don't show the popup when a selection is made in reattach mode
                        show: !isInReattachMode(),
                        left: x - portalRect.left,
                        top: top - portalRect.top,
                        selectionRect: {
                            left: x - portalRect.left,
                            top: top - portalRect.top,
                            width: width,
                            height: height
                        }
                    }));
            }
        });
    };
    const createReactInlineCommentHighlight = ()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
         // Close any existing media create comment when opening a text comment
        if ((0, $6mKj3.expValEquals)('confluence_comment_unmount_onmedia_selection', 'isEnabled', true)) {
            if (hoverProps) {
                // Remove draft annotation from media element if it exists
                hoverProps.removeDraftMode?.(); // Close the hover component (calls renderer's onClose)
                hoverProps.onClose?.(); // Clear hoverProps from context
                setHoverProps(null); // Flag to trigger text comment creation after hoverProps is cleared
                setPendingTextComment(true);
                return;
            }
        } // Proceed with text comment creation immediately if no media comment to clean up
        if (isFabric) onCommentButtonPress?.();
        else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }));
    };
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight()
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'inlineCommentFromInlineToolbar',
                action: 'clicked',
                actionSubject: 'button',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const extractNodeDetailsToString = (node)=>{
        if (!node) return '';
        while(node?.nodeType === Node.TEXT_NODE || node.tagName === 'MARK')node = node?.parentNode;
        if (node) {
            const elem = node;
            const classListStr = Array.from(elem.classList).join(',');
            let attrListStr = '';
            Object.entries(elem.dataset).forEach((attrEntry, idx)=>{
                if (idx > 0) attrListStr += ',';
                 // COMMENTS-1916 - Remove any emails that are in any values for attributes
                if (attrEntry.length > 1) {
                    const field = attrEntry[0];
                    if (field && field.includes('testMediaName')) attrEntry[1] = '';
                }
                attrListStr += attrEntry.join('=');
            }); // Get the tag name and stringify the class list and attribute list
            return `${elem.tagName}${classListStr.length ? `.${classListStr}` : ''}${attrListStr.length ? `[${attrListStr}]` : ''}`;
        }
        return '';
    };
    const CreateInlineCommentButton = ()=>{
        (0, $cozmU.useEffect)(()=>{
            onCommentButtonMount && onCommentButtonMount();
        }, []);
        if (!content.current) return null;
        const isHighlightValid = $9755f908a54a6c5b$var$getIsHighlightValid({
            content: content.current,
            isFabric: isFabric,
            isAnnotationAllowed: isAnnotationAllowed,
            contentId: contentId
        }); // Cases where we want to disable the create button:
        // 1. The content is archived.
        // 2. The user does not have the "Comment - Add" permission.
        // 3. The highlight was invalid (over elements we don't support commenting on).
        // 4. The document needs to be updated (i.e. is outdated) AND selected node is one of [status, date, mention, inlineCard].
        // This order matters when communicating to users, as checking "Comment - Add" permission for archived pages
        // will return false.
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid; // Check if the comment is on a selection that includes an non-text inline node
        const isNonTextInlineNodeIncludedInComment = (inlineNodeTypes ?? []).filter((nodeType)=>nodeType !== 'text').length > 0; // Track the nodes in which the highlight was made on to send in the event
        if (!highlightActionsShownRef.current) {
            highlightActionsShownRef.current = true;
            try {
                const selection = window.getSelection();
                const startingNode = extractNodeDetailsToString(selection?.anchorNode);
                const endingNode = extractNodeDetailsToString(selection?.focusNode); // Track when the menu is shown to users and if it's disabled
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'shown',
                        actionSubject: 'toolbar',
                        actionSubjectId: 'highlightActionsMenu',
                        attributes: {
                            isDisabled: !isCreateButtonEnabled,
                            pageMode: 'view',
                            startingNode: startingNode,
                            endingNode: endingNode,
                            inlineNodeTypes: inlineNodeTypes,
                            isNonTextInlineNodeIncludedInComment: /**
               * This attribute is used as the trigger to display an engagement platform promotion message
               * when isNonTextInlineNodeIncludedInComment is true, and isDisabled is false,
               * A spotlight/flag will be shown to the user to encourage them to comment on inline nodes.
               */ isNonTextInlineNodeIncludedInComment
                        }
                    }
                }).fire();
            } catch (e) {
                $9755f908a54a6c5b$var$logger.error`Unable to send highlight actions event; ${e}`;
            }
        }
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>{
            const commonCreateButtonProps = {
                'data-key': 'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
                // Needed for integration tests
                isDisabled: !isCreateButtonEnabled,
                testId: 'createInlineCommentButton',
                interactionName: 'start-inline-comment-action',
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                },
                id: 'create-inline-comment-button'
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
                ...commonCreateButtonProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        }); // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        //           and ADG doesn't allow tooltips on disabled buttons for accessibility reasons...
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            delay: 0,
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const createJiraIssueButton = (completeKey)=>{
        if (!content.current || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        if (!(0, $1xpoY.default).getBoolean('confluence_legacy_single_jira_work_create', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
            config: {
                // Required configuration
                product: 'confluence',
                subproduct: 'jira',
                aiFeatureName: 'confluenceAiWorkCreation',
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                // Optional configuration
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae4b6329110effd0$export$f91cf3aef874f6f), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            container: content.current,
            contentId: contentId,
            contentType: contentType,
            lastModified: lastModifiedDate || lastModificationDate,
            showCreateMultipleIssuesButton: (0, $2zMIV.isHighlightValidForBulkCreateJiraIssues)(),
            setRecordedClick: setRecordedClick,
            setIsWarningDialogOpen: setIsWarningDialogOpen
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                }),
            "data-key": completeKey,
            testId: "createJiraIssueButton",
            onClick: (0, $fc9c79783a6d919a$export$b5c53601259f278e)(content.current, contentId, lastModifiedDate || lastModificationDate)
        }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-issue-issue-term-refresh",
            defaultMessage: "Create work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-issue",
            defaultMessage: "Create issue"
        }));
    };
    const createTrelloInboxButton = (completeKey)=>{
        if (!content.current || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed7cf63fc877d47c$export$12f6e4d1b0812953), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            contentId: contentId
        });
    };
    const createReadingAidsDefineButton = ({ selectedRange: selectedRange, selectedText: selectedText, isOverWordLimit: isOverWordLimit })=>{
        if (!content.current) return null;
        const isDisabled = isOverWordLimit && readingAidsChangeboardingStep === 'disabled' || // only check word limit when changeboarding is disabled
        readingAidsChangeboardingStep === 'spotlight'; // always disable when spotlight is active
        const commonDefineButtonProps = {
            testId: 'defineButton',
            isDisabled: isDisabled,
            onClick: ()=>{
                if (!selectedRange) return;
                if (!selectedText) return;
                if (isAIEnabledForContent || isRovoEnabledForContent) experienceTracker.start({
                    name: (0, $irVI7.READING_AIDS_EXPERIENCE),
                    attributes: {
                        contentId: contentId,
                        source: 'defineButton'
                    }
                });
                setDefineDefinitionOpen({
                    defineDefinitionOpen: true
                });
                setActionStates((prevState)=>({
                        ...prevState,
                        ...isOverWordLimit && readingAidsChangeboardingStep === 'idle' ? {
                            readingAidsChangeboardingStep: 'modal-word-count'
                        } : {
                            isReadingAidsOpen: true
                        },
                        show: false,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'defineButton',
                        type: 'ui',
                        attributes: {
                            contentId: contentId,
                            isAIOptedIn: isAIEnabledForContent
                        }
                    }
                }).fire();
            }
        };
        const defineButtonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.defineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            ...commonDefineButtonProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                label: "",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        })))); // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        const defineButton = (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, defineButtonContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $lS27Y.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, defineButtonContent);
        return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            delay: 0,
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.define.unsupported",
                defaultMessage: "Highlight a term, acronym, or abbreviation"
            }),
            component: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('confluence_comment_border_migration') ? $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated : $9755f908a54a6c5b$var$CustomLineWrapTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonOverlay), null), defineButton)) : defineButton;
    };
    const handleClickChat = (0, $cozmU.useCallback)(()=>{
        const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
        const isChatActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
        if (!isChatActive) rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const createRovoChatHighlightActionsButton = (selectedADFContent)=>{
        if ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3N2DH.RovoChatHighlightActions), {
            selectedContent: selectedADFContent,
            product: "confluence",
            onClickChat: handleClickChat
        });
    };
    const renderBuiltInWebItemActions = (builtInWebItems)=>{
        const isHighlightValid = $9755f908a54a6c5b$var$getIsHighlightValid({
            content: content.current,
            isFabric: isFabric,
            isAnnotationAllowed: isAnnotationAllowed,
            contentId: contentId
        });
        const isReactionAllowed = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid;
        const componentsAI = [];
        const components = [];
        const showMoreActions = [];
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        const selectionString = (0, $4d90dab75b68bf7b$export$a25c0fd63a5cc834)(window.getSelection());
        const selectedADFContent = (0, $i8Nmr.htmlToADF)(selectionString);
        if (isRovoEnabledForContent && !isAccessLinkRequest) {
            const askRovoButton = createRovoChatHighlightActionsButton(selectedADFContent);
            if (askRovoButton) componentsAI.push(askRovoButton);
        }
        if (showReadingAidsDefineButton && !isOverWordLimit) {
            const defineButton = createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            if (defineButton) componentsAI.push(defineButton);
        }
        const canShowRemix = isRemixAvailable && !isAccessLinkRequest && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
        const shouldHideForUnremixableSelection = canShowRemix && isSelectionUnremixable && Boolean(onRemixButtonPress) && !shouldDisableRemix && (0, $6mKj3.expValEquals)('platform_editor_disable_unremixable_selection', 'isEnabled', true);
        if (canShowRemix && !shouldHideForUnremixableSelection) {
            const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62937d50f24b4234$export$750386901eee7bd0), {
                key: "RemixButton",
                onClick: onRemixButtonPress,
                onMouseDown: onRemixButtonMouseDown,
                isDisabled: !onRemixButtonPress,
                isRemixInProgress: shouldDisableRemix,
                remixDisabledReason: remixDisabledReason
            });
            componentsAI.push(remixButton);
        }
        const commentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CreateInlineCommentButton, {
            key: "CreateInlineCommentButton"
        });
        components.push(commentButton);
        if ((0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true)) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96891b810f2a7438$export$9e9c4b5df2f723ad), {
            key: "InlineReactionAction",
            isAnnotationAllowed: isReactionAllowed,
            disabledTooltip: !isReactionAllowed ? (0, $dj3mI.getReactionButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType) : undefined
        }));
        let jiraButton = null;
        let trelloButton = null;
        builtInWebItems.forEach((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') jiraButton = createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') trelloButton = createTrelloInboxButton(completeKey);
        });
        if (snippetSlots?.dropdownItem && (0, $6mKj3.expValEquals)('platform_editor_blocks_conf', 'isEnabled', true)) showMoreActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "SnippetDropdownItem"
        }, snippetSlots.dropdownItem));
        if (jiraButton) showMoreActions.push(jiraButton);
        if (trelloButton) showMoreActions.push(trelloButton);
        if (componentsAI.length > 0) // if there are AI components, render them in a ToolbarSection with a separator at the end
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                key: "built-in-actions-ai",
                hasSeparator: (0, $cE5a1.SeparatorPosition).END
            }, componentsAI), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                key: "built-in-actions"
            }, components)),
            showMoreActions: showMoreActions
        };
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                key: "built-in-actions"
            }, components),
            showMoreActions: showMoreActions
        };
    };
    const getComponentsForPopup = (webItems, forgeItems = [])=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        const webItemsWithTrello = (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            ...webItems,
            {
                completeKey: 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
            }
        ] : webItems;
        const builtInWebItems = webItemsWithTrello.filter((item)=>$9755f908a54a6c5b$var$BUILT_IN_ITEMS.includes(item.completeKey));
        const connectItems = webItems.filter((item)=>!$9755f908a54a6c5b$export$9205c47465d0942.includes(item.completeKey));
        const { builtInActions: builtInActions, showMoreActions: showMoreActions } = renderBuiltInWebItemActions(builtInWebItems);
        const otherActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5df649ae1312176$export$c01fdef1354c759b), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        })));
        return [
            builtInActions,
            otherActions
        ];
    };
    const renderPopup = (components)=>components.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAFO.BannerHeightReader), null, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + (position?.top ?? top),
                left: position?.left ?? left,
                updatePosition: updatePosition
            }, components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        }) : null;
    const isCreateSingleJiraIssueHandleParams = (params)=>{
        return params?.fireAiAnalytics === undefined;
    };
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        const callRightSidebarClose = async ()=>rightSidebarContext.close((0, $dVJc1.ISSUE_CREATE_SIDE_PANEL_ID)); // Need to make sure sidebar is closed before creating a new one issue
        await callRightSidebarClose(); // Sorry this block sucks because of TS types
        if (isCreateSingleJiraIssueHandleParams(recordedClick)) (0, $4d90dab75b68bf7b$export$358d16442308a1f3)(recordedClick);
        else recordedClick && (0, $4d90dab75b68bf7b$export$5378c6b60bde04bf)(recordedClick);
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen,
        recordedClick,
        rightSidebarContext
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen
    ]);
    const contentSection = !isFabric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79f107ddc4d1b489$export$ca9047e33beaf8b2).Provider, {
        value: highlightActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: "content-container",
        ref: content
    }, children));
    const popupSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
        key: "action-panel",
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        fetchPolicy: "cache-first"
    }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
            render: (forgeItems, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return renderPopup(getComponentsForPopup(webItems, forgeItems));
            }
        }))) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onConfirm: handleConfirm,
        onCancel: handleCancel
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), contentQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentQueryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        render: (_apps, _loading, error)=>{
            if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            return null;
        }
    }), forgeExtension && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9755f908a54a6c5b$var$ForgeAction, {
        content: content.current,
        contentId: contentId,
        forgeExtension: forgeExtension,
        activeSelection: activeSelection,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    forgeExtension: null
                }));
        }
    }), (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9755f908a54a6c5b$var$DefinitionAction, {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        selectedText: activeSelection.selectedText,
        selectionRect: selectionRect
    }) : isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Jxlo.ReadingAidsPopup), {
        selectedText: activeSelection.selectedText,
        selectionRange: activeSelection.selectedRange,
        selectionRect: selectionRect,
        isReadingAidsOpen: isReadingAidsOpen,
        onClose: ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        contentId: contentId,
        popupPortalContainerId: (0, $bEdUx.popupPortalContainerId),
        onResult: (result)=>{
            if (readingAidsChangeboardingStep === 'idle') {
                if (result?.nlpSearch?.errorState?.startsWith('NO_ANSWER')) setActionStates((prevState)=>({
                        ...prevState,
                        isReadingAidsOpen: false,
                        readingAidsChangeboardingStep: 'modal-undefined'
                    }));
                else stopReadingAidsChangeboarding();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96ca290bd1749542$export$2e2bcd8739ae039), null, readingAidsChangeboardingStep.startsWith('modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $371bfa624b8f4825$export$d9088a53cb7c38b4), {
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'disabled'
                }));
            stopReadingAidsChangeboarding();
        },
        onNextClick: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'spotlight',
                    show: true
                }));
        },
        modalVersion: readingAidsChangeboardingStep,
        contentId: contentId
    }) : null), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        isVisible: readingAidsChangeboardingStep === 'spotlight',
        placement: "bottom-start",
        dismiss: ()=>void stopReadingAidsChangeboarding()
    }, readingAidsChangeboardingStep === 'spotlight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ade6da7539ba5902$export$1942ca99b3c33b66), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    })), contentSection, popupSection) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, readingAidsChangeboardingStep === 'spotlight' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ade6da7539ba5902$export$1942ca99b3c33b66), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    }) : null), contentSection, popupSection));
};
module.exports["DROPDOWN_EXCLUDED_ITEMS"] = $9755f908a54a6c5b$export$9205c47465d0942;
module.exports["HighlightActions"] = $9755f908a54a6c5b$export$a6299569dd2a354f;

});

parcelRegister("i8Nmr", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");

const $480784015f96442e$var$adfTransformer = new (0, $2lPWP.JSONTransformer)();
const $480784015f96442e$export$e83f06e0073cd34f = (html)=>{
    const element = document.createElement('div');
    element.innerHTML = html;
    const doc = (0, $aPdNQ.DOMParser).fromSchema((0, $4XbfY.defaultSchema)).parse(element);
    return $480784015f96442e$var$adfTransformer.encode(doc);
};
module.exports["htmlToADF"] = $480784015f96442e$export$e83f06e0073cd34f;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    loader: async ()=>(await (parcelRequire("iBn3F"))).ReadingAidsPopup,
    name: 'ReadingAidsPopup'
});
const $8c38d1311bce6ee3$export$21572bb35b054edb = async ()=>{
    const popup = await $8c38d1311bce6ee3$export$15b21f0ead27e4bf.preload();
    if (typeof popup === 'function') await popup.preloadSummaryContent();
};
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;
module.exports["prepareSmartLinkSummarizePopup"] = $8c38d1311bce6ee3$export$21572bb35b054edb;

});

parcelRegister("iBn3F", function(module, exports) {

let $d8ad918e7912a46e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8ad918e7912a46e$var$load("fhJVC"),
    $d8ad918e7912a46e$var$load("ennNB"),
    $d8ad918e7912a46e$var$load("9Hr92"),
    $d8ad918e7912a46e$var$load("g7Yjk"),
    $d8ad918e7912a46e$var$load("aqs28"),
    $d8ad918e7912a46e$var$load("7I4uK"),
    $d8ad918e7912a46e$var$load("hUbK8"),
    $d8ad918e7912a46e$var$load("22tb1"),
    $d8ad918e7912a46e$var$load("kGZ8W"),
    $d8ad918e7912a46e$var$load("8yk9S"),
    $d8ad918e7912a46e$var$load("iOfkQ"),
    $d8ad918e7912a46e$var$load("5KHgm"),
    $d8ad918e7912a46e$var$load("211bN"),
    $d8ad918e7912a46e$var$load("blNQo"),
    $d8ad918e7912a46e$var$load("bRoHi"),
    $d8ad918e7912a46e$var$load("4M5us"),
    $d8ad918e7912a46e$var$load("hoo42"),
    $d8ad918e7912a46e$var$load("gft53"),
    $d8ad918e7912a46e$var$load("lPKve"),
    $d8ad918e7912a46e$var$load("dmzjI"),
    $d8ad918e7912a46e$var$load("f7eY1"),
    $d8ad918e7912a46e$var$load("kedWY"),
    $d8ad918e7912a46e$var$load("giX30"),
    $d8ad918e7912a46e$var$load("lUYNi"),
    $d8ad918e7912a46e$var$load("3UmlS"),
    $d8ad918e7912a46e$var$load("7SteV"),
    $d8ad918e7912a46e$var$load("4aKct"),
    $d8ad918e7912a46e$var$load("jqoep"),
    $d8ad918e7912a46e$var$load("iYvvi"),
    $d8ad918e7912a46e$var$load("eWXZF"),
    $d8ad918e7912a46e$var$load("kfGHh"),
    $d8ad918e7912a46e$var$load("lIiD7"),
    $d8ad918e7912a46e$var$load("bJbqV"),
    $d8ad918e7912a46e$var$load("hLB9K"),
    $d8ad918e7912a46e$var$load("le1z7"),
    $d8ad918e7912a46e$var$load("4xsdA"),
    $d8ad918e7912a46e$var$load("ea3NB"),
    $d8ad918e7912a46e$var$load("dxcsb"),
    $d8ad918e7912a46e$var$load("7qcPK"),
    $d8ad918e7912a46e$var$load("6wr18"),
    $d8ad918e7912a46e$var$load("59hV4"),
    $d8ad918e7912a46e$var$load("cGkFm"),
    $d8ad918e7912a46e$var$load("2jERw"),
    $d8ad918e7912a46e$var$load("b7144"),
    $d8ad918e7912a46e$var$load("3LYaV"),
    $d8ad918e7912a46e$var$load("ffEVr"),
    $d8ad918e7912a46e$var$load("do0Fh"),
    $d8ad918e7912a46e$var$load("jNr09"),
    $d8ad918e7912a46e$var$load("9xmQ5"),
    $d8ad918e7912a46e$var$load("ckVWI"),
    $d8ad918e7912a46e$var$load("9LDVS"),
    $d8ad918e7912a46e$var$load("kiMHu"),
    $d8ad918e7912a46e$var$load("7J1PC"),
    $d8ad918e7912a46e$var$load("446Ip"),
    $d8ad918e7912a46e$var$load("fwbNS"),
    $d8ad918e7912a46e$var$load("Wowvf"),
    $d8ad918e7912a46e$var$load("bSSct"),
    $d8ad918e7912a46e$var$load("45r7q"),
    $d8ad918e7912a46e$var$load("hhss7"),
    $d8ad918e7912a46e$var$load("aAWLw"),
    $d8ad918e7912a46e$var$load("7EorR"),
    $d8ad918e7912a46e$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("ghCl1", function(module, exports) {

let $bdabf9019c290d14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bdabf9019c290d14$var$load("6wr18"),
    $bdabf9019c290d14$var$load("Wowvf"),
    $bdabf9019c290d14$var$load("ffEVr"),
    $bdabf9019c290d14$var$load("kwiXK")
]).then(()=>parcelRequire('iPt4B'));

});

parcelRegister("1pom1", function(module, exports) {

let $106b0480d107f050$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $106b0480d107f050$var$load("ePGBS").then(()=>parcelRequire('cR1lV'));

});

parcelRegister("lS27Y", function(module, exports) {
const $b507e6fb02a1be0a$export$a21884ebed08a664 = 'reading-aids-spotlight';
module.exports["READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID"] = $b507e6fb02a1be0a$export$a21884ebed08a664;

});

parcelRegister("eDk57", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aiCO = parcelRequire("4aiCO");


var $1mDVg = parcelRequire("1mDVg");

const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};
module.exports["SingleIssueCreateProvidersWrapper"] = $45dbb5af31f3f8d0$export$bc90850968906652;

});

parcelRegister("4aiCO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $b8aa98a6a4a50068$export$83f018e4a62abc64 = {
    NAV: 'NAV',
    FLOATING: 'FLOATING'
};
const $b8aa98a6a4a50068$export$106572395d8035d = {
    isWarningDialogOpen: false,
    warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
};
const $b8aa98a6a4a50068$export$e324594224ef24da = {
    showWarningDialog: (warningDialogDisplayType)=>({ setState: setState })=>{
            const warningDialog = warningDialogDisplayType || $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV;
            setState({
                isWarningDialogOpen: true,
                warningDialog: warningDialog
            });
        },
    hideWarningDialog: ()=>({ setState: setState })=>{
            setState({
                isWarningDialogOpen: false,
                warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
            });
        }
};
const $b8aa98a6a4a50068$var$Store = (0, $8s9DV.createStore)({
    initialState: $b8aa98a6a4a50068$export$106572395d8035d,
    actions: $b8aa98a6a4a50068$export$e324594224ef24da,
    name: 'WarningDialogState'
});
const $b8aa98a6a4a50068$export$b306247a3820322e = (0, $j8on0.createContainer)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$cbed96beb63c6f4b = (0, $kBr4q.createActionsHook)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$4516c77130246355 = (0, $kBr4q.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.isWarningDialogOpen
});
const $b8aa98a6a4a50068$export$33ce673123557ab7 = (0, $kBr4q.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.warningDialog
});
module.exports["WarningDialog"] = $b8aa98a6a4a50068$export$83f018e4a62abc64;
module.exports["IssueCreateWarningDialogContainer"] = $b8aa98a6a4a50068$export$b306247a3820322e;
module.exports["useWarningDialogStateActions"] = $b8aa98a6a4a50068$export$cbed96beb63c6f4b;
module.exports["useIsWarningDialogOpen"] = $b8aa98a6a4a50068$export$4516c77130246355;
module.exports["useGetWarningDialog"] = $b8aa98a6a4a50068$export$33ce673123557ab7;

});

parcelRegister("1mDVg", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $4AavA = parcelRequire("4AavA");


var $c8cGy = parcelRequire("c8cGy");

var $5a132039fb6a1ec6$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["VIEW"] = "view";
    // Regular Page View Mode
    PageMode["EDIT"] = "edit";
    // Regular Page Edit Mode
    PageMode["LIVE_VIEW"] = "live-view";
    // Live Page View Mode
    PageMode["LIVE_EDIT"] = "live-edit";
    return PageMode;
}({});
const $5a132039fb6a1ec6$var$initialIssueCreateSidePanelState = {
    contentId: '',
    contentType: 'page',
    summary: '',
    descriptionAdf: (0, $4AavA.doc)((0, $c8cGy.paragraph)('')),
    highlightedText: (0, $4AavA.doc)((0, $c8cGy.paragraph)('')),
    selectedAdf: undefined,
    selectedTable: undefined,
    selectedActionItems: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertMultipleStorageFragmentsRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: 'idle',
    isCreatedWithAi: false,
    firstAttempt: true,
    totalRetries: 0,
    aiAnalyticsContext: {
        aiResponseLength: 0,
        pageContextLength: 0,
        highlightedTextLength: 0
    },
    currentSiteSelection: '',
    currentProjectSelection: undefined,
    aiIssueCreationEnablement: {
        isEnabled: false
    },
    isCreateManuallyPressed: false,
    isGicIframeReady: false,
    pageMode: undefined,
    hasEditPermission: false,
    isCreatedFromActionItems: false,
    editorAPI: undefined
};
const $5a132039fb6a1ec6$var$issueCreateSidePanelActions = {
    setContentId: (contentId)=>({ setState: setState })=>{
            setState({
                contentId: contentId
            });
        },
    setContentType: (contentType)=>({ setState: setState })=>{
            setState({
                contentType: contentType
            });
        },
    setSummary: (summary)=>({ setState: setState })=>{
            setState({
                summary: summary
            });
        },
    setDescriptionAdf: (descriptionAdf)=>({ setState: setState })=>{
            setState({
                descriptionAdf: descriptionAdf
            });
        },
    setHighlightedText: (highlightedText)=>({ setState: setState })=>{
            setState({
                highlightedText: highlightedText
            });
        },
    setSelectedAdf: (selectedAdf)=>({ setState: setState })=>{
            setState({
                selectedAdf: selectedAdf
            });
        },
    setSelectedTable: (selectedTable)=>({ setState: setState })=>{
            setState({
                selectedTable: selectedTable
            });
        },
    setSelectedActionItems: (selectedActionItems)=>({ setState: setState })=>{
            setState({
                selectedActionItems: selectedActionItems
            });
        },
    setAiState: (aiState)=>({ setState: setState })=>{
            setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setIsCreatedFromActionItem: (isCreatedFromActionItems)=>({ setState: setState })=>{
            setState({
                isCreatedFromActionItems: isCreatedFromActionItems
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertMultipleStorageFragmentsRequestPayload: (insertMultipleStorageFragmentsRequestPayload)=>({ setState: setState })=>{
            setState({
                insertMultipleStorageFragmentsRequestPayload: insertMultipleStorageFragmentsRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    setAiAnalyticsContext: (key, value)=>({ setState: setState, getState: getState })=>{
            setState({
                aiAnalyticsContext: {
                    ...getState()['aiAnalyticsContext'],
                    [key]: value
                }
            });
        },
    setFirstAttempt: (firstAttempt)=>({ setState: setState })=>{
            setState({
                firstAttempt: firstAttempt
            });
        },
    setTotalRetries: ()=>({ setState: setState, getState: getState })=>{
            const currentTotalRetries = getState().totalRetries;
            setState({
                totalRetries: currentTotalRetries + 1
            });
        },
    setCurrentSiteSelection: (currentSiteSelection)=>({ setState: setState })=>{
            setState({
                currentSiteSelection: currentSiteSelection
            });
        },
    setCurrentProjectSelection: (currentProjectSelection)=>({ setState: setState })=>{
            setState({
                currentProjectSelection: currentProjectSelection
            });
        },
    setAiIssueCreationEnablement: (aiIssueCreationEnablement)=>({ setState: setState })=>{
            setState({
                aiIssueCreationEnablement: aiIssueCreationEnablement
            });
        },
    setIsCreateManuallyPressed: (isCreateManuallyPressed)=>({ setState: setState })=>{
            setState({
                isCreateManuallyPressed: isCreateManuallyPressed
            });
        },
    setIsGicIframeReady: (isGicIframeReady)=>({ setState: setState })=>{
            setState({
                isGicIframeReady: isGicIframeReady
            });
        },
    setPageMode: (pageMode)=>({ setState: setState })=>{
            setState({
                pageMode: pageMode
            });
        },
    setHasEditPermission: (hasEditPermission)=>({ setState: setState })=>{
            setState({
                hasEditPermission: hasEditPermission
            });
        },
    setEditorAPI: (editorAPI)=>({ setState: setState })=>{
            setState({
                editorAPI: editorAPI
            });
        }
};
const $5a132039fb6a1ec6$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$5a132039fb6a1ec6$var$initialIssueCreateSidePanelState
    },
    actions: $5a132039fb6a1ec6$var$issueCreateSidePanelActions,
    name: 'issueCreateSidePanelContext'
});
const $5a132039fb6a1ec6$export$a8290271bb06280a = (0, $j8on0.createContainer)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$2a12c9775e55a317 = (0, $kBr4q.createHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$74cf44ce4ce6c99b = (0, $kBr4q.createActionsHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$daa560916caa4ae4 = (0, $kBr4q.createStateHook)($5a132039fb6a1ec6$var$Store, {
    selector: (state)=>state.aiIssueCreationEnablement
});
module.exports["PageMode"] = $5a132039fb6a1ec6$export$6ea4b0c62affbe44;
module.exports["IssueCreateSidePanelContainer"] = $5a132039fb6a1ec6$export$a8290271bb06280a;
module.exports["useIssueCreateSidePanelContext"] = $5a132039fb6a1ec6$export$2a12c9775e55a317;
module.exports["useIssueCreateSidePanelActions"] = $5a132039fb6a1ec6$export$74cf44ce4ce6c99b;
module.exports["useAiIssueCreationEnablementState"] = $5a132039fb6a1ec6$export$daa560916caa4ae4;

});

parcelRegister("98CLM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");


var $cDs9S = parcelRequire("cDs9S");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $e9c533ef122c07a9$var$headerStyles = (0, $buxP3.xcss)({
    flexDirection: 'row-reverse',
    width: '100%',
    justifyContent: 'space-between'
});
const $e9c533ef122c07a9$var$footerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    gap: 'space.050'
});
const $e9c533ef122c07a9$export$4385dd64e7fb8e2d = ({ onConfirm: onConfirm, onCancel: onCancel, issuesCount: issuesCount = 1 })=>{
    const handleConfirm = ()=>{
        onConfirm();
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
    };
    const Footer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $e9c533ef122c07a9$var$footerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "issue-create-warning-cancel-button",
            onClick: handleCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3E5yu.messages).unsavedActionCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "issue-create-warning-ok-button",
            appearance: "warning",
            onClick: handleConfirm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3E5yu.messages).unsavedActionDiscard))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedHeadingIssueTermRefresh : (0, $3E5yu.messages).unsavedHeading,
        values: {
            issuesCount: issuesCount
        }
    }, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            testId: "modal-dialog-issue-create-warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $e9c533ef122c07a9$var$headerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: handleCancel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedContentIssueTermRefresh : (0, $3E5yu.messages).unsavedContent,
            values: {
                issuesCount: issuesCount
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Footer, null)));
};
module.exports["IssueCreateWarningDialog"] = $e9c533ef122c07a9$export$4385dd64e7fb8e2d;

});

parcelRegister("3E5yu", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $340704cf66283bf0$var$messagesBase = (0, $kSwu1.defineMessages)({
    sidePanelHeader: {
        id: "issue-create-side-panel.header",
        defaultMessage: "Create Jira issue"
    },
    sidePanelFooterSubmit: {
        id: "issue-create-side-panel.footer.submit",
        defaultMessage: "Submit"
    },
    sidePanelFooterCancel: {
        id: "issue-create-side-panel.footer.cancel",
        defaultMessage: "Cancel"
    },
    sidePanelIssueCreateInsertionFailed: {
        id: "issue-create-side-panel.insertion-failed",
        defaultMessage: "We were unable to insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelFooterDisclaimerText: {
        id: "issue-create-side-panel.footer.disclaimer-text",
        defaultMessage: "Content quality may vary"
    },
    sidePanelIssueCreateAiToggleLabel: {
        id: "issue-create-side-panel.ai-toggle-label",
        defaultMessage: "Use Rovo to generate summary and description"
    },
    sidePanelFooterRovoText: {
        id: "issue-create-side-panel.footer.ai-text",
        defaultMessage: "Powered by Rovo"
    },
    sidePanelAiLoading: {
        id: "issue-create-side-panel.body.ai-loading",
        defaultMessage: "Generating issue"
    },
    sidePanelAiLoadingBulk: {
        id: "issue-create-side-panel.bulk-body.ai-loading",
        defaultMessage: "Generating issues"
    },
    manualBulkCreateLoadingTextFirst: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text",
        defaultMessage: "Teleporting text to Jira..."
    },
    manualBulkCreateLoadingTextSecond: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text-second",
        defaultMessage: "Building your next big thing..."
    },
    manualBulkCreateLoadingTextThird: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text-third",
        defaultMessage: "Your work items are on the way..."
    },
    jiraSiteHeading: {
        id: "issue-create-side-panel.body.site.heading",
        defaultMessage: "Site:"
    },
    jiraProjectHeading: {
        id: "issue-create-side-panel.body.project.heading",
        defaultMessage: "Project:"
    },
    jiraProjectHeadingGalaxia: {
        id: "issue-create-side-panel.body.project.heading-galaxia",
        defaultMessage: "Space:"
    },
    bulkCreateConfigureButtonText: {
        id: "issue-create-side-panel.bulk-create.configure-button-text",
        defaultMessage: "Configure"
    },
    singleCreateAiErrorDescription: {
        id: "issue-create-side-panel.single-create-ai-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Try again or create your issue manually."
    },
    issueGenerationErrorDescription: {
        id: "issue-create-side-panel.bulk-create-issue-generation-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Add more content and try again. Or highlight specific text to create manually."
    },
    ethicalViolationErrorDescription: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create an issue manually."
    },
    rateLimitErrorDescription: {
        id: "issue-create-side-panel.rate-limit-ai-error-description",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create an issue manually."
    },
    exceedingTokenLimitDescription: {
        id: "issue-create-side-panel.exceed-token-limit-description",
        defaultMessage: "Atlassian Intelligence can\u2019t create issues for lengthy Confluence pages right now. You can always create an issue manually."
    },
    noAnswerSuggestedIssues: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description",
        defaultMessage: "We can\u2019t understand the content to suggest an issue. Select different content or create an issue manually."
    },
    bulkCreateAiErrorDescription: {
        id: "issue-create-side-panel.bulk-create-ai-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Try again or highlight specific text to create manually."
    },
    singleCreateAiErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.single-create-ai-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or create your issue manually."
    },
    issueGenerationErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.bulk-create-issue-generation-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Add more content and try again. Or highlight specific text to create manually."
    },
    rateLimitErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-rebrand-to-rovo",
        defaultMessage: "We\u2019ve received too many recent requests for Rovo. Try again in a few minutes or <link>read about excessive use of Rovo</link>. You can always create an issue manually."
    },
    exceedingTokenLimitDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.exceed-token-limit-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t create issues for lengthy Confluence pages right now. You can always create an issue manually."
    },
    bulkCreateAiErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.bulk-create-ai-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or highlight specific text to create manually."
    },
    connectJiraProjectErrorDescription: {
        id: "issue-create-side-panel.bulk-create-connect-jira-project-error-description",
        defaultMessage: "We weren\u2019t able to connect to your Jira project. Please try again."
    },
    connectJiraProjectErrorDescriptionGalaxia: {
        id: "issue-create-side-panel.bulk-create-connect-jira-project-error-description-galaxia",
        defaultMessage: "We weren\u2019t able to connect to your Jira space. Please try again."
    },
    errorTryAgainButton: {
        id: "issue-create-side-panel.error.button.try-again",
        defaultMessage: "Try again"
    },
    errorCreateManuallyButton: {
        id: "issue-create-side-panel.error.button.create-manually",
        defaultMessage: "Create manually"
    },
    sidePanelSingleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.sucess-flag-title",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> issue"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.multiple.sucess-flag-title",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    sidePanelSingleIssueInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert links for  {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    documentModifiedSingleIssueInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.page-modified-after-selection-single-insert-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert a link for <link>{issueKey} {issueSummary}</link> because page content was modified after the side panel was opened"
    },
    documentModifiedMultipleIssuesInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.page-modified-after-selection-multiple-insert-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert links for {issueCount} {issueCount, plural, one {issue} other {issues}} because page content was modified after the side panel was opened"
    },
    sidePanelMultipleIssueCreateFlagViewIssue: {
        id: "issue-create-side-panel.multiple.flag-view-issue",
        defaultMessage: "View {issueCount, plural, one {issue} other {issues}} in Jira"
    },
    sidePanelMultipleIssueCreateFlagCopyLink: {
        id: "issue-create-side-panel.multiple.flag-copy-link",
        defaultMessage: "Copy link"
    },
    sidePanelMultipleIssueCreateFlagReloadToSeeLinks: {
        id: "issue-create-side-panel.multiple.flag-reload-to-see-links",
        defaultMessage: "Reload to see links appear"
    },
    sidePanelIssueCreateErrorMessage: {
        id: "issue-create-side-panel.bulk-create.error.message",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {issue} other {issues}}. Please try again."
    },
    sidePanelIssueCreatePartialErrorMessage: {
        id: "issue-create-side-panel.bulk-create.partial.error.message",
        defaultMessage: "We couldn\u2019t create some of your issues. Select the checkmark on the remaining issues to create them one at a time."
    },
    sidePanelBetaText: {
        id: "issue-create-side-panel.beta-text",
        defaultMessage: "Beta"
    },
    unsavedHeading: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading",
        defaultMessage: "Discard {issuesCount, plural, =0 {issue} one {issue} other {issues}}?"
    },
    unsavedContent: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content",
        defaultMessage: "Your {issuesCount, plural, =0 {issue} one {issue} other {issues}} will be lost."
    },
    unsavedActionDiscard: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.discard",
        defaultMessage: "Discard"
    },
    unsavedActionCancel: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateHeaderText: {
        id: "issue-create-side-panel.bulk-create.header",
        defaultMessage: "Create Jira issues"
    },
    bulkCreateCreateAllFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.create-all",
        defaultMessage: "Create all"
    },
    bulkCreateCancelFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateEditHeaderText: {
        id: "issue-create-side-panel.bulk-create-edit.header",
        defaultMessage: "Edit issue"
    },
    bulkCreateConfigureBodyText: {
        id: "issue-create-side-panel.bulk-create.configure.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    singleWorkCreateFormBodyText: {
        id: "issue-create-side-panel.single-work-create-form.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    bulkConfigureHeaderText: {
        id: "issue-create-side-panel.bulk-configure.header",
        defaultMessage: "Configure"
    },
    bulkConfigureJiraErrorText: {
        id: "issue-create-side-panel.bulk-configure.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    bulkConfigureJiraErrorTextGalaxia: {
        id: "issue-create-side-panel.bulk-configure.jira-error-galaxia",
        defaultMessage: "There are no available spaces in this site."
    },
    singleWorkCreateFormJiraErrorText: {
        id: "issue-create-side-panel.single-work-create-form.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    singleWorkCreateFormJiraErrorTextGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.jira-error-galaxia",
        defaultMessage: "There are no available spaces in this site."
    },
    bulkConfigureMissingTableCoulumnMappingErrorHeaderText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-header",
        defaultMessage: "Missing table column mapping"
    },
    bulkConfigureMissingTableCoulumnMappingErrorText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-text",
        defaultMessage: "Please update and save the mapping of your table columns to work item fields."
    },
    bulkConfigureFormSite: {
        id: "issue-create-side-panel.bulk-configure.form.site",
        defaultMessage: "Site"
    },
    singleWorkCreateFormSite: {
        id: "issue-create-side-panel.single-work-create-form.form.site",
        defaultMessage: "Site"
    },
    bulkConfigureFormProject: {
        id: "issue-create-side-panel.bulk-configure.form.project",
        defaultMessage: "Project"
    },
    bulkConfigureFormProjectGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-galaxia",
        defaultMessage: "Space"
    },
    singleWorkCreateFormProject: {
        id: "issue-create-side-panel.single-work-create-form.form.project",
        defaultMessage: "Project"
    },
    singleWorkCreateFormProjectGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-galaxia",
        defaultMessage: "Space"
    },
    bulkConfigureFormDefaultIssueType: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type",
        defaultMessage: "Default Issue type"
    },
    singleWorkCreateFormDefaultIssueType: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type",
        defaultMessage: "Issue type"
    },
    bulkConfigureFormProjectSelectorProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    bulkConfigureFormProjectSelectorProjectsGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.projects-galaxia",
        defaultMessage: "Spaces"
    },
    singleWorkCreateFormProjectSelectorProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    singleWorkCreateFormProjectSelectorProjectsGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.projects-galaxia",
        defaultMessage: "Spaces"
    },
    bulkConfigureFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    bulkConfigureFormProjectSelectorRecentProjectsGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects-galaxia",
        defaultMessage: "Recent Spaces"
    },
    singleWorkCreateFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    singleWorkCreateFormProjectSelectorRecentProjectsGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.recent-projects-galaxia",
        defaultMessage: "Recent Spaces"
    },
    bulkConfigureFooterCancel: {
        id: "issue-create-side-panel.bulk-configure.footer.cancel",
        defaultMessage: "Cancel"
    },
    singleCreateIssueFormFooterCancel: {
        id: "issue-create-side-panel.single-create-issue-form.footer.cancel",
        defaultMessage: "Cancel"
    },
    bulkConfigureFooterSave: {
        id: "issue-create-side-panel.bulk-configure.footer.save",
        defaultMessage: "Save"
    },
    singleCreateIssueFormFooterSave: {
        id: "issue-create-side-panel.single-create-issue-form.footer.save",
        defaultMessage: "Create"
    },
    bulkConfigureMapTableToIssueTitle: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title",
        defaultMessage: "Map table to issue fields"
    },
    bulkConfigureMapTableToIssueDescription: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your issues."
    },
    bulkConfigureMapTableToIssueTableColumn: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.table-column",
        defaultMessage: "Table column"
    },
    bulkConfigureMapTableToIssueIssueField: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field",
        defaultMessage: "Issue field"
    },
    bulkConfigureMapTableToIssueAddMapping: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.add-mapping",
        defaultMessage: "Add mapping"
    },
    bulkConfigureMapTableToIssueErrorColumnNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.column-not-selected",
        defaultMessage: "Column must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-not-selected",
        defaultMessage: "Field must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldAlreadyMapped: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-already-mapped",
        defaultMessage: "Another column is already mapped to selected field."
    },
    issueCardDescriptionIconLabel: {
        id: "issue-create-side-panel.bulk-create.card.description-icon",
        defaultMessage: "Description"
    },
    // TODO update objects below with correct fields
    requiredFieldsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-title",
        defaultMessage: "These suggestions have required fields"
    },
    requiredFieldsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description",
        defaultMessage: "Edit each suggestion and complete the required fields to create the issues"
    },
    workflowValidatorFieldsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.workflow-validator-fields-message-title",
        defaultMessage: "These suggestions have required fields specified through workflow validators"
    },
    bulkCreateIssueInsertionHeading: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading",
        defaultMessage: "Linked Jira Issues"
    },
    sidePanelAiLoadingIssueTermRefresh: {
        id: "issue-create-side-panel.body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelAiLoadingIssueExperiment: {
        id: "issue-create-side-panel.body.ai-loading-issue-experiment",
        defaultMessage: "Atlassian Intelligence is generating the summary and description, which may take a few moments."
    },
    unsavedHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading-issue-term-refresh",
        defaultMessage: "Discard {issuesCount, plural, =0 {work item} one {work item} other {work items}}?"
    },
    singleCreateAiErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh",
        defaultMessage: // oxlint-disable-next-line eslint-core/no-restricted-syntax
        "Atlassian Intelligence can\u2018t provide a response right now. Try again or create your work item manually."
    },
    singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or create your work item manually."
    },
    sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> work item"
    },
    sidePanelIssueCreatePartialErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.partial.error.message-issue-term-refresh",
        defaultMessage: "We couldn\u2019t create some of your work items. Select the checkmark on the remaining work items to create them one at a time."
    },
    unsavedContentIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content-issue-term-refresh",
        defaultMessage: "Your {issuesCount, plural, =0 {work item} one {work item} other {work items}} will be lost."
    },
    sidePanelAiLoadingBulkIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelHeaderIssueTermRefresh: {
        id: "issue-create-side-panel.header-issue-term-refresh",
        defaultMessage: "Create Jira work item"
    },
    noAnswerSuggestedIssuesIssueTermRefresh: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description-issue-term-refresh",
        defaultMessage: "We can\u2019t understand the content to suggest a work item. Select different content or create manually."
    },
    ethicalViolationErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description-issue-term-refresh",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create a work item manually."
    },
    rateLimitErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create a work item manually."
    },
    exceedingTokenLimitDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh",
        defaultMessage: "Atlassian Intelligence can\u2019t create work items for lengthy Confluence pages right now. You can always create a work item manually."
    },
    rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "We\u2019ve received too many recent requests for Rovo. Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create a work item manually."
    },
    exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t create work items for lengthy Confluence pages right now. You can always create a work item manually."
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title-issue-term-refresh",
        defaultMessage: "We couldn\u2019t insert links to the page for {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelIssueCreateErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.error.message-issue-term-refresh",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {work item} other {work items}}. Please try again."
    },
    bulkCreateConfigureBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.configure.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    bulkCreateConfigureBodyWorkFieldMappingsComponentsFieldOption: {
        id: "issue-create-side-panel.bulk-create.configure.body.work-field-mappings.components-field-option",
        defaultMessage: "Components"
    },
    singleWorkCreateFormBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    requiredFieldsSectionMessageDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description-issue-term-refresh",
        defaultMessage: "Edit each suggestion and complete the required fields to create the work items"
    },
    workflowValidatorFieldsSectionMessageDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.body.workflow-validator-fields-message-description-issue-term-refresh",
        defaultMessage: "Edit each suggestion and complete the following required fields to create the work items:"
    },
    moreThanFiftyWorkItemsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-title",
        defaultMessage: "There are more than 50 work items"
    },
    moreThanFiftyWorkItemsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-description",
        defaultMessage: "We can\u2019t create more than 50 work items at once. Please delete or approve work items from this list, or limit your {context, select, table {table to 50 rows} list {list to 50 action items} other {selection to 50 items}}."
    },
    moreThanTenAIWorkItemsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.more-than-ten-ai-work-items-message-title",
        defaultMessage: "Creation with Rovo is unavailable for more than 10 work items"
    },
    moreThanTenAIWorkItemsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.more-than-ten-ai-work-items-message-description",
        defaultMessage: "To create with Rovo, close this panel and reselect a {context, select, table {table with 10 or fewer rows} list {list with 10 or fewer action items} other {selection with 10 or fewer items}}. Otherwise, you can still create work items manually."
    },
    bulkConfigureFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Default work type"
    },
    singleWorkCreateFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Work type"
    },
    bulkCreateIssueInsertionHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading-issue-term-refresh",
        defaultMessage: "Linked Jira work items"
    },
    bulkCreateHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.header-issue-term-refresh",
        defaultMessage: "Create Jira work items"
    },
    bulkConfigureMapTableToIssueTitleIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title-issue-term-refresh",
        defaultMessage: "Map table to work item fields"
    },
    bulkConfigureMapTableToIssueDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description-issue-term-refresh",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your work items."
    },
    bulkConfigureMapTableToIssueIssueFieldIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field-issue-term-refresh",
        defaultMessage: "Work item field"
    },
    bulkCreateEditHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create-edit.header-issue-term-refresh",
        defaultMessage: "Edit work item"
    },
    workCreateCommonRequiredFieldsSectionMessageNote: {
        id: "issue-create-side-panel.work-create-form-common.required-fields-message-note",
        defaultMessage: "Required fields are marked with an asterisk *"
    },
    workCreateCommonRequiredFieldsSectionMessageNoteWithoutTailingAsterisk: {
        id: "issue-create-side-panel.work-create-form-common.required-fields-message-note-without-tailing-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    workCreateCommonSummaryLabel: {
        id: "issue-create-side-panel.work-create-form-common.text-field-label",
        defaultMessage: "Summary"
    },
    workCreateCommonSummaryError: {
        id: "issue-create-side-panel.work-create-form-common.text-field-error",
        defaultMessage: "Summary is required"
    },
    workCreateCommonDescriptionLabel: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-label",
        defaultMessage: "Description"
    },
    workCreateCommonDescriptionPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-placeholder",
        defaultMessage: "Add a description..."
    },
    workCreateCommonSummaryAiLoadingPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.text-field-ai-loading-placeholder",
        defaultMessage: "Generating summary..."
    },
    workCreateCommonDescriptionAiLoadingPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-ai-loading-placeholder",
        defaultMessage: "Generating description..."
    },
    transitionToGicAnywhereSectionMessage: {
        id: "issue-create-side-panel.transition-to-gic-anywhere-section-message",
        defaultMessage: "We have updated this form to show additional required fields."
    }
});
const $340704cf66283bf0$export$defe85febe8b728c = $340704cf66283bf0$var$messagesBase;
const $340704cf66283bf0$export$79a7c1ed4f4b06be = 'jiraEmbedIssueSiteSelected';
const $340704cf66283bf0$export$4e8bd21788b520a = 'jiraEmbedIssueProjectSelected';
const $340704cf66283bf0$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $340704cf66283bf0$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
module.exports["messages"] = $340704cf66283bf0$export$defe85febe8b728c;
module.exports["JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED"] = $340704cf66283bf0$export$79a7c1ed4f4b06be;
module.exports["JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED"] = $340704cf66283bf0$export$4e8bd21788b520a;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $340704cf66283bf0$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $340704cf66283bf0$export$a402043ad8e6699;

});

parcelRegister("aiS08", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("dVJc1")).ISSUE_CREATE_SIDE_PANEL_ID);

var $jmjWc = parcelRequire("jmjWc");


var $dVJc1 = parcelRequire("dVJc1");


const $8c03994ca3756429$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dU97j",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await (parcelRequire("dQ8Hf"))).IssueCreateSidePanel
});
module.exports["IssueCreateSidePanel"] = $8c03994ca3756429$export$808956d96594cb81;

});

parcelRegister("dVJc1", function(module, exports) {
const $1a5e120a9b7ff436$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $1a5e120a9b7ff436$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $1a5e120a9b7ff436$export$d030b92b162b528d = 320;
module.exports["sidePanelTestId"] = $1a5e120a9b7ff436$export$3318bd9d18742c1e;
module.exports["ISSUE_CREATE_SIDE_PANEL_ID"] = $1a5e120a9b7ff436$export$e760a8f02240cc6d;
module.exports["ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $1a5e120a9b7ff436$export$d030b92b162b528d;

});

parcelRegister("dQ8Hf", function(module, exports) {

let $a136e0a3850094c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a136e0a3850094c9$var$load("46Rej"),
    $a136e0a3850094c9$var$load("8EHOM"),
    $a136e0a3850094c9$var$load("jNr09"),
    $a136e0a3850094c9$var$load("9xmQ5"),
    $a136e0a3850094c9$var$load("9LDVS"),
    $a136e0a3850094c9$var$load("kiMHu"),
    $a136e0a3850094c9$var$load("7J1PC"),
    $a136e0a3850094c9$var$load("446Ip"),
    $a136e0a3850094c9$var$load("g7Yjk"),
    $a136e0a3850094c9$var$load("aqs28"),
    $a136e0a3850094c9$var$load("3LYaV"),
    $a136e0a3850094c9$var$load("45r7q"),
    $a136e0a3850094c9$var$load("6wr18"),
    $a136e0a3850094c9$var$load("ecWwW"),
    $a136e0a3850094c9$var$load("isCfG"),
    $a136e0a3850094c9$var$load("b19pM"),
    $a136e0a3850094c9$var$load("aMUi4"),
    $a136e0a3850094c9$var$load("4nZ85"),
    $a136e0a3850094c9$var$load("211bN"),
    $a136e0a3850094c9$var$load("7SteV"),
    $a136e0a3850094c9$var$load("Msrsx"),
    $a136e0a3850094c9$var$load("ariuh"),
    $a136e0a3850094c9$var$load("ffEVr"),
    $a136e0a3850094c9$var$load("kHXvF"),
    $a136e0a3850094c9$var$load("iWnyc"),
    $a136e0a3850094c9$var$load("Wowvf"),
    $a136e0a3850094c9$var$load("bSSct"),
    $a136e0a3850094c9$var$load("7EorR"),
    $a136e0a3850094c9$var$load("hhss7"),
    $a136e0a3850094c9$var$load("kcTOK")
]).then(()=>parcelRequire('1L1jV'));

});

parcelRegister("hq2Sz", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $f0BVO = parcelRequire("f0BVO");


var $3E5yu = parcelRequire("3E5yu");


var $aMxFD = parcelRequire("aMxFD");

const $9380a12614698ffc$export$298219811dc2c4cb = {
    ABORT: 'abort',
    LOADING: 'loading',
    ERROR: 'error',
    IDLE: 'idle'
};
const $9380a12614698ffc$export$b6616fff1cd26f39 = {
    BULK_CREATION: 'bulk-issue-creation-failed',
    ISSUE_GENERATION: 'ai-issue-generation-failed',
    SITE_RETRIEVAL: 'jira-site-retreival-failed',
    PROJECT_RETRIEVAL: 'jira-project-retreival-failed',
    ISSUE_TYPE_RETRIEVAL: 'issue-type-retreival-failed',
    EMPTY: ''
};
const $9380a12614698ffc$export$ed15e8f0bf6a46a2 = (()=>{
    return {
        [$9380a12614698ffc$export$b6616fff1cd26f39.BULK_CREATION]: ()=>(0, $3E5yu.messages).bulkCreateAiErrorDescriptionRebrandToRovo,
        [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION]: ()=>(0, $3E5yu.messages).issueGenerationErrorDescriptionRebrandToRovo,
        [$9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription,
        [$9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription,
        [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription
    };
})();
// Persisted state: survives panel close/reopen to maintain the user's Jira configuration
// and track issues that need to be inserted into the page.
const $9380a12614698ffc$var$initialPersistedBulkCreateState = {
    currentJiraSite: undefined,
    currentJiraProject: undefined,
    currentDefaultIssueType: undefined,
    issueTypeHasRequiredFields: false,
    singleIssuesCreated: [],
    issueTypeFields: {
        requiredFields: [],
        optionalFields: []
    }
};
// Transient state: reset on panel close
// Workflow-specific state for the current session
const $9380a12614698ffc$var$initialTransientBulkCreateState = {
    bulkIssuesList: [],
    currentIssueId: '',
    contentLastModifiedTimestamp: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: $9380a12614698ffc$export$298219811dc2c4cb.IDLE,
    isCreatedWithAi: false,
    isCreatedFromTable: false,
    isCreatedFromActionItems: false,
    error: '',
    manualCreateState: 'idle',
    aiResultViewedFiredOnce: false,
    closeAndAddIssuesToPage: false,
    expectedIssueIndices: [],
    selectedTableAdf: undefined,
    userChoseManualCreation: false,
    workflowValidators: null,
    isRovoPanelWidth: false
};
const $9380a12614698ffc$var$initialBulkCreateState = {
    ...$9380a12614698ffc$var$initialPersistedBulkCreateState,
    ...$9380a12614698ffc$var$initialTransientBulkCreateState
};
const $9380a12614698ffc$var$bulkCreateActions = {
    setCurrentIssueId: (currentIssueId)=>({ setState: setState })=>{
            setState({
                currentIssueId: currentIssueId
            });
        },
    setBulkIssuesList: (bulkIssuesList)=>({ setState: setState })=>{
            setState({
                bulkIssuesList: bulkIssuesList
            });
        },
    setIssueTypeFields: (issueTypeFields)=>({ setState: setState })=>{
            setState({
                issueTypeFields: issueTypeFields
            });
        },
    setAiState: (aiState)=>({ setState: setState, getState: getState })=>{
            const { error: error } = getState();
            if (error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION && aiState == $9380a12614698ffc$export$298219811dc2c4cb.LOADING) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
            });
            else if (aiState == $9380a12614698ffc$export$298219811dc2c4cb.ERROR) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION
            });
            else setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setIsCreatedFromTable: (isCreatedFromTable)=>({ setState: setState })=>{
            setState({
                isCreatedFromTable: isCreatedFromTable
            });
        },
    setIsCreatedFromActionItems: (isCreatedFromActionItems)=>({ setState: setState })=>{
            setState({
                isCreatedFromActionItems: isCreatedFromActionItems
            });
        },
    setContentLastModifiedTimestamp: (contentLastModifiedTimestamp)=>({ setState: setState })=>{
            setState({
                contentLastModifiedTimestamp: contentLastModifiedTimestamp
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    removeBulkIssue: (issueId)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue.id !== issueId);
            setState({
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    removeBulkIssueList: (issueIds)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            setState({
                bulkIssuesList: bulkIssuesList.filter((issue)=>!issueIds.includes(issue.id))
            });
        },
    setSingleIssuesCreated: (singleIssue)=>({ setState: setState, getState: getState })=>{
            const { singleIssuesCreated: singleIssuesCreated } = getState();
            setState({
                singleIssuesCreated: [
                    ...singleIssuesCreated,
                    singleIssue
                ]
            });
        },
    resetSingleIssuesCreated: ()=>({ setState: setState })=>{
            setState({
                singleIssuesCreated: $9380a12614698ffc$var$initialBulkCreateState.singleIssuesCreated
            });
        },
    setCurrentJiraSite: (currentJiraSite)=>({ setState: setState })=>{
            setState({
                currentJiraSite: currentJiraSite,
                workflowValidators: null
            });
        },
    setCurrentJiraProject: (currentJiraProject)=>({ setState: setState })=>{
            setState({
                currentJiraProject: currentJiraProject,
                workflowValidators: null
            });
        },
    setNextIssueToEdit: (goToPage)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList, currentIssueId: currentIssueId } = getState();
            const currentIssueListIndex = bulkIssuesList.findIndex((issue)=>issue?.id === currentIssueId);
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue?.id !== currentIssueId);
            if (currentIssueListIndex >= bulkIssuesList.length - 1) {
                setState({
                    bulkIssuesList: newBulkIssuesList,
                    closeAndAddIssuesToPage: newBulkIssuesList.length === 0
                });
                goToPage('default');
                return;
            }
            setState({
                currentIssueId: bulkIssuesList[currentIssueListIndex + 1]?.id,
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    setCurrentDefaultIssueType: (currentDefaultIssueType)=>({ setState: setState })=>{
            setState({
                currentDefaultIssueType: currentDefaultIssueType,
                workflowValidators: null
            });
        },
    setIssueTypeHasRequiredFields: (issueTypeHasRequiredFields)=>({ setState: setState })=>{
            setState({
                issueTypeHasRequiredFields: issueTypeHasRequiredFields
            });
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        },
    setManualCreateState: (manualCreateState)=>({ setState: setState, getState: getState })=>{
            const { error: error } = getState();
            const isManualError = error === $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL;
            if (isManualError && manualCreateState === 'loading') setState({
                manualCreateState: manualCreateState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
            });
            else if (manualCreateState === 'error') setState({
                manualCreateState: manualCreateState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL
            }); // Can be site , project or issue type retrieval since they all have the same error message
            else setState({
                manualCreateState: manualCreateState
            });
        },
    // Resets transient bulk create state while preserving Jira configuration
    resetTransientBulkCreateState: ()=>({ setState: setState })=>{
            setState($9380a12614698ffc$var$initialTransientBulkCreateState);
        },
    resetManualBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                manualCreateState: 'idle',
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY,
                bulkIssuesList: []
            });
        },
    resetAIBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                bulkIssuesList: [],
                aiResultViewedFiredOnce: false
            });
        },
    setAiResultViewedFiredOnce: (aiResultViewedFiredOnce)=>({ setState: setState })=>{
            setState({
                aiResultViewedFiredOnce: aiResultViewedFiredOnce
            });
        },
    resetCloseAndAddIssuesToPage: ()=>({ setState: setState })=>{
            setState({
                closeAndAddIssuesToPage: false
            });
        },
    setExpectedIssueIndices: (expectedIssueIndices)=>({ setState: setState })=>{
            setState({
                expectedIssueIndices: expectedIssueIndices
            });
        },
    setSelectedTableAdf: (selectedTableAdf)=>({ setState: setState })=>{
            setState({
                selectedTableAdf: selectedTableAdf
            });
        },
    setUserChoseManualCreation: (userChoseManualCreation)=>({ setState: setState })=>{
            setState({
                userChoseManualCreation: userChoseManualCreation
            });
        },
    setWorkflowValidators: (workflowValidators)=>({ setState: setState })=>{
            setState({
                workflowValidators: workflowValidators
            });
        },
    setIsRovoPanelWidth: (isRovoPanelWidth)=>({ setState: setState })=>{
            setState({
                isRovoPanelWidth: isRovoPanelWidth
            });
        }
};
const $9380a12614698ffc$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$9380a12614698ffc$var$initialBulkCreateState
    },
    actions: $9380a12614698ffc$var$bulkCreateActions,
    name: 'bulkCreateContext'
});
const $9380a12614698ffc$export$92252eadd295fb8a = (0, $j8on0.createContainer)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$490e4a97d97cfc86 = (0, $kBr4q.createHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$var$useActions = (0, $kBr4q.createActionsHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$1b7cc5c3228e5df3 = ()=>{
    const { setIssueTypeFields: setIssueTypeFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeFields;
};
const $9380a12614698ffc$export$870e2a44cedc7bc5 = ()=>{
    const { setIsCreatedWithAi: setIsCreatedWithAi } = $9380a12614698ffc$var$useActions();
    return setIsCreatedWithAi;
};
const $9380a12614698ffc$export$bbe8b2f72a2f0142 = ()=>{
    const { setIsCreatedFromTable: setIsCreatedFromTable } = $9380a12614698ffc$var$useActions();
    return setIsCreatedFromTable;
};
const $9380a12614698ffc$export$bd9a2bb248501d3c = ()=>{
    const { setIsCreatedFromActionItems: setIsCreatedFromActionItems } = $9380a12614698ffc$var$useActions();
    return setIsCreatedFromActionItems;
};
const $9380a12614698ffc$export$855adaee6d0178f6 = ()=>{
    const { setCurrentIssueId: setCurrentIssueId } = $9380a12614698ffc$var$useActions();
    return setCurrentIssueId;
};
const $9380a12614698ffc$export$296da57e9c6a045e = ()=>{
    const { removeBulkIssue: removeBulkIssue } = $9380a12614698ffc$var$useActions();
    return removeBulkIssue;
};
const $9380a12614698ffc$export$99381c02a30b0305 = ()=>{
    const { setNextIssueToEdit: setNextIssueToEdit } = $9380a12614698ffc$var$useActions();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    return (0, $cozmU.useCallback)(()=>void setNextIssueToEdit(goToPage), [
        goToPage,
        setNextIssueToEdit
    ]);
};
const $9380a12614698ffc$export$a4390ab8bce5f04c = ()=>{
    const { setIssueTypeHasRequiredFields: setIssueTypeHasRequiredFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeHasRequiredFields;
};
const $9380a12614698ffc$export$ba3d9bfa5413fe8b = ()=>{
    const { setSingleIssuesCreated: setSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return setSingleIssuesCreated;
};
const $9380a12614698ffc$export$ba48a27b4c861376 = ()=>{
    const { resetTransientBulkCreateState: resetTransientBulkCreateState } = $9380a12614698ffc$var$useActions();
    return resetTransientBulkCreateState;
};
const $9380a12614698ffc$export$d4106eeb3c6fb998 = ()=>{
    const { setManualCreateState: setManualCreateState } = $9380a12614698ffc$var$useActions();
    return setManualCreateState;
};
const $9380a12614698ffc$export$73a6a2784da9c400 = ()=>{
    const { resetManualBulkCreateState: resetManualBulkCreateState } = $9380a12614698ffc$var$useActions();
    return resetManualBulkCreateState;
};
const $9380a12614698ffc$export$b51cb542c700486 = ()=>{
    const { resetSingleIssuesCreated: resetSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return resetSingleIssuesCreated;
};
const $9380a12614698ffc$export$de8db8fa7dde89bc = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.contentLastModifiedTimestamp
});
const $9380a12614698ffc$export$244e33037af9cd62 = ()=>{
    const { setContentLastModifiedTimestamp: setContentLastModifiedTimestamp } = $9380a12614698ffc$var$useActions();
    return setContentLastModifiedTimestamp;
};
const $9380a12614698ffc$export$ad6d9721593c93fd = ()=>{
    const { setInsertStorageFragmentRequestPayload: setInsertStorageFragmentRequestPayload } = $9380a12614698ffc$var$useActions();
    return setInsertStorageFragmentRequestPayload;
};
const $9380a12614698ffc$export$9a0d9cff0b566e0d = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>({
            iconUrl: (0, $f0BVO.transformStargateUrl)(state.currentDefaultIssueType?.iconUrl || ''),
            name: state.currentDefaultIssueType?.name || '',
            id: state.currentDefaultIssueType?.id || ''
        })
});
const $9380a12614698ffc$export$eece47bd38cb4087 = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>!state.isCreatedWithAi && state.bulkIssuesList.length === 0
});
const $9380a12614698ffc$export$40eff28c679d44c8 = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.bulkIssuesList
});
const $9380a12614698ffc$export$9beedfe5695c176b = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.isCreatedWithAi
});
const $9380a12614698ffc$export$a7b4ff61662e2485 = ()=>{
    const { setError: setError } = $9380a12614698ffc$var$useActions();
    return setError;
};
const $9380a12614698ffc$export$8f38f84afcc073bc = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.closeAndAddIssuesToPage
});
const $9380a12614698ffc$export$8ed14da773b8613e = ()=>{
    const { resetCloseAndAddIssuesToPage: resetCloseAndAddIssuesToPage } = $9380a12614698ffc$var$useActions();
    return resetCloseAndAddIssuesToPage;
};
const $9380a12614698ffc$export$d035dcbd01eeba65 = ()=>{
    const { setBulkIssuesList: setBulkIssuesList } = $9380a12614698ffc$var$useActions();
    return setBulkIssuesList;
};
const $9380a12614698ffc$export$8698bd5657d8677 = ()=>{
    const { setExpectedIssueIndices: setExpectedIssueIndices } = $9380a12614698ffc$var$useActions();
    return setExpectedIssueIndices;
};
const $9380a12614698ffc$export$d3b3009eefe8d2e5 = ()=>{
    const { setSelectedTableAdf: setSelectedTableAdf } = $9380a12614698ffc$var$useActions();
    return setSelectedTableAdf;
};
const $9380a12614698ffc$export$98217e1ec518131b = ()=>{
    const { setUserChoseManualCreation: setUserChoseManualCreation } = $9380a12614698ffc$var$useActions();
    return setUserChoseManualCreation;
};
const $9380a12614698ffc$export$54281b991e018e12 = ()=>{
    const { setCurrentJiraSite: setCurrentJiraSite } = $9380a12614698ffc$var$useActions();
    return setCurrentJiraSite;
};
const $9380a12614698ffc$export$3083f19844329ad0 = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>({
            currentJiraSite: state.currentJiraSite,
            currentJiraProject: state.currentJiraProject,
            currentDefaultIssueType: state.currentDefaultIssueType
        })
});
const $9380a12614698ffc$export$d414bfb39fd535d3 = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.workflowValidators
});
const $9380a12614698ffc$export$c70d454f6bb9e8b8 = ()=>{
    const { setWorkflowValidators: setWorkflowValidators } = $9380a12614698ffc$var$useActions();
    return setWorkflowValidators;
};
const $9380a12614698ffc$export$f430a11618be5cac = (0, $kBr4q.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.isRovoPanelWidth
});
const $9380a12614698ffc$export$713d96f50e0cb8bb = ()=>{
    const { setIsRovoPanelWidth: setIsRovoPanelWidth } = $9380a12614698ffc$var$useActions();
    return setIsRovoPanelWidth;
};
const $9380a12614698ffc$export$5d9e87214479bf28 = 'Initiative';
const $9380a12614698ffc$export$d93b204c953f19e9 = 'Epic';
module.exports["AiStates"] = $9380a12614698ffc$export$298219811dc2c4cb;
module.exports["ErrorStates"] = $9380a12614698ffc$export$b6616fff1cd26f39;
module.exports["ErrorMessageMap"] = $9380a12614698ffc$export$ed15e8f0bf6a46a2;
module.exports["BulkCreateContainer"] = $9380a12614698ffc$export$92252eadd295fb8a;
module.exports["useBulkCreateContext"] = $9380a12614698ffc$export$490e4a97d97cfc86;
module.exports["useSetIssueTypeFields"] = $9380a12614698ffc$export$1b7cc5c3228e5df3;
module.exports["useSetIsCreatedWithAi"] = $9380a12614698ffc$export$870e2a44cedc7bc5;
module.exports["useSetIsCreatedFromTable"] = $9380a12614698ffc$export$bbe8b2f72a2f0142;
module.exports["useSetIsCreatedFromActionItems"] = $9380a12614698ffc$export$bd9a2bb248501d3c;
module.exports["useSetCurrentIssueId"] = $9380a12614698ffc$export$855adaee6d0178f6;
module.exports["useRemoveBulkIssue"] = $9380a12614698ffc$export$296da57e9c6a045e;
module.exports["useSetNextIssueToEdit"] = $9380a12614698ffc$export$99381c02a30b0305;
module.exports["useSetIssueTypeHasRequiredFields"] = $9380a12614698ffc$export$a4390ab8bce5f04c;
module.exports["useSetSingleIssuesCreated"] = $9380a12614698ffc$export$ba3d9bfa5413fe8b;
module.exports["useResetTransientBulkCreateState"] = $9380a12614698ffc$export$ba48a27b4c861376;
module.exports["useSetManualCreateState"] = $9380a12614698ffc$export$d4106eeb3c6fb998;
module.exports["useResetSingleIssuesCreated"] = $9380a12614698ffc$export$b51cb542c700486;
module.exports["useGetContentLastModifiedTimestamp"] = $9380a12614698ffc$export$de8db8fa7dde89bc;
module.exports["useSetContentLastModifiedTimestamp"] = $9380a12614698ffc$export$244e33037af9cd62;
module.exports["useSetInsertStorageFragmentRequestPayload"] = $9380a12614698ffc$export$ad6d9721593c93fd;
module.exports["useGetIssueType"] = $9380a12614698ffc$export$9a0d9cff0b566e0d;
module.exports["useGetIsMissingColumnMappingError"] = $9380a12614698ffc$export$eece47bd38cb4087;
module.exports["useBulkIssuesList"] = $9380a12614698ffc$export$40eff28c679d44c8;
module.exports["useIsCreatedWithAi"] = $9380a12614698ffc$export$9beedfe5695c176b;
module.exports["useSetError"] = $9380a12614698ffc$export$a7b4ff61662e2485;
module.exports["useCloseAndAddIssuesToPage"] = $9380a12614698ffc$export$8f38f84afcc073bc;
module.exports["useResetCloseAndAddIssuesToPage"] = $9380a12614698ffc$export$8ed14da773b8613e;
module.exports["useSetBulkIssuesList"] = $9380a12614698ffc$export$d035dcbd01eeba65;
module.exports["useSetSelectedTableAdf"] = $9380a12614698ffc$export$d3b3009eefe8d2e5;
module.exports["useSetUserChoseManualCreation"] = $9380a12614698ffc$export$98217e1ec518131b;
module.exports["useSetCurrentJiraSite"] = $9380a12614698ffc$export$54281b991e018e12;
module.exports["useGetJiraConfig"] = $9380a12614698ffc$export$3083f19844329ad0;
module.exports["useGetWorkflowValidators"] = $9380a12614698ffc$export$d414bfb39fd535d3;
module.exports["useSetWorkflowValidators"] = $9380a12614698ffc$export$c70d454f6bb9e8b8;
module.exports["useIsRovoPanelWidth"] = $9380a12614698ffc$export$f430a11618be5cac;
module.exports["useSetIsRovoPanelWidth"] = $9380a12614698ffc$export$713d96f50e0cb8bb;

});

parcelRegister("f0BVO", function(module, exports) {
// Projects and Issue Types aratar URLs are returned wrongly for Stargate requests.
// This function corrects the URLs.
// This can be removed once the Stargate issue is fixed. Ticket: https://donut-world-dogfood.atlassian.net/browse/MCRTB-1099
const $09059fa00e602c45$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
module.exports["transformStargateUrl"] = $09059fa00e602c45$export$96f8b7181eacc12a;

});

parcelRegister("aMxFD", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $8e2cb5cf70790964$var$initialState = {
    currentPage: 'default',
    errorMessage: null
};
const $8e2cb5cf70790964$var$actions = {
    goToPage: (page)=>({ setState: setState })=>{
            setState({
                currentPage: page
            });
        },
    setFlags: (flags)=>({ setState: setState })=>{
            setState({
                flags: flags
            });
        },
    setErrorMessage: (errorMessage)=>({ setState: setState })=>{
            setState({
                errorMessage: errorMessage
            });
        }
};
const $8e2cb5cf70790964$var$Store = (0, $8s9DV.createStore)({
    initialState: $8e2cb5cf70790964$var$initialState,
    actions: $8e2cb5cf70790964$var$actions,
    name: 'AiBulkNavigationState'
});
const $8e2cb5cf70790964$export$a334843fa0c1b332 = (0, $j8on0.createContainer)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$var$useActions = (0, $kBr4q.createActionsHook)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$export$26ede1f3a8b75971 = ()=>{
    const { goToPage: goToPage } = $8e2cb5cf70790964$var$useActions();
    return goToPage;
};
const $8e2cb5cf70790964$export$c38ef97487898e66 = (0, $kBr4q.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.currentPage
});
const $8e2cb5cf70790964$export$94387769fbc3c2a7 = ()=>{
    const { setFlags: setFlags } = $8e2cb5cf70790964$var$useActions();
    return setFlags;
};
const $8e2cb5cf70790964$export$9800018acb54c42 = (0, $kBr4q.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.flags
});
const $8e2cb5cf70790964$export$bf8137e7995f9734 = ()=>{
    const { setErrorMessage: setErrorMessage } = $8e2cb5cf70790964$var$useActions();
    return setErrorMessage;
};
const $8e2cb5cf70790964$export$23759efdd2d2dae9 = (0, $kBr4q.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.errorMessage
});
module.exports["AiBulkNavigationContextContainer"] = $8e2cb5cf70790964$export$a334843fa0c1b332;
module.exports["useAiBulkNavigationGotoPage"] = $8e2cb5cf70790964$export$26ede1f3a8b75971;
module.exports["useAiBulkNavigationCurrentPage"] = $8e2cb5cf70790964$export$c38ef97487898e66;
module.exports["useSetBulkCreateFlagsContainer"] = $8e2cb5cf70790964$export$94387769fbc3c2a7;
module.exports["useBulkCreateFlagsContainer"] = $8e2cb5cf70790964$export$9800018acb54c42;
module.exports["useSetErrorMessage"] = $8e2cb5cf70790964$export$bf8137e7995f9734;
module.exports["useErrorMessage"] = $8e2cb5cf70790964$export$23759efdd2d2dae9;

});

parcelRegister("dAg4H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $3ricL = parcelRequire("3ricL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7mpOv = parcelRequire("7mpOv");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $2R8mu = parcelRequire("2R8mu");


var $k9cgj = parcelRequire("k9cgj");

const $3bc657bf57b962b7$export$8e6d40ccfb969320 = ({ contentId: contentId, isBulkCreate: isBulkCreate = false })=>{
    const [{ currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isCreateManuallyPressed: isCreateManuallyPressed, pageMode: pageMode, hasEditPermission: hasEditPermission }, { setAiIssueCreationEnablement: setAiIssueCreationEnablement }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const hasLicensedConfluenceAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    // environment-aware enablement via feature encoding
    // Encoded environments example: commercial-cloud: true, fedramp-moderate: false, isolated-commercial-cloud-ga: true
    const isAIEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isConfluenceAiEnabled = hasLicensedConfluenceAccess && isAIEnabledForContent && isAIEnvEnabled;
    (0, $cozmU.useEffect)(()=>{
        // isCreateManuallyPressed - When there is AI error "Create Manually" button can be pressed by user.
        // We should honour this and create manually.  This will be overriden on refresh.
        if (isCreateManuallyPressed) {
            setAiIssueCreationEnablement({
                isEnabled: false
            });
            return;
        }
        // Short-circuit if Confluence Ai is enabled
        if (isConfluenceAiEnabled) {
            setAiIssueCreationEnablement({
                isEnabled: true,
                enablement: 'confluence'
            });
            return;
        }
        const isJiraAiEnabled = async ()=>{
            /**
       * 1. Cannot call Jira enablement API if site & project are not selected
       * 2. Remove (cloudId !== currentSiteSelection) after Jira AI API supports
       * 	  cross-site scenarios - https://hello.jira.atlassian.cloud/browse/CBT-4995
       */ const bulkJiraNotSelected = !currentJiraSite || !currentJiraProject?.projectTypeKey || cloudId !== currentJiraSite.cloudId;
            const singleJiraNotSelected = !currentSiteSelection || !currentProjectSelection?.selectedProjectType || cloudId !== currentSiteSelection;
            const jiraNotSelected = isBulkCreate ? bulkJiraNotSelected : singleJiraNotSelected;
            if (jiraNotSelected) {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
                return;
            }
            try {
                const projectType = isBulkCreate ? currentJiraProject?.projectTypeKey ?? '' : currentProjectSelection?.selectedProjectType ?? '';
                const jiraEnablement = await (0, $k9cgj.getJiraAiEnablement)(isBulkCreate ? currentJiraSite?.cloudId ?? '' : currentSiteSelection, (0, $2R8mu.MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE)[projectType]);
                // 	User switches from a Jira AI enabled site to a no AI enabled site
                if (aiIssueCreationEnablement?.enablement == 'jira' && !jiraEnablement?.isEnabled) createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'disabled',
                        actionSubject: 'issueCreationAi',
                        attributes: {
                            pageMode: pageMode,
                            hasEditPermission: hasEditPermission,
                            isCreatedFromActionItems: isCreatedFromActionItems,
                            isCreatedFromTable: isCreatedFromTable
                        }
                    }
                }).fire();
                setAiIssueCreationEnablement({
                    isEnabled: jiraEnablement?.isEnabled ?? false,
                    enablement: jiraEnablement?.isEnabled ? 'jira' : undefined
                });
            } catch  {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
            }
        };
        isJiraAiEnabled();
    }, [
        currentSiteSelection,
        currentProjectSelection?.selectedProjectType,
        setAiIssueCreationEnablement,
        aiIssueCreationEnablement,
        isConfluenceAiEnabled,
        createAnalyticsEvent,
        isCreateManuallyPressed,
        cloudId,
        pageMode,
        hasEditPermission,
        currentJiraSite,
        currentJiraProject,
        isBulkCreate,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return aiIssueCreationEnablement;
};
module.exports["useIsAIIssueCreationAllowed"] = $3bc657bf57b962b7$export$8e6d40ccfb969320;

});

parcelRegister("2R8mu", function(module, exports) {
const $71c94b57ccceac13$export$6f9c4b5b9f7231da = (value)=>{
    return typeof value === 'object' && value !== null && 'id' in value;
};
const $71c94b57ccceac13$export$a24d9b48e1b802c6 = (value)=>{
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$6f9c4b5b9f7231da);
};
var $71c94b57ccceac13$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["JiraCore"] = "jira-core";
    JiraProjectType["JiraServiceDesk"] = "jira-servicedesk";
    JiraProjectType["JiraCustomerService"] = "jira-customer-service";
    JiraProjectType["JiraSoftware"] = "jira-software";
    JiraProjectType["JiraProductDiscovery"] = "jira-product-discovery";
    return JiraProjectType;
}({});
const $71c94b57ccceac13$export$f7e2564263dc8770 = {
    service_desk: "jira-servicedesk",
    software: "jira-software",
    customer_service: "jira-customer-service",
    business: "jira-core",
    product_discovery: "jira-product-discovery"
};
var $71c94b57ccceac13$export$bff92472168efa13 = /*#__PURE__*/ function(FieldMetadataSchemaItems) {
    FieldMetadataSchemaItems["VERSION"] = "version";
    FieldMetadataSchemaItems["OPTION"] = "option";
    return FieldMetadataSchemaItems;
}({});
var $71c94b57ccceac13$export$e70f0c6fcc814588 = /*#__PURE__*/ function(FieldMetadataSchemaType) {
    FieldMetadataSchemaType["ANY"] = "any";
    FieldMetadataSchemaType["STRING"] = "string";
    FieldMetadataSchemaType["NUMBER"] = "number";
    FieldMetadataSchemaType["DATE"] = "date";
    FieldMetadataSchemaType["DATETIME"] = "datetime";
    FieldMetadataSchemaType["ISSUELINK"] = "issuelink";
    FieldMetadataSchemaType["ISSUETYPE"] = "issuetype";
    FieldMetadataSchemaType["USER"] = "user";
    FieldMetadataSchemaType["TEAM"] = "team";
    FieldMetadataSchemaType["PRIORITY"] = "priority";
    FieldMetadataSchemaType["ARRAY"] = "array";
    FieldMetadataSchemaType["COMPONENTS"] = "components";
    return FieldMetadataSchemaType;
}({});
var $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6 = /*#__PURE__*/ function(FieldMetadataSchemaCustom) {
    FieldMetadataSchemaCustom["TEXT_AREA"] = "com.atlassian.jira.plugin.system.customfieldtypes:textarea";
    FieldMetadataSchemaCustom["TEXT_FIELD"] = "com.atlassian.jira.plugin.system.customfieldtypes:textfield";
    FieldMetadataSchemaCustom["PEOPLE"] = "com.atlassian.jira.plugin.system.customfieldtypes:people";
    return FieldMetadataSchemaCustom;
}({});
var $71c94b57ccceac13$export$2896cf63ba927114 = /*#__PURE__*/ function(FieldMetadataSchemaSystem) {
    FieldMetadataSchemaSystem["LABELS"] = "labels";
    FieldMetadataSchemaSystem["PARENT"] = "parent";
    return FieldMetadataSchemaSystem;
}({});
var $71c94b57ccceac13$export$e47e8d3b239f13b2 = /*#__PURE__*/ function(FieldMetadataSchemaOperations) {
    FieldMetadataSchemaOperations["ADD"] = "add";
    FieldMetadataSchemaOperations["SET"] = "set";
    FieldMetadataSchemaOperations["REMOVE"] = "remove";
    return FieldMetadataSchemaOperations;
}({});
class $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    add(priority) {
        // It's assumed that no two priorities will have the same ID so we don't have to worry about overwriting.
        this.internalMap.set(this.customIdFn(priority), priority);
    }
    has(priority) {
        return this.internalMap.has(this.customIdFn(priority));
    }
    get(key) {
        return this.internalMap.get(key);
    }
    hasId(id) {
        return this.internalMap.has(id);
    }
    union(other) {
        return new $71c94b57ccceac13$export$3bf230daf0bbd5c9([
            ...other.values(),
            ...this.values()
        ], this.customIdFn);
    }
    values() {
        return Array.from(this.internalMap.values());
    }
    size() {
        return this.internalMap.size;
    }
    constructor(priorities = [], customIdFn){
        this.internalMap = void 0;
        this.customIdFn = void 0;
        this.internalMap = new Map(priorities.map((priority)=>[
                customIdFn(priority),
                priority
            ]));
        this.customIdFn = customIdFn;
    }
}
class $71c94b57ccceac13$export$18c3c0a92740f3c1 extends $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    constructor(priorities = []){
        super(priorities, (priority)=>priority.id);
    }
}
class $71c94b57ccceac13$export$c115b35e1b0e068f extends $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    constructor(issues = []){
        super(issues, (issue)=>issue.key);
    }
}
function $71c94b57ccceac13$export$9e460c89a345e1d4(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'name' in value;
}
function $71c94b57ccceac13$export$4c30197f0b576bcc(value) {
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$9e460c89a345e1d4);
}
function $71c94b57ccceac13$export$26db3529e2ea773b(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'value' in value;
}
function $71c94b57ccceac13$export$363de4039b18e730(value) {
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$26db3529e2ea773b);
}
module.exports["isGICCompatibleObject"] = $71c94b57ccceac13$export$6f9c4b5b9f7231da;
module.exports["isGICCompatibleObjectList"] = $71c94b57ccceac13$export$a24d9b48e1b802c6;
module.exports["MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE"] = $71c94b57ccceac13$export$f7e2564263dc8770;
module.exports["FieldMetadataSchemaItems"] = $71c94b57ccceac13$export$bff92472168efa13;
module.exports["FieldMetadataSchemaType"] = $71c94b57ccceac13$export$e70f0c6fcc814588;
module.exports["FieldMetadataSchemaCustom"] = $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6;
module.exports["FieldMetadataSchemaSystem"] = $71c94b57ccceac13$export$2896cf63ba927114;
module.exports["FieldMetadataSchemaOperations"] = $71c94b57ccceac13$export$e47e8d3b239f13b2;
module.exports["SimpleJiraIssuesSet"] = $71c94b57ccceac13$export$c115b35e1b0e068f;
module.exports["isIdNameObjectList"] = $71c94b57ccceac13$export$4c30197f0b576bcc;
module.exports["isSelectOptionList"] = $71c94b57ccceac13$export$363de4039b18e730;

});

parcelRegister("k9cgj", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $2R8mu = parcelRequire("2R8mu");

const $8c7990e76592fea1$var$getJiraProjectsEndpoint = ({ cloudId: cloudId, query: query, projectIds: projectIds, orderBy: orderBy })=>{
    let endpoint = `/gateway/api/ex/jira/${cloudId}/rest/api/3/project/search?action=create`;
    if (orderBy) endpoint += `&orderBy=${orderBy}`;
    if (projectIds && projectIds.length > 0) endpoint += `&id=${projectIds.join('&id=')}`;
    if (query && query.length > 0) endpoint += `&query=${query}`;
    return endpoint;
};
const $8c7990e76592fea1$export$3643d7b900ddb907 = async ({ cloudId: cloudId, query: query, projectIds: projectIds, orderBy: orderBy })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getJiraProjectsEndpoint({
            cloudId: cloudId,
            query: query,
            projectIds: projectIds,
            orderBy: orderBy
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const projects = data?.values;
        if (!projects) throw new Error('Parsing response from fetchJiraProjects failed');
        return projects;
    } catch  {
        throw new Error('Request to fetchJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$var$getRecentJiraProjectsEndpoint = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/recent`;
const $8c7990e76592fea1$export$7c1ee4a22f76eab4 = async ({ cloudId: cloudId })=>{
    try {
        if (!cloudId) throw new Error('cloudId is required');
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getRecentJiraProjectsEndpoint(cloudId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const recentProjects = await response.json();
        if (!recentProjects) throw new Error('Parsing response from getRecentJiraProjects failed');
        return recentProjects;
    } catch  {
        throw new Error('Request to fetchRecentJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$export$7486116a104ef6e1 = ({ cloudId: cloudId, projectId: projectId })=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes`;
const $8c7990e76592fea1$export$2434906985ee7db = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7486116a104ef6e1({
            cloudId: cloudId,
            projectId: projectId
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const issues = data?.issueTypes;
        if (!issues) throw new Error('Parsing response from fetchIssueTypes failed');
        return issues;
    } catch  {
        throw new Error('Request to fetchIssueTypes agent failed');
    }
};
const $8c7990e76592fea1$export$2c19a8a7ef06a941 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue`;
const $8c7990e76592fea1$export$f47c2dad96a0a8ce = ({ cloudId: cloudId, issueBody: issueBody })=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$2c19a8a7ef06a941(cloudId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(issueBody)
    });
};
const $8c7990e76592fea1$export$b61347e00e271b8e = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await $8c7990e76592fea1$export$f47c2dad96a0a8ce({
            cloudId: cloudId,
            issueBody: issueBody
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createIssue failed');
        return data;
    } catch  {
        throw new Error('Request to createIssue agent failed');
    }
};
const $8c7990e76592fea1$export$7308ced31fe15b63 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/bulk`;
const $8c7990e76592fea1$export$b2c5c6a2eab6752b = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7308ced31fe15b63(cloudId), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(issueBody)
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createBulkIssues failed');
        return data;
    } catch  {
        throw new Error('Request to createBulkIssues agent failed');
    }
};
const $8c7990e76592fea1$export$e2e9228ec6723fb3 = (tasks, limit)=>{
    return new Promise((resolve)=>{
        const results = [];
        if (tasks.length <= 0) return resolve(results);
        let currentIndex = 0;
        let activePromises = 0;
        const processNext = ()=>{
            while(activePromises < limit && currentIndex < tasks.length){
                const index = currentIndex++;
                activePromises++;
                tasks[index]().then((value)=>handleSettlement(index, {
                        status: 'fulfilled',
                        value: value
                    }), (reason)=>handleSettlement(index, {
                        status: 'rejected',
                        reason: reason
                    }));
            }
        };
        const handleSettlement = (index, result)=>{
            results[index] = result;
            activePromises--;
            if (currentIndex >= tasks.length && activePromises === 0) resolve(results);
            else processNext();
        };
        processNext();
    });
};
const $8c7990e76592fea1$var$getIssuesMetadataEndpoint = ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults, startAt: startAt })=>{
    const base = `/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes/${issueTypeId}`;
    const withMaxResults = `${base}?maxResults=${maxResults}`;
    return `${withMaxResults}&startAt=${startAt}`;
};
const $8c7990e76592fea1$export$33757cfaf527b436 = async ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults = 200, page: page = 0, consolidatedFields: consolidatedFields = [] })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getIssuesMetadataEndpoint({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            startAt: page * maxResults
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from issues metadata failed');
        const finalConsolidatedFields = [
            ...consolidatedFields,
            ...data.fields
        ];
        // The API can return a maximum result of 200. However, Issue types can sometimes have more than
        // 200 fields, in which case, the API may not be able to retrieve the summary and description fields correctly.
        // Therefore we call this API until the number of consolidated fields is equal to the value of 'total' indicated in the API response.
        // This 'total' indicates the total number of fields in all pages.
        if (data.total > finalConsolidatedFields.length) return await $8c7990e76592fea1$export$33757cfaf527b436({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            page: page + 1,
            consolidatedFields: finalConsolidatedFields
        });
        return {
            fields: finalConsolidatedFields,
            maxResults: data.maxResults,
            total: data.total,
            startAt: data.startAt
        };
    } catch  {
        throw new Error('Error retrieving issue metadata');
    }
};
const $8c7990e76592fea1$export$fea6fd4de12a3df = (payload)=>{
    return {
        id: payload.issueId ? payload.issueId.toString() : '',
        key: payload.issueKey,
        self: payload.link,
        transition: {
            status: 200,
            errorCollection: {
                errorMessages: [],
                errors: {}
            }
        },
        summary: payload.summary
    };
};
const $8c7990e76592fea1$export$bed1e93b328a9d5f = (field)=>{
    if ((0, $2R8mu.isGICCompatibleObject)(field.value)) return field.value.id;
    if ((0, $2R8mu.isGICCompatibleObjectList)(field.value)) return field.value.map((value)=>value.id);
    // For all other primitive cases, we will just use the value directly.
    return field.value;
};
const $8c7990e76592fea1$export$f758b0f2f750cf99 = (cloudId, jiraProduct)=>`/gateway/api/ex/jira/${cloudId}/rest/api/1/aiconfig/ai-enabled/${jiraProduct}`;
const $8c7990e76592fea1$export$922a2bf0f405ea63 = (cloudId, jiraProduct)=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$f758b0f2f750cf99(cloudId, jiraProduct), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    });
};
const $8c7990e76592fea1$export$741d044e24209da7 = async (cloudId, jiraProduct)=>{
    try {
        const response = await $8c7990e76592fea1$export$922a2bf0f405ea63(cloudId, jiraProduct);
        const data = await response.json();
        if (!data) throw new Error('Parsing response from getJiraAiEnablementRequest failed');
        return data;
    } catch  {
        throw new Error('Request to getJiraAiEnablementRequest agent failed');
    }
};
const $8c7990e76592fea1$var$getBulkWorkItemTypesEndpoint = (cloudId, workItemIds)=>{
    const searchTerms = encodeURI(`issuekey in (${workItemIds.join(',')})`);
    return `/gateway/api/ex/jira/${cloudId}/rest/api/3/search?jql=${searchTerms}&fields=issuetype`;
};
const $8c7990e76592fea1$export$29f6d64e496bf360 = async ({ cloudId: cloudId, workItemKeys: workItemKeys })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getBulkWorkItemTypesEndpoint(cloudId, workItemKeys), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data || !data.issues) throw new Error('Parsing response from fetchBulkIssueTypes failed');
        const issueTypeMap = new Map();
        data.issues.forEach((issue)=>{
            if (issue.key && issue.fields?.issuetype) issueTypeMap.set(issue.key, {
                issueType: issue.fields.issuetype,
                id: issue.id
            });
        });
        return issueTypeMap;
    } catch (error) {
        // Return an empty map if the request fails due to a bad request, which should only happen if the work item keys are invalid.
        if (error instanceof (0, $hBkCm.BadStatusError) && error.response.status === 400) return new Map();
        throw new Error('Request to fetchBulkIssueTypes agent failed');
    }
};
const $8c7990e76592fea1$var$getComponentsEndpoint = (cloudId, projectId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/${projectId}/components`;
const $8c7990e76592fea1$export$85ceea444bba598d = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getComponentsEndpoint(cloudId, projectId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchComponents failed');
        return data;
    } catch  {
        throw new Error('Request to fetchComponents agent failed');
    }
};
const $8c7990e76592fea1$var$getVersionsEndpoint = (cloudId, projectId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/${projectId}/versions`;
const $8c7990e76592fea1$export$d21a3f2efb15f4cc = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getVersionsEndpoint(cloudId, projectId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchVersions failed');
        return data;
    } catch  {
        throw new Error('Request to fetchVersions agent failed');
    }
};
const $8c7990e76592fea1$var$getWorkflowValidatorsEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial?expand=fieldRequiredValidators`;
const $8c7990e76592fea1$export$7986722e27b5683d = async ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getWorkflowValidatorsEndpoint(cloudId), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                projectId: projectId,
                issueTypeId: issueTypeId
            })
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchWorkflowValidators failed');
        return data;
    } catch (error) {
        if (error instanceof Error && error.message.includes('Parsing response')) throw error;
        if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) {
            const status = error.response.status;
            throw new Error(`Request to fetchWorkflowValidators failed with status ${status}: ${error.message}`);
        }
        if (error instanceof SyntaxError) throw new Error(`Invalid JSON response from fetchWorkflowValidators: ${error.message}`);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        throw new Error(`Request to fetchWorkflowValidators agent failed: ${errorMessage}`);
    }
};
const $8c7990e76592fea1$export$f8fab2cbd65681b8 = async (query, cloudId)=>{
    const url = `/gateway/api/ex/jira/${cloudId}/rest/gira/1/?operation=${encodeURIComponent(query.operationName)}`;
    const requestBody = {
        query: query.query,
        variables: query.variables,
        operationName: query.operationName
    };
    try {
        const response = await (0, $f7B1p.cfetch)(url, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from GraphQL query failed');
        return data;
    } catch  {
        throw new Error('Request to GraphQL endpoint failed');
    }
};
const $8c7990e76592fea1$export$90b69b40e344dcd5 = `
	query ParentCandidatesForNewIssueQuery(
		$projectId: ID!
		$issueTypeId: ID!
		$cloudId: ID!
		$searchTerm: String
	) {
		jira {
			parentCandidatesWithInfoForNewIssue(
				projectId: $projectId
				issueTypeId: $issueTypeId
				cloudId: $cloudId
				searchTerm: $searchTerm
				excludeDone: false
				first: 1
			) {
				parentCandidates {
					edges {
						node {
							key
							issueId
						}
					}
				}
				message
			}
		}
	}
`;
module.exports["fetchJiraProjects"] = $8c7990e76592fea1$export$3643d7b900ddb907;
module.exports["fetchRecentJiraProjects"] = $8c7990e76592fea1$export$7c1ee4a22f76eab4;
module.exports["fetchIssueTypes"] = $8c7990e76592fea1$export$2434906985ee7db;
module.exports["createBulkIssues"] = $8c7990e76592fea1$export$b2c5c6a2eab6752b;
module.exports["fetchIssuesMetadata"] = $8c7990e76592fea1$export$33757cfaf527b436;
module.exports["mapGICPayloadToCreateIssueResponse"] = $8c7990e76592fea1$export$fea6fd4de12a3df;
module.exports["convertToGICFieldValue"] = $8c7990e76592fea1$export$bed1e93b328a9d5f;
module.exports["getJiraAiEnablement"] = $8c7990e76592fea1$export$741d044e24209da7;
module.exports["fetchBulkWorkItemTypes"] = $8c7990e76592fea1$export$29f6d64e496bf360;
module.exports["fetchJiraComponents"] = $8c7990e76592fea1$export$85ceea444bba598d;
module.exports["fetchWorkflowValidators"] = $8c7990e76592fea1$export$7986722e27b5683d;
module.exports["executeGraphQLQuery"] = $8c7990e76592fea1$export$f8fab2cbd65681b8;
module.exports["ParentCandidatesForNewIssueQuery"] = $8c7990e76592fea1$export$90b69b40e344dcd5;

});

parcelRegister("2ay9q", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

var $d14147b5d5932d8b$export$f06d63e9178daac8 = /*#__PURE__*/ function(ISSUE_CREATE_WITH_AI) {
    ISSUE_CREATE_WITH_AI["enabled"] = "enabled";
    ISSUE_CREATE_WITH_AI["disabled"] = "disabled";
    return ISSUE_CREATE_WITH_AI;
}({});
const $d14147b5d5932d8b$export$1a5b3977e2178dad = (payload)=>{
    if (payload?.selectedCloudId) try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE, payload.selectedCloudId);
    } catch (error) {
        throw new Error('Unable to save cloudId to localStorage');
    }
};
const $d14147b5d5932d8b$export$330363aaebcbbac2 = ()=>(0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE);
const $d14147b5d5932d8b$export$6637741b3a6a9486 = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE);
    } catch (error) {
        throw new Error('Unable to clear persisted override cloudId');
    }
};
const $d14147b5d5932d8b$export$a35ab74c98615456 = ()=>{
    const isCreateIssueAiEnabled = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI);
    // If the value is not set true should be returned by default
    return isCreateIssueAiEnabled !== "disabled";
};
const $d14147b5d5932d8b$export$14465c2df74f62aa = (enabled)=>{
    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI, enabled ? "enabled" : "disabled");
};
const $d14147b5d5932d8b$export$e1a5fce8e4916b90 = ({ selectedSite: selectedSite, selectedProject: selectedProject, selectedIssueType: selectedIssueType })=>{
    try {
        if (selectedSite && selectedProject && selectedIssueType) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER, {
            selectedSite: selectedSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to set bulk create Jira config: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$a231f3bb3ce63ba = ({ selectedSite: selectedSite, selectedProject: selectedProject, selectedIssueType: selectedIssueType })=>{
    try {
        if (selectedSite && selectedProject && selectedIssueType) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER, {
            selectedSite: selectedSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to set single work create Jira config: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$c5b1c13af74bb340 = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to get single work create Jira config: ${error instanceof Error ? error.message : String(error)}`);
        return null;
    }
};
const $d14147b5d5932d8b$export$75a524dafb2d99e6 = (shouldUseEmbed)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SHOULD_USE_GIC_EMBED, String(shouldUseEmbed));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to save shouldUseEmbed to localStorage: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$88676120d0f50696 = ()=>{
    try {
        const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SHOULD_USE_GIC_EMBED);
        if (value === null || value === undefined) return null;
        return value === 'true';
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to get shouldUseEmbed from localStorage: ${error instanceof Error ? error.message : String(error)}`);
        return null;
    }
};
module.exports["saveCloudIdToLocalStorage"] = $d14147b5d5932d8b$export$1a5b3977e2178dad;
module.exports["getPersistedOverrideCloudId"] = $d14147b5d5932d8b$export$330363aaebcbbac2;
module.exports["clearPersistedOverrideCloudId"] = $d14147b5d5932d8b$export$6637741b3a6a9486;
module.exports["getIsCreateIssueWithAiEnabledByUser"] = $d14147b5d5932d8b$export$a35ab74c98615456;
module.exports["setCreateIssueWithAiEnabledByUser"] = $d14147b5d5932d8b$export$14465c2df74f62aa;
module.exports["saveJiraConfigDetailsToLocalStorage"] = $d14147b5d5932d8b$export$e1a5fce8e4916b90;

});

parcelRegister("cSSgB", function(module, exports) {

var $i8Nmr = parcelRequire("i8Nmr");


var $1mDVg = parcelRequire("1mDVg");

const $49be58ea5500c18e$export$367309a91893a493 = (node)=>{
    return node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
};
const $49be58ea5500c18e$export$d8e52034650aae53 = (node)=>{
    const element = $49be58ea5500c18e$export$367309a91893a493(node);
    return element?.closest('[data-task-local-id]') ?? null;
};
const $49be58ea5500c18e$var$findActionItemElementInEditor = (node)=>{
    const element = $49be58ea5500c18e$export$367309a91893a493(node);
    return element instanceof HTMLDivElement ? element : null;
};
const $49be58ea5500c18e$export$57c04832e4673593 = (selection, pageMode = (0, $1mDVg.PageMode).VIEW)=>{
    if (!selection || selection.rangeCount === 0) return selection;
    const range = selection.getRangeAt(0);
    const { startContainer: startContainer, endContainer: endContainer } = range;
    const startInActionItem = pageMode === (0, $1mDVg.PageMode).VIEW ? $49be58ea5500c18e$export$d8e52034650aae53(startContainer) : $49be58ea5500c18e$var$findActionItemElementInEditor(startContainer);
    const endInActionItem = pageMode === (0, $1mDVg.PageMode).VIEW ? $49be58ea5500c18e$export$d8e52034650aae53(endContainer) : $49be58ea5500c18e$var$findActionItemElementInEditor(endContainer);
    if (startInActionItem) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newRange = document.createRange();
        newRange.selectNodeContents(startInActionItem);
        return newRange;
    }
    if (endInActionItem) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newRange = document.createRange();
        newRange.selectNodeContents(endInActionItem);
        return newRange;
    }
    return range;
};
const $49be58ea5500c18e$export$95b6717a0644653e = (selection, pageMode = (0, $1mDVg.PageMode).VIEW)=>{
    if (!selection || selection.rangeCount === 0) return null;
    const range = selection.getRangeAt(0);
    const container = $49be58ea5500c18e$export$367309a91893a493(range.commonAncestorContainer);
    if (!container) return null;
    const actionItems = Array.from(container.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])'));
    const firstActionItemInSelection = actionItems.find((actionItem)=>range.intersectsNode(actionItem)) ?? null;
    const actionItemListQuerySelector = pageMode === (0, $1mDVg.PageMode).VIEW ? '[aria-label="Action Item List"]' : 'div[data-node-type="actionList"]';
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const allLists = Array.from(document.querySelectorAll(actionItemListQuerySelector));
    return allLists.find((list)=>list.contains(firstActionItemInSelection)) ?? null;
};
const $49be58ea5500c18e$export$2171717a094dd1e7 = (actionList)=>{
    // Skip if any child has data-task-list-local-id -> avoid double counting nested action items
    const actionItems = actionList?.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""]):not(:has([data-task-list-local-id]))');
    const issues = [];
    let issueIndex = 0;
    actionItems.forEach((actionItem)=>{
        if (actionItem.textContent?.trim()) {
            const issue = {
                id: String(issueIndex),
                issueType: {
                    iconUrl: '',
                    name: '',
                    id: ''
                },
                rowIndex: issueIndex,
                summary: actionItem.textContent.trim(),
                description: (0, $i8Nmr.htmlToADF)(actionItem.innerHTML)
            };
            issues.push(issue);
        }
        issueIndex++;
    });
    return issues;
};
module.exports["findActionItemElement"] = $49be58ea5500c18e$export$d8e52034650aae53;
module.exports["includeEntireActionItemInSelection"] = $49be58ea5500c18e$export$57c04832e4673593;
module.exports["getClosestActionListFromSelection"] = $49be58ea5500c18e$export$95b6717a0644653e;
module.exports["mapActionItemsToIssues"] = $49be58ea5500c18e$export$2171717a094dd1e7;

});

parcelRegister("3TWPv", function(module, exports) {

var $i8Nmr = parcelRequire("i8Nmr");


var $1Q0l6 = parcelRequire("1Q0l6");


var $1mDVg = parcelRequire("1mDVg");


var $dVJc1 = parcelRequire("dVJc1");


var $cSSgB = parcelRequire("cSSgB");


var $9uzSK = parcelRequire("9uzSK");

const $918fba8df3fbcc13$export$233a92718b28d19e = 254;
const $918fba8df3fbcc13$var$getHTMLString = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $918fba8df3fbcc13$export$db5a8500f6b6286e = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipsis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipsis,
        text
    ];
};
const $918fba8df3fbcc13$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $918fba8df3fbcc13$var$getHTMLString(activeSelection);
    const [summary] = $918fba8df3fbcc13$export$db5a8500f6b6286e(selectionString, $918fba8df3fbcc13$export$233a92718b28d19e);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    const descriptionAdf = (0, $i8Nmr.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $918fba8df3fbcc13$export$41bb5569f66eae2a = ({ actions: actions, rightSidebarContext: rightSidebarContext, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const { updatedSelection: updatedSelection, activeSelectionRange: activeSelectionRange } = $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected({
        activeSelection: activeSelection,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const selectionAdf = shouldUseSelectionAdf ? (0, $9uzSK.extractSelectedAdfSlice)(selectionAdfResult) : undefined;
    const highlightedText = shouldUseSelectionAdf ? (0, $9uzSK.normalizeToDocNode)(selectionAdf) : (0, $i8Nmr.htmlToADF)($918fba8df3fbcc13$var$getHTMLString(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, convertSelectionToLegacyFormat, activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = shouldUseSelectionAdf ? (0, $9uzSK.getSummaryAndDescriptionFromSelectionAdfResult)(selectionAdfResult, $918fba8df3fbcc13$export$233a92718b28d19e) : $918fba8df3fbcc13$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    actions.setPageMode(pageMode);
    rightSidebarContext.open((0, $dVJc1.ISSUE_CREATE_SIDE_PANEL_ID), (0, $dVJc1.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected = ({ activeSelection: activeSelection, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection, pageMode);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        } else activeSelectionRange = activeSelection && 'getRangeAt' in activeSelection ? (0, $1Q0l6.getValidRange)(activeSelection.getRangeAt(0)) : undefined;
    }
    return {
        updatedSelection: updatedSelection,
        activeSelectionRange: activeSelectionRange
    };
};
module.exports["openSingleIssueSidePanelWithSelection"] = $918fba8df3fbcc13$export$41bb5569f66eae2a;

});

parcelRegister("1Q0l6", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $1mDVg = parcelRequire("1mDVg");


var $euVTc = parcelRequire("euVTc");

const $d1908e0af5aa886c$var$REFRESH_TIMEOUT = 3000;
const $d1908e0af5aa886c$export$78fd671954584729 = (jiraSiteUrl, issueKey)=>{
    return `${jiraSiteUrl}/browse/${issueKey}`;
};
const $d1908e0af5aa886c$export$9f5042b23377cc4d = (children)=>{
    return `<div><br />${children}</div>`;
};
const $d1908e0af5aa886c$export$abe60dca128cf840 = (url)=>{
    return `<a href="${url}" data-card-appearance="inline">${url}</a>`;
};
const $d1908e0af5aa886c$export$44af636f2297de15 = (urls)=>{
    return urls.map((url)=>$d1908e0af5aa886c$export$abe60dca128cf840(url)).join(' ');
};
const $d1908e0af5aa886c$export$8f3860761b656032 = (text)=>{
    return `<h2>${text}</h2>`;
};
const $d1908e0af5aa886c$export$5a351b98ac81cb91 = (columnToFieldMappings, isCreatedWithAi)=>{
    // When bulk creating with AI there is currently not support for mapping table columns to work item fields.
    // Therefore we always insert the summary into the first column.
    if (isCreatedWithAi) return 0;
    const summaryMapping = columnToFieldMappings?.find((mapping)=>mapping.field?.fieldId === 'summary');
    return summaryMapping?.column?.index;
};
const $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const metaTag = document.querySelector(`meta[name="confluence-request-time"]`);
    return metaTag ? Number(metaTag.getAttribute('content')) : null;
};
// Get last fetch time of current page.
// This used to be the request time, but this caused problems due to time drift between the server and database.
// So now try to use the content last modification date on load if that exists, then fallback onto the
// request time if it's not available.
const $d1908e0af5aa886c$var$getLastFetchTime = (lastModified)=>lastModified ? new Date(lastModified).getTime() : $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag();
const $d1908e0af5aa886c$var$constructBasePayload = (result)=>{
    // This happens when the page is completely empty.
    if (!result || !result.searchText || result.searchText.numMatches === undefined) return {
        selectedText: '',
        index: -1,
        numMatches: 0
    };
    const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = result;
    return {
        selectedText: selectedText,
        index: matchIndex,
        numMatches: numMatches
    };
};
const $d1908e0af5aa886c$export$3135b2526beb9ea6 = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(result),
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        xmlModification: undefined
    };
};
const $d1908e0af5aa886c$export$914430c62ea916b5 = (contentId, convertSelectionToLegacyFormat, ranges, contentRef, lastModified)=>{
    const result = [];
    let id = 0;
    for (const range of ranges)result.push({
        ...$d1908e0af5aa886c$var$constructBasePayload(convertSelectionToLegacyFormat(contentRef, range, contentId)),
        xmlModification: undefined,
        rowIndex: String(id++)
    });
    return {
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        fragments: result
    };
};
const $d1908e0af5aa886c$export$703688cefc28164e = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified, tableColumnIndex)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(result),
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        tableColumnIndex: tableColumnIndex ?? 0,
        cellModifications: []
    };
};
const $d1908e0af5aa886c$export$af14e9631e8de173 = (payload, pageMode)=>{
    if (pageMode && pageMode !== (0, $1mDVg.PageMode).VIEW) payload.lastFetchTime = Date.now();
};
const $d1908e0af5aa886c$export$2c148dbaa22fa887 = (selectedAdf, workItemUrl)=>{
    try {
        const selectedContent = selectedAdf.content ?? [];
        const updatedContent = [
            ...selectedContent,
            {
                type: 'inlineCard',
                attrs: {
                    url: workItemUrl
                }
            }
        ];
        return {
            type: selectedAdf.type,
            attrs: selectedAdf.attrs ?? {},
            content: updatedContent
        };
    } catch  {
        return null;
    }
};
const $d1908e0af5aa886c$export$761e13f48d0db999 = async ({ insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, pageMode: pageMode, selectedAdf: selectedAdf, editorAPI: editorAPI, workItemUrl: workItemUrl })=>{
    if (pageMode !== (0, $1mDVg.PageMode).VIEW && selectedAdf && editorAPI && workItemUrl) {
        const updatedAdf = $d1908e0af5aa886c$export$2c148dbaa22fa887(selectedAdf, workItemUrl);
        const result = await $d1908e0af5aa886c$export$fb99ecbaceee1e4e(editorAPI, updatedAdf);
        if (result.status === 'document-changed') throw new Error('document-changed');
        if (result.status === 'success') // Return true to indicate that the insertion via the editor API was successful.
        // If not, we fall back to using the legacy API below.
        return true;
    }
    return $d1908e0af5aa886c$export$57c9f61b323299ee(insertStorageFragmentRequestPayload);
};
const $d1908e0af5aa886c$export$57c9f61b323299ee = async (insertStorageFragmentRequestPayload)=>{
    try {
        const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-fragment';
        const response = await (0, $f7B1p.cfetch)(restUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(insertStorageFragmentRequestPayload)
        });
        if (!response.ok) throw new Error('Insert storage fragment request failed');
        return await response.json();
    } catch (error) {
        throw error;
    }
};
const $d1908e0af5aa886c$export$74ebcab4c727b6c6 = async (InsertMultipleStorageFragmentsRequestPayload)=>{
    const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-fragments';
    const response = await (0, $f7B1p.cfetch)(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(InsertMultipleStorageFragmentsRequestPayload)
    });
    if (!response.ok) throw new Error('Insert storage fragments request failed');
    return response.json();
};
const $d1908e0af5aa886c$export$1f11e8d398d7ee36 = async (insertStorageColumnTableRequestPayload)=>{
    const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-column-table';
    const response = await (0, $f7B1p.cfetch)(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(insertStorageColumnTableRequestPayload)
    });
    if (!response.ok) throw new Error('Insert storage column table request failed');
    return response.json();
};
const $d1908e0af5aa886c$export$63b770721cbd3eed = ()=>{
    setTimeout(()=>{
        window.location.reload();
    }, $d1908e0af5aa886c$var$REFRESH_TIMEOUT);
};
const $d1908e0af5aa886c$var$findDeepestChild = (node)=>{
    let current = node;
    while(current.hasChildNodes())current = current.lastChild;
    return current;
};
const $d1908e0af5aa886c$export$7c90eb3225536b1 = (originalRange)=>{
    if (!originalRange) return undefined;
    const currentNode = $d1908e0af5aa886c$var$findDeepestChild(originalRange.endContainer);
    return $d1908e0af5aa886c$export$61726a905a82cbc1(originalRange, currentNode);
};
const $d1908e0af5aa886c$export$61726a905a82cbc1 = (originalRange, startNode)=>{
    if (!originalRange) return undefined;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const newRange = document.createRange();
    let lastTextNode = null;
    let lastTextNodeStartOffset = 0;
    let lastTextNodeEndOffset = 0;
    const INVALID_NODE_SELECTORS = [
        // Status macro
        'span[data-node-type="status"]',
        // Inline Smart Card/Jira issue link
        '[data-inline-card="true"]',
        '.inlineCardView-content-wrap',
        '.smart-link-title-wrapper'
    ].join(',');
    const isInvalidNode = (node)=>{
        return node.nodeType === Node.ELEMENT_NODE && node.matches(INVALID_NODE_SELECTORS);
    };
    const hasInvalidAncestor = (node, ancestorLimit)=>{
        let currentNode = node;
        while(currentNode && currentNode !== ancestorLimit){
            if (isInvalidNode(currentNode)) return true;
            currentNode = currentNode.parentNode;
        }
        return false;
    };
    const previousNode = (node, range)=>{
        if (node.previousSibling) {
            node = node.previousSibling;
            while(node.hasChildNodes() && !isInvalidNode(node))node = node.lastChild;
            return node;
        }
        return node.parentNode && node.parentNode !== range.commonAncestorContainer ? node.parentNode : null;
    };
    let currentNode = startNode ?? originalRange.endContainer;
    while(currentNode){
        // If the current node is a text node and it is not empty, and it does not have an invalid ancestor, then it is a valid node.
        if (currentNode.nodeType === Node.TEXT_NODE && currentNode.textContent && currentNode.textContent.trim() !== '' && !hasInvalidAncestor(currentNode, originalRange.commonAncestorContainer)) {
            lastTextNode = currentNode;
            if (originalRange.endContainer === currentNode) lastTextNodeEndOffset = originalRange.endOffset;
            else lastTextNodeEndOffset = currentNode.textContent.length;
            if (originalRange.startContainer === currentNode) lastTextNodeStartOffset = originalRange.startOffset;
            else lastTextNodeStartOffset = 0;
            break; // Early termination as soon as we find the last valid text node.
        }
        // Terminate when we reach the start of the original range.
        if (currentNode === originalRange.startContainer) break;
        currentNode = previousNode(currentNode, originalRange);
    }
    if (lastTextNode) {
        newRange.setStart(lastTextNode, lastTextNodeStartOffset);
        newRange.setEnd(lastTextNode, lastTextNodeEndOffset);
        return newRange;
    }
    return originalRange;
};
const $d1908e0af5aa886c$export$6884d917093a4918 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const contentElement = document.getElementById('main-content');
    if (contentElement) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        range.selectNodeContents(contentElement);
        const endContainer = $d1908e0af5aa886c$var$findDeepestChild(range.endContainer);
        let endOffset = 0;
        if (endContainer.nodeType === Node.TEXT_NODE) endOffset = endContainer.textContent?.length || 0;
        else if (endContainer.nodeType === Node.ELEMENT_NODE) endOffset = endContainer.childNodes.length;
        range.setEnd(endContainer, endOffset);
        return range;
    }
    return undefined;
};
const $d1908e0af5aa886c$export$fb99ecbaceee1e4e = async (editorApi, adfNode)=>{
    if (!editorApi || !adfNode) return {
        status: 'failed-to-replace'
    };
    try {
        const result = await editorApi.selectionExtension?.actions.replaceWithAdf(adfNode);
        const status = result?.status === 'success' || result?.status === 'document-changed' ? result?.status : 'failed-to-replace';
        return {
            status: status
        };
    } catch  {
        return {
            status: 'failed-to-replace'
        };
    }
};
const $d1908e0af5aa886c$export$3724e27407b1cddd = async ({ createdIssues: createdIssues, currentJiraSiteUrl: currentJiraSiteUrl, pageMode: pageMode, selectedTableAdf: selectedTableAdf, editorAPI: editorAPI, payload: payload, summaryInsertionColumn: summaryInsertionColumn })=>{
    // Determine that we are in a non-view mode and whether we should use editorAPI for insertion
    const isEditorPathEnabled = pageMode !== (0, $1mDVg.PageMode).VIEW;
    if (isEditorPathEnabled && selectedTableAdf && editorAPI && summaryInsertionColumn != null) {
        // Construct map of row indices to work item URLs
        const workItemsByRow = new Map();
        for (const issue of createdIssues)if (issue.rowIndex != null) workItemsByRow.set(Number(issue.rowIndex), $d1908e0af5aa886c$export$78fd671954584729(currentJiraSiteUrl, issue.key));
        const tableAdf = (0, $euVTc.constructTableWithWorkItems)(selectedTableAdf, workItemsByRow, summaryInsertionColumn);
        if (!tableAdf) return false;
        const result = await $d1908e0af5aa886c$export$fb99ecbaceee1e4e(editorAPI, tableAdf);
        if (result.status === 'document-changed') throw new Error('document-changed');
        return result.status === 'success';
    }
    const response = await $d1908e0af5aa886c$export$1f11e8d398d7ee36(payload);
    return response;
};
module.exports["constructJiraIssueUrl"] = $d1908e0af5aa886c$export$78fd671954584729;
module.exports["constructBreakContainerTag"] = $d1908e0af5aa886c$export$9f5042b23377cc4d;
module.exports["constructSmartlinkTag"] = $d1908e0af5aa886c$export$abe60dca128cf840;
module.exports["bulkConstructSmartlinkTags"] = $d1908e0af5aa886c$export$44af636f2297de15;
module.exports["constructHeading"] = $d1908e0af5aa886c$export$8f3860761b656032;
module.exports["getSummaryInsertionColumn"] = $d1908e0af5aa886c$export$5a351b98ac81cb91;
module.exports["constructInsertStorageFragmentRequestPayload"] = $d1908e0af5aa886c$export$3135b2526beb9ea6;
module.exports["constructInsertMultipleStorageFragmentsRequestPayload"] = $d1908e0af5aa886c$export$914430c62ea916b5;
module.exports["constructInsertStorageColumnTableRequestPayload"] = $d1908e0af5aa886c$export$703688cefc28164e;
module.exports["updateLastFetchTimeIfNotViewMode"] = $d1908e0af5aa886c$export$af14e9631e8de173;
module.exports["insertSingleWorkItemToEndOfSelection"] = $d1908e0af5aa886c$export$761e13f48d0db999;
module.exports["insertContentAtSelectionEnd"] = $d1908e0af5aa886c$export$57c9f61b323299ee;
module.exports["insertMultipleContentAtSelectionEnd"] = $d1908e0af5aa886c$export$74ebcab4c727b6c6;
module.exports["refreshPageWithTimeout"] = $d1908e0af5aa886c$export$63b770721cbd3eed;
module.exports["getValidRangeForActionItem"] = $d1908e0af5aa886c$export$7c90eb3225536b1;
module.exports["getValidRange"] = $d1908e0af5aa886c$export$61726a905a82cbc1;
module.exports["getPageContentRange"] = $d1908e0af5aa886c$export$6884d917093a4918;
module.exports["insertWorkItemsIntoTable"] = $d1908e0af5aa886c$export$3724e27407b1cddd;

});

parcelRegister("euVTc", function(module, exports) {

var $f6RxU = parcelRequire("f6RxU");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $i8Nmr = parcelRequire("i8Nmr");


var $2R8mu = parcelRequire("2R8mu");


var $CbMiC = parcelRequire("CbMiC");

const $39b1e229aed8b0e2$var$TEAM_ID_PATTERN = /[0-9A-Za-z]{8}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{12}/;
const $39b1e229aed8b0e2$var$JIRA_DATE_FORMAT = 'yyyy-MM-dd';
const $39b1e229aed8b0e2$var$ISO_DATE_PREFIX_PATTERN = /^(\d{4}-\d{2}-\d{2})(?:$|[Tt])/;
const $39b1e229aed8b0e2$var$getFieldTypeFromMapping = (mapping)=>{
    if (mapping.field) return $39b1e229aed8b0e2$export$485ff2ccf56b085f(mapping.field);
    return (0, $CbMiC.FieldType).UNSUPPORTED;
};
const $39b1e229aed8b0e2$export$485ff2ccf56b085f = (metadata)=>{
    switch(metadata.schema.type){
        // "SHORT_TEXT" is the least restrictive type, so we can use it for "ANY"
        case (0, $2R8mu.FieldMetadataSchemaType).STRING:
            const customType = metadata.schema.custom;
            return customType === (0, $2R8mu.FieldMetadataSchemaCustom).TEXT_AREA ? (0, $CbMiC.FieldType).PARAGRAPH : (0, $CbMiC.FieldType).SHORT_TEXT;
        case (0, $2R8mu.FieldMetadataSchemaType).NUMBER:
            return (0, $CbMiC.FieldType).NUMBER;
        case (0, $2R8mu.FieldMetadataSchemaType).DATE:
            return (0, $CbMiC.FieldType).DATE;
        case (0, $2R8mu.FieldMetadataSchemaType).USER:
            return (0, $CbMiC.FieldType).USER;
        case (0, $2R8mu.FieldMetadataSchemaType).PRIORITY:
            return (0, $CbMiC.FieldType).PRIORITY;
        case (0, $2R8mu.FieldMetadataSchemaType).DATETIME:
            return (0, $CbMiC.FieldType).TIMESTAMP;
        case (0, $2R8mu.FieldMetadataSchemaType).ARRAY:
            if (metadata.schema.custom === (0, $2R8mu.FieldMetadataSchemaCustom).PEOPLE) return (0, $CbMiC.FieldType).PEOPLE;
            else if (metadata.schema.system === (0, $2R8mu.FieldMetadataSchemaSystem).LABELS) return (0, $CbMiC.FieldType).LABELS;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).VERSION) return (0, $CbMiC.FieldType).VERSIONS;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).OPTION && metadata.operations?.includes((0, $2R8mu.FieldMetadataSchemaOperations).ADD)) return (0, $CbMiC.FieldType).MULTI_SELECT;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).OPTION && metadata.operations?.includes((0, $2R8mu.FieldMetadataSchemaOperations).SET)) return (0, $CbMiC.FieldType).SINGLE_SELECT;
            return (0, $CbMiC.FieldType).UNSUPPORTED;
        case (0, $2R8mu.FieldMetadataSchemaType).TEAM:
            return (0, $CbMiC.FieldType).TEAM;
        case (0, $2R8mu.FieldMetadataSchemaType).ISSUELINK:
            if (metadata.schema.system === (0, $2R8mu.FieldMetadataSchemaSystem).PARENT) return (0, $CbMiC.FieldType).PARENT;
            return (0, $CbMiC.FieldType).UNSUPPORTED;
        case (0, $2R8mu.FieldMetadataSchemaType).COMPONENTS:
            // NOTE: Components are not a standard field type.
            return (0, $CbMiC.FieldType).COMPONENTS;
        default:
            return (0, $CbMiC.FieldType).UNSUPPORTED;
    }
};
const $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode = (adfNode)=>{
    return adfNode.type == 'mention' && adfNode.attrs?.id ? adfNode.attrs.id : null;
};
const $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    const accountIds = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        const accountId = $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode(node);
        accountId && accountIds.push(node.attrs.id);
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return accountIds;
};
const $39b1e229aed8b0e2$var$getTeamIdFromUrl = (urlString)=>{
    if (!urlString) return null;
    let url;
    try {
        url = new URL(urlString);
    } catch  {
        return null;
    }
    const path = url.pathname;
    const pathParts = path.split('/');
    if (path.startsWith('/people/team') && pathParts.length > 3) {
        const teamId = pathParts[3];
        return teamId.match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN) ? teamId : null;
    }
    return null;
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfNode = (adfNode)=>{
    let urlString;
    if (adfNode.type == 'inlineCard' || adfNode.type == 'blockCard') urlString = adfNode.attrs?.url;
    else if (adfNode.type == 'link') urlString = adfNode.attrs?.href;
    else if (adfNode.type == 'text') urlString = adfNode.text;
    return $39b1e229aed8b0e2$var$getTeamIdFromUrl(urlString);
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    let node;
    while((node = nodes.pop()) !== undefined){
        const teamId = $39b1e229aed8b0e2$var$getTeamIdFromAdfNode(node);
        if (teamId) return teamId;
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
        node.marks?.forEach((n)=>{
            nodes.push(n);
        });
    }
    return null;
};
const $39b1e229aed8b0e2$export$e8f4aa792ae88917 = (adf, delimeterRegex = /\s+/)=>{
    const nodes = [
        adf
    ];
    const array = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        if (node.type == 'text' && node.text) array.push(...node.text.split(delimeterRegex));
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return array;
};
const $39b1e229aed8b0e2$export$793b299699592cd5 = (fieldType, fieldId, cell, options, fieldMetadata)=>{
    if (!cell) return null;
    const textContent = cell.textContent?.trim();
    const adf = (0, $i8Nmr.htmlToADF)(cell.innerHTML);
    let accountIds;
    const dateFromTextContent = textContent ? new Date(textContent) : null;
    const validDateOrNull = dateFromTextContent && !isNaN(dateFromTextContent.getTime()) ? dateFromTextContent : null;
    switch(fieldType){
        case (0, $CbMiC.FieldType).SHORT_TEXT:
            return textContent;
        case (0, $CbMiC.FieldType).PARAGRAPH:
            return adf;
        case (0, $CbMiC.FieldType).NUMBER:
            return Number(textContent);
        case (0, $CbMiC.FieldType).DATE:
            {
                const isoDatePrefix = textContent?.match($39b1e229aed8b0e2$var$ISO_DATE_PREFIX_PATTERN)?.[1];
                if (!validDateOrNull) return null;
                if (isoDatePrefix) {
                    const dateFromIsoPrefix = (0, $k5sGX.default)(isoDatePrefix);
                    return (0, $esV19.default)(dateFromIsoPrefix) ? (0, $f6RxU.default)(dateFromIsoPrefix, $39b1e229aed8b0e2$var$JIRA_DATE_FORMAT) : (0, $f6RxU.default)(validDateOrNull, $39b1e229aed8b0e2$var$JIRA_DATE_FORMAT);
                }
                return (0, $f6RxU.default)(validDateOrNull, $39b1e229aed8b0e2$var$JIRA_DATE_FORMAT);
            }
        case (0, $CbMiC.FieldType).USER:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.length > 0 ? {
                id: accountIds[0]
            } : null;
        case (0, $CbMiC.FieldType).PRIORITY:
            const prioritiesAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(prioritiesAllowedValues)) return null;
            // Priorities cannot have the same name and are case-insensitive, so we can do a lenient match.
            const lenientPriority = $39b1e229aed8b0e2$var$findLenientMatches(textContent, prioritiesAllowedValues);
            return lenientPriority.length > 0 ? {
                name: lenientPriority[0].name,
                id: lenientPriority[0].id
            } : null;
        case (0, $CbMiC.FieldType).COMPONENTS:
            const componentsAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(componentsAllowedValues)) return null;
            const lenientComponents = $39b1e229aed8b0e2$var$findLenientMatches(textContent, componentsAllowedValues, /\n+/, adf);
            return lenientComponents.length > 0 ? lenientComponents.map((component)=>({
                    id: component.id
                })) : null;
        case (0, $CbMiC.FieldType).VERSIONS:
            const versionsAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(versionsAllowedValues)) return null;
            const lenientVersions = $39b1e229aed8b0e2$var$findLenientMatches(textContent, versionsAllowedValues, /\n+/, adf);
            return lenientVersions.length > 0 ? lenientVersions.map((version)=>({
                    id: version.id
                })) : null;
        case (0, $CbMiC.FieldType).SINGLE_SELECT:
        case (0, $CbMiC.FieldType).MULTI_SELECT:
            const selectAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isSelectOptionList)(selectAllowedValues)) return null;
            // Convert the allowedValues to the format expected by findLenientMatches
            const lenientOptions = $39b1e229aed8b0e2$var$findLenientMatches(textContent, selectAllowedValues.map((option)=>({
                    name: option.value,
                    id: option.id
                })), /\n+/, adf);
            return lenientOptions.length > 0 ? lenientOptions : null;
        case (0, $CbMiC.FieldType).TIMESTAMP:
            return validDateOrNull ? validDateOrNull.toISOString() : null;
        case (0, $CbMiC.FieldType).PEOPLE:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.length > 0 ? accountIds.map((id)=>({
                    id: id
                })) : null;
        case (0, $CbMiC.FieldType).LABELS:
            return $39b1e229aed8b0e2$export$e8f4aa792ae88917(adf);
        case (0, $CbMiC.FieldType).TEAM:
            return $39b1e229aed8b0e2$var$getTeamIdFromAdfTree(adf);
        case (0, $CbMiC.FieldType).PARENT:
            if (textContent == null) return null;
            const trimmedKey = textContent.toUpperCase().trim();
            const mappedType = options.mappingValidParentCandidates?.get(trimmedKey);
            return mappedType ? {
                key: mappedType.key,
                id: mappedType.issueId
            } : undefined;
        default:
            // Check for field-specific allowedValues validation for custom fields
            if (fieldMetadata && fieldMetadata.allowedValues && options.mappingFieldAllowedValues) {
                const fieldValidationResult = $39b1e229aed8b0e2$var$validateFieldWithAllowedValues(textContent, fieldMetadata.fieldId, options);
                if (fieldValidationResult) return fieldValidationResult;
            }
            return textContent;
    }
};
const $39b1e229aed8b0e2$var$findLenientMatches = (textContent, availableItems, delimiterRegex = /\n+/, adf)=>{
    if (!textContent || !availableItems) return [];
    const searchTexts = adf ? $39b1e229aed8b0e2$export$e8f4aa792ae88917(adf, delimiterRegex) : [
        textContent
    ];
    return searchTexts.map((searchText)=>availableItems.find((item)=>item.name.trim().toLowerCase() === searchText.trim().toLowerCase())).filter((item)=>item !== undefined);
};
// Flexible function to find text matches in allowedValues with different structures
// Supports various allowedValues formats:
// - { name: string, id: string } (priorities)
// - { name: string, value: string } (custom dropdowns)
// - { displayName: string, value: string } (some custom fields)
const $39b1e229aed8b0e2$var$findFlexibleMatches = (textContent, allowedValues)=>{
    if (!textContent || !allowedValues) return [];
    const searchText = textContent.trim().toLowerCase();
    return allowedValues.filter((item)=>{
        if (!item || typeof item !== 'object') return false;
        const obj = item;
        // Try different property names that might contain the display text
        // Order matters: more specific names first
        const possibleTextProperties = [
            'name',
            'displayName',
            'value'
        ];
        for (const prop of possibleTextProperties)if (obj[prop] && typeof obj[prop] === 'string') {
            if (obj[prop].trim().toLowerCase() === searchText) return true;
        }
        return false;
    });
};
const $39b1e229aed8b0e2$var$validateFieldWithAllowedValues = (textContent, fieldId, options)=>{
    if (!textContent || !fieldId) return null;
    // Look up field-specific allowedValues
    const fieldAllowedValues = options?.mappingFieldAllowedValues?.get(fieldId);
    if (fieldAllowedValues && Array.isArray(fieldAllowedValues)) {
        const matches = $39b1e229aed8b0e2$var$findFlexibleMatches(textContent, fieldAllowedValues);
        return matches.length > 0 ? matches[0] : null;
    }
    return null;
};
// Empty rows are not included in the issue create list, so we should not include them in the validation
const $39b1e229aed8b0e2$var$rowIsEmpty = (row)=>{
    return Array.from(row.cells).every((cell)=>cell.textContent?.trim() === '');
};
const $39b1e229aed8b0e2$export$aa8024509e414d36 = (cells)=>{
    if (!Array.isArray(cells) || cells.length === 0) return false;
    const first = cells[0];
    // Address HTML table cells
    if (first && typeof first === 'object' && 'tagName' in first) return cells.every((cell)=>cell.tagName?.toLowerCase() === 'th' || cell.classList?.contains('ak-renderer-table-number-column'));
    // Address ADF cell nodes
    return cells.every((c)=>c?.type === 'tableHeader');
};
function $39b1e229aed8b0e2$var$adjustInsertionColumn(rows, targetRows, startIndex = 0) {
    const firstTargetRow = [
        ...targetRows.keys()
    ][0];
    const row = rows[firstTargetRow];
    if (!row || row.type !== 'tableRow' || !row.content) return -1;
    const firstTableCellIndex = row.content.slice(startIndex).findIndex((cell)=>cell?.type === 'tableCell');
    if (firstTableCellIndex < 0) return -1;
    return startIndex + firstTableCellIndex;
}
const $39b1e229aed8b0e2$export$cd6fbae9421c69c7 = (fieldType, fieldId, column, table, validator, options, fieldMetadata)=>{
    const rows = Array.from(table.rows).slice(1);
    // Ignore completely empty rows for validation purposes
    const nonEmptyRows = rows.filter((row)=>!$39b1e229aed8b0e2$var$rowIsEmpty(row));
    const totalRowCount = nonEmptyRows.length;
    if (totalRowCount === 0) return null;
    // Get all field values from non-empty rows (ignore empty rows entirely)
    const allFieldValues = nonEmptyRows.map((row)=>$39b1e229aed8b0e2$export$793b299699592cd5(fieldType, fieldId, row.cells[column.index], options, fieldMetadata));
    // Filter out null values and apply validator for the final fieldValues array
    const fieldValues = allFieldValues.filter((value)=>value !== null && validator(value));
    // Count how many of the ALL original values (including nulls) are valid
    const validValues = allFieldValues.filter(validator);
    // If no valid values, return null
    if (validValues.length === 0) return null;
    return {
        canBeRequired: validValues.length === totalRowCount,
        fieldValues: fieldValues
    };
};
const $39b1e229aed8b0e2$export$dea6de0898ac5b8 = (column, fieldId, table, options)=>{
    const validatedIssueFieldValues = new Map();
    const setIfNotNull = (fieldType, validatedValues)=>{
        if (validatedValues) validatedIssueFieldValues.set(fieldType, validatedValues);
    };
    const dateValidator = (value)=>value != null && !isNaN(new Date(value.toString()).getTime());
    const userValidator = (value)=>value != null;
    const textValidator = (value)=>value != null && typeof value === 'string' && value.trim().length > 0;
    const adfValidator = (value)=>value != null && typeof value === 'object';
    const shortTextResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).SHORT_TEXT, fieldId, column, table, textValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).SHORT_TEXT, shortTextResult);
    const paragraphResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PARAGRAPH, fieldId, column, table, adfValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).PARAGRAPH, paragraphResult);
    const numberResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).NUMBER, fieldId, column, table, (value)=>value != null && !Number.isNaN(Number(value)), options);
    setIfNotNull((0, $CbMiC.FieldType).NUMBER, numberResult);
    const dateResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).DATE, fieldId, column, table, dateValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).DATE, dateResult);
    const timestampResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).TIMESTAMP, fieldId, column, table, dateValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).TIMESTAMP, timestampResult);
    const userResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).USER, fieldId, column, table, userValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).USER, userResult);
    const priorityResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PRIORITY, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).PRIORITY, priorityResult);
    const componentResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).COMPONENTS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).COMPONENTS, componentResult);
    const versionsResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).VERSIONS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).VERSIONS, versionsResult);
    const peopleResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PEOPLE, fieldId, column, table, (values)=>Array.isArray(values) && values.every(userValidator), options);
    setIfNotNull((0, $CbMiC.FieldType).PEOPLE, peopleResult);
    const teamResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).TEAM, fieldId, column, table, (value)=>!!value?.toString().match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN), options);
    setIfNotNull((0, $CbMiC.FieldType).TEAM, teamResult);
    const labelsResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).LABELS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).LABELS, labelsResult);
    const parentResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PARENT, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).PARENT, parentResult);
    const singleSelectResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).SINGLE_SELECT, fieldId, column, table, (value)=>value != null && Array.isArray(value) && value.length == 1, options);
    setIfNotNull((0, $CbMiC.FieldType).SINGLE_SELECT, singleSelectResult);
    const multiSelectResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).MULTI_SELECT, fieldId, column, table, (value)=>value != null && Array.isArray(value) && value.length > 0, options);
    setIfNotNull((0, $CbMiC.FieldType).MULTI_SELECT, multiSelectResult);
    return validatedIssueFieldValues;
};
const $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f = (activeSelection)=>{
    if (activeSelection && activeSelection.rangeCount > 0) {
        // Get the first range from the selection
        const range = activeSelection.getRangeAt(0);
        // Start from the common ancestor container of the range
        let node = range.commonAncestorContainer;
        // If the node is a text node, move up to its parent element
        if (node?.nodeType === Node.TEXT_NODE) node = node.parentElement;
        // Traverse up the DOM tree to find the closest <table> element
        while(node && node.nodeType === Node.ELEMENT_NODE){
            if (node.tagName === 'TABLE') return node;
            node = node.parentElement;
        }
    }
    return null;
};
const $39b1e229aed8b0e2$var$isFirstRowHeader = (rows)=>rows.length > 0 && Array.from(rows[0].cells).every((cell)=>cell.tagName.toLowerCase() === 'th' || cell.classList.contains('ak-renderer-table-number-column'));
const $39b1e229aed8b0e2$export$41999e0c951335f6 = (rows)=>{
    const firstRowHeader = $39b1e229aed8b0e2$var$isFirstRowHeader(rows);
    return Array.from(rows).slice(1).flatMap((row, index)=>{
        const hasContent = Array.from(row.cells).some((cell)=>cell.textContent?.trim() && // Exclude numbered columns when checking for content
            !cell.classList.contains('ak-renderer-table-number-column'));
        return hasContent ? [
            index + (firstRowHeader ? 0 : 1)
        ] : [];
    });
};
const $39b1e229aed8b0e2$export$d050dc64d7b7d275 = (mappings, table, options)=>{
    let issueIndex = 0;
    const rows = table.rows;
    const issues = [];
    const firstRowHeader = $39b1e229aed8b0e2$var$isFirstRowHeader(rows);
    // Starting from the second row as we will be using the first row as the header even if it is not a HTML header row
    for(let i = 1; i < rows.length; i++){
        const issue = {
            id: '',
            summary: '',
            description: undefined,
            issueType: {
                iconUrl: '',
                name: '',
                id: ''
            },
            // Note: the issue insertion API does not count the HTML header row as the first row so we want to shift the index by 1 if the first row is a HTML header row
            rowIndex: i - (firstRowHeader ? 1 : 0)
        };
        let emptySummary = true;
        let emptyDescription = true;
        for (const mapping of mappings){
            const textContent = mapping.column ? rows[i]?.cells[mapping.column.index]?.textContent?.trim() : '';
            if (mapping.field) {
                if (mapping.field.fieldId === 'summary') {
                    issue.summary = textContent || 'Untitled';
                    emptySummary = !textContent;
                } else if (mapping.field.fieldId === 'description') {
                    //The description expects ADF content
                    const cellHTML = mapping.column ? rows[i]?.cells[mapping.column.index]?.innerHTML : '';
                    issue.description = (0, $i8Nmr.htmlToADF)(cellHTML);
                    emptyDescription = !textContent;
                } else if (mapping.field.fieldId === 'assignee') {
                    const assigneeValue = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).USER, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (assigneeValue) issue.assigneeUserId = assigneeValue.id;
                } else if (mapping.field.fieldId === 'labels') issue.labels = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).LABELS, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field) ?? [];
                else if (mapping.field.fieldId === 'parent') {
                    const parentValue = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).PARENT, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (parentValue) issue.parent = parentValue;
                } else {
                    const fieldType = $39b1e229aed8b0e2$var$getFieldTypeFromMapping(mapping);
                    const fieldValue = $39b1e229aed8b0e2$export$793b299699592cd5(fieldType, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (!issue.additionalFields) issue.additionalFields = [];
                    if (fieldValue !== null) issue.additionalFields.push({
                        field: mapping.field,
                        value: fieldValue
                    });
                }
            }
        }
        if (!emptySummary && !emptyDescription) {
            issue.id = String(issueIndex++);
            issues.push(issue);
        }
    }
    return issues;
};
const $39b1e229aed8b0e2$export$fd730ab37ac74696 = (result, rowIndices)=>{
    const failedElementNumbers = result.errors.map((error)=>error.failedElementNumber);
    const updatedRowIndices = rowIndices.filter((_, elementNumber)=>!failedElementNumbers.includes(elementNumber));
    return result.issues.map((issue, index)=>{
        return {
            ...issue,
            rowIndex: updatedRowIndices[index]
        };
    });
};
const $39b1e229aed8b0e2$var$issueKeyRegex = /^[A-Z][A-Z0-9_]+-[1-9][0-9]*$/;
const $39b1e229aed8b0e2$export$5f391f745ffca1ca = (table)=>{
    const result = new Map();
    // Iterate through each row in the table
    for(let rowIndex = 0; rowIndex < table.rows.length; rowIndex++){
        const row = table.rows[rowIndex];
        // Iterate through each cell in the row
        for(let colIndex = 0; colIndex < row.cells.length; colIndex++){
            const cell = row.cells[colIndex];
            const textContent = cell.textContent || '';
            const matches = textContent.trim().toUpperCase().match($39b1e229aed8b0e2$var$issueKeyRegex);
            if (matches) result.set(colIndex, (result.get(colIndex) ?? []).concat(matches.map((key)=>key.trim().toUpperCase())));
        }
    }
    return result;
};
const $39b1e229aed8b0e2$export$33993da3a44263b8 = (tableCellAdf, workItemUrl)=>{
    try {
        const cellContent = tableCellAdf.content ?? [];
        const workItemNode = {
            type: 'inlineCard',
            attrs: {
                url: workItemUrl
            }
        };
        const updatedContent = [
            ...cellContent,
            {
                type: 'paragraph',
                content: [
                    workItemNode
                ]
            }
        ];
        return {
            type: tableCellAdf.type,
            attrs: tableCellAdf.attrs ?? {},
            content: updatedContent
        };
    } catch  {
        return null;
    }
};
/**
 * Returns updated table rows with work items inserted into the specified column in ADF
 *
 * @param rows - Array of ADF tableRow nodes
 * @param workItemsByRow - Map of row indices to work item URLs
 * @param insertionColumn - Column index to insert the work item into
 * @returns Updated array of tableRow ADF nodes
 */ const $39b1e229aed8b0e2$var$updateRowsWithWorkItems = (rows, workItemsByRow, insertionColumn = 0)=>{
    const tableRows = rows.slice();
    // Find the next insertable tableCell starting from insertionColumn
    const col = $39b1e229aed8b0e2$var$adjustInsertionColumn(tableRows, workItemsByRow, insertionColumn);
    if (col === -1) return null;
    for (const [rowIndex, workItemUrl] of workItemsByRow){
        const row = tableRows[rowIndex];
        if (!row || row.type !== 'tableRow' || !row.content) return null;
        if (col >= row.content.length) return null;
        const targetCellAdf = row.content[col];
        if (!targetCellAdf) return null;
        const updatedCell = $39b1e229aed8b0e2$export$33993da3a44263b8(targetCellAdf, workItemUrl);
        if (!updatedCell) return null;
        // Update the row with the new cell that includes the work item
        tableRows[rowIndex] = {
            ...row,
            content: [
                ...row.content.slice(0, col),
                updatedCell,
                ...row.content.slice(col + 1)
            ]
        };
    }
    return tableRows;
};
const $39b1e229aed8b0e2$export$ed3387feb2643b3c = (tableNode, workItemsByRow, insertionColumn)=>{
    try {
        if (tableNode.type !== 'table' || !Array.isArray(tableNode.content)) return null;
        const rows = tableNode.content.filter((row)=>row !== undefined);
        if (rows.length === 0) return null;
        // Determine if the first row is a header and apply an offset if so
        const firstRow = rows[0];
        const startColumnIndex = 0;
        const hasHeaderRow = Array.isArray(firstRow?.content) && $39b1e229aed8b0e2$export$aa8024509e414d36(firstRow.content.slice(startColumnIndex));
        const rowOffset = hasHeaderRow ? 1 : 0;
        // Apply row offset so rowIndex from issues mapping accounts for header row if present
        const offsetWorkItemsByRow = new Map();
        for (const [rowIndex, url] of workItemsByRow)offsetWorkItemsByRow.set(rowIndex + rowOffset, url);
        // Update applicable rows with matching work items
        const updatedRows = $39b1e229aed8b0e2$var$updateRowsWithWorkItems(rows, offsetWorkItemsByRow, insertionColumn);
        // Failure to update rows should propagate as null to signal failure to callers
        if (!updatedRows) return null;
        // If no updates were applied, abandon insertion entirely
        if (updatedRows === tableNode.content) return null;
        return {
            ...tableNode,
            content: updatedRows
        };
    } catch  {
        return null;
    }
};
module.exports["getFieldTypeFromMetadata"] = $39b1e229aed8b0e2$export$485ff2ccf56b085f;
module.exports["getValidatedIssueFieldValuesForColumn"] = $39b1e229aed8b0e2$export$dea6de0898ac5b8;
module.exports["getClosestTableFromSelection"] = $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f;
module.exports["getRowIndicesWithContent"] = $39b1e229aed8b0e2$export$41999e0c951335f6;
module.exports["mapTableToIssues"] = $39b1e229aed8b0e2$export$d050dc64d7b7d275;
module.exports["updateIssuesWithRowIndex"] = $39b1e229aed8b0e2$export$fd730ab37ac74696;
module.exports["getJiraWorkItemKeysFromTable"] = $39b1e229aed8b0e2$export$5f391f745ffca1ca;
module.exports["constructTableWithWorkItems"] = $39b1e229aed8b0e2$export$ed3387feb2643b3c;

});

parcelRegister("CbMiC", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $bb8ecfce0aa3278d$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType[FieldType["PARAGRAPH"] = 0] = "PARAGRAPH";
    FieldType[FieldType["SHORT_TEXT"] = 1] = "SHORT_TEXT";
    FieldType[FieldType["NUMBER"] = 2] = "NUMBER";
    FieldType[FieldType["DATE"] = 3] = "DATE";
    FieldType[FieldType["TIMESTAMP"] = 4] = "TIMESTAMP";
    FieldType[FieldType["USER"] = 5] = "USER";
    FieldType[FieldType["PEOPLE"] = 6] = "PEOPLE";
    FieldType[FieldType["TEAM"] = 7] = "TEAM";
    FieldType[FieldType["PRIORITY"] = 8] = "PRIORITY";
    FieldType[FieldType["COMPONENTS"] = 9] = "COMPONENTS";
    FieldType[FieldType["LABELS"] = 10] = "LABELS";
    FieldType[FieldType["VERSIONS"] = 11] = "VERSIONS";
    FieldType[FieldType["PARENT"] = 12] = "PARENT";
    FieldType[FieldType["UNSUPPORTED"] = 13] = "UNSUPPORTED";
    FieldType[FieldType["SINGLE_SELECT"] = 14] = "SINGLE_SELECT";
    FieldType[FieldType["MULTI_SELECT"] = 15] = "MULTI_SELECT";
    return FieldType;
}({});
const $bb8ecfce0aa3278d$var$initialState = {
    optionsAvailableSites: null,
    optionsRecentProjects: null,
    optionsAllProjects: null,
    optionsIssueTypes: null,
    optionsIssueTypeFields: null,
    optionsColumns: null,
    selectedAvailableSite: null,
    selectedProject: null,
    selectedIssueType: null,
    loadingProjects: false,
    loadingIssueType: false,
    loadingIssueTypeFields: false,
    projectSelectorQuery: '',
    isJiraError: false,
    columnToFieldMappings: null,
    unsavedColumnToFieldMappings: null,
    columnOffset: null,
    mappingWorkItemTypes: null,
    mappingValidParentCandidates: null,
    mappingFieldAllowedValues: null,
    mappingAvailableComponents: null
};
const $bb8ecfce0aa3278d$var$actions = {
    setOptionsAvailableSites: (optionsAvailableSites)=>({ setState: setState })=>{
            setState({
                optionsAvailableSites: optionsAvailableSites
            });
        },
    setOptionsRecentProjects: (optionsRecentProjects)=>({ setState: setState })=>{
            setState({
                optionsRecentProjects: optionsRecentProjects
            });
        },
    setOptionsAllProjects: (optionsAllProjects)=>({ setState: setState })=>{
            setState({
                optionsAllProjects: optionsAllProjects
            });
        },
    setOptionsIssueTypes: (optionsIssueTypes)=>({ setState: setState })=>{
            setState({
                optionsIssueTypes: optionsIssueTypes
            });
        },
    setOptionsIssueTypeFields: (optionsIssueTypeFields)=>({ setState: setState })=>{
            setState({
                optionsIssueTypeFields: optionsIssueTypeFields
            });
        },
    setOptionsColumns: (optionsColumns)=>({ setState: setState })=>{
            setState({
                optionsColumns: optionsColumns
            });
        },
    setSelectedAvailableSite: (selectedAvailableSite)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: null,
                selectedIssueType: null,
                optionsRecentProjects: null,
                optionsAllProjects: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null,
                isJiraError: false
            });
        },
    setSelectedProject: (selectedProject)=>({ setState: setState })=>{
            setState({
                selectedProject: selectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedProjectIfEmpty: (newSelectedProject)=>({ getState: getState, setState: setState })=>{
            const { selectedProject: selectedProject } = getState();
            if (!selectedProject) setState({
                selectedProject: newSelectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueType: (selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: selectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueTypeIfEmpty: (newSelectedIssueType)=>({ getState: getState, setState: setState })=>{
            const { selectedIssueType: selectedIssueType } = getState();
            if (!selectedIssueType) setState({
                selectedIssueType: newSelectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setLoadingProjects: (loadingProjects)=>({ setState: setState })=>{
            setState({
                loadingProjects: loadingProjects
            });
        },
    setLoadingIssueType: (loadingIssueType)=>({ setState: setState })=>{
            setState({
                loadingIssueType: loadingIssueType
            });
        },
    setLoadingIssueTypeFields: (loadingIssueTypeFields)=>({ setState: setState })=>{
            setState({
                loadingIssueTypeFields: loadingIssueTypeFields
            });
        },
    setProjectSelectorQuery: (projectSelectorQuery)=>({ setState: setState })=>{
            setState({
                projectSelectorQuery: projectSelectorQuery
            });
        },
    setIsJiraError: (isJiraError)=>({ setState: setState })=>{
            setState({
                isJiraError: isJiraError
            });
        },
    setColumnToFieldMappings: (columnToFieldMappings)=>({ setState: setState })=>{
            setState({
                columnToFieldMappings: columnToFieldMappings
            });
        },
    setUnsavedColumnToFieldMappings: (unsavedColumnToFieldMappings)=>({ setState: setState })=>{
            setState({
                unsavedColumnToFieldMappings: unsavedColumnToFieldMappings
            });
        },
    initUnsavedColumnToFieldMappings: ()=>({ setState: setState, getState: getState })=>{
            const { columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, optionsIssueTypeFields: optionsIssueTypeFields } = getState();
            // When the issue type chenges, the issue type fields will need to be reloaded.
            // With the existing mapping:
            // If the field is not available in the newly selected issue type, we remove the mapping.
            // If the field is available, we keep the mapping and update the reference to the field.
            if (unsavedColumnToFieldMappings && optionsIssueTypeFields) {
                const fieldIdMap = new Map(optionsIssueTypeFields.map((field)=>[
                        field.fieldId,
                        field
                    ]));
                const updatedMappings = unsavedColumnToFieldMappings.reduce((acc, mapping)=>{
                    const currentFieldId = mapping.field?.fieldId;
                    if (currentFieldId === undefined || fieldIdMap.has(currentFieldId)) acc.push({
                        ...mapping,
                        field: currentFieldId ? fieldIdMap.get(currentFieldId) : undefined,
                        errors: {}
                    });
                    return acc;
                }, []);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            } else if (columnToFieldMappings) {
                const updatedMappings = columnToFieldMappings.map((mapping)=>({
                        ...mapping,
                        isDefaultMapping: mapping.field?.fieldId === 'summary' || mapping.field?.fieldId === 'description',
                        errors: {}
                    }));
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    addUnsavedColumnToFieldMapping: (mapping)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) setState({
                unsavedColumnToFieldMappings: [
                    ...unsavedColumnToFieldMappings,
                    mapping
                ]
            });
        },
    deleteUnsavedColumnToFieldMapping: (index)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.filter((_, idx)=>idx !== index);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    saveUnsavedColumnToFieldMapping: ()=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.map(({ errors: _errors, isDefaultMapping: _isDefaultMapping, ...rest })=>rest);
                setState({
                    columnToFieldMappings: updatedMappings
                });
            }
        },
    setColumnOffset: (columnOffset)=>({ setState: setState })=>{
            setState({
                columnOffset: columnOffset
            });
        },
    setFieldAllowedValues: (mappingFieldAllowedValues)=>({ setState: setState })=>{
            setState({
                mappingFieldAllowedValues: mappingFieldAllowedValues
            });
        },
    setMappingWorkItemTypes: (mappingWorkItemTypes)=>({ setState: setState })=>{
            setState({
                mappingWorkItemTypes: mappingWorkItemTypes
            });
        },
    setMappingValidParentCandidates: (mappingValidParentCandidates)=>({ setState: setState })=>{
            setState({
                mappingValidParentCandidates: mappingValidParentCandidates
            });
        },
    setMappingAvailableComponents: (mappingAvailableComponents)=>({ setState: setState })=>{
            setState({
                mappingAvailableComponents: mappingAvailableComponents
            });
        },
    resetAll: (selectedAvailableSite, selectedProject, selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType
            });
        }
};
const $bb8ecfce0aa3278d$var$Store = (0, $8s9DV.createStore)({
    initialState: $bb8ecfce0aa3278d$var$initialState,
    actions: $bb8ecfce0aa3278d$var$actions,
    name: 'BulkConfigureState'
});
const $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c = (0, $j8on0.createContainer)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$var$useActions = (0, $kBr4q.createActionsHook)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$export$34f182b55b8247e5 = ()=>{
    const { setOptionsAvailableSites: setOptionsAvailableSites, setSelectedAvailableSite: setSelectedAvailableSite } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsAvailableSites: setOptionsAvailableSites,
        setSelectedAvailableSite: setSelectedAvailableSite
    };
};
const $bb8ecfce0aa3278d$export$b6149499a5c58797 = (0, $kBr4q.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsAvailableSites: optionsAvailableSites, selectedAvailableSite: selectedAvailableSite })=>({
            optionsAvailableSites: optionsAvailableSites,
            selectedAvailableSite: selectedAvailableSite
        })
});
const $bb8ecfce0aa3278d$export$af9c52e036827f6 = ()=>{
    const { setOptionsRecentProjects: setOptionsRecentProjects, setOptionsAllProjects: setOptionsAllProjects, setSelectedProject: setSelectedProject, setSelectedProjectIfEmpty: setSelectedProjectIfEmpty, setLoadingProjects: setLoadingProjects, setProjectSelectorQuery: setProjectSelectorQuery, setIsJiraError: setIsJiraError } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsRecentProjects: setOptionsRecentProjects,
        setOptionsAllProjects: setOptionsAllProjects,
        setSelectedProject: setSelectedProject,
        setSelectedProjectIfEmpty: setSelectedProjectIfEmpty,
        setLoadingProjects: setLoadingProjects,
        setProjectSelectorQuery: setProjectSelectorQuery,
        setIsJiraError: setIsJiraError
    };
};
const $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd = (0, $kBr4q.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects, selectedProject: selectedProject, projectSelectorQuery: projectSelectorQuery })=>({
            optionsRecentProjects: optionsRecentProjects,
            optionsAllProjects: optionsAllProjects,
            selectedProject: selectedProject,
            projectSelectorQuery: projectSelectorQuery
        })
});
const $bb8ecfce0aa3278d$export$8748a77548356db8 = ()=>{
    const { setOptionsIssueTypes: setOptionsIssueTypes, setSelectedIssueType: setSelectedIssueType, setLoadingIssueType: setLoadingIssueType, setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsIssueTypes: setOptionsIssueTypes,
        setSelectedIssueType: setSelectedIssueType,
        setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty,
        setLoadingIssueType: setLoadingIssueType
    };
};
const $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1 = (0, $kBr4q.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsIssueTypes: optionsIssueTypes, selectedIssueType: selectedIssueType })=>({
            optionsIssueTypes: optionsIssueTypes,
            selectedIssueType: selectedIssueType
        })
});
const $bb8ecfce0aa3278d$export$fd383356e1d8436d = (0, $kBr4q.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ selectedAvailableSite: selectedAvailableSite, loadingProjects: loadingProjects, loadingIssueType: loadingIssueType, isJiraError: isJiraError })=>({
            isLoading: selectedAvailableSite == null || loadingProjects || loadingIssueType,
            isJiraError: isJiraError
        })
});
const $bb8ecfce0aa3278d$export$d70d2e57670622a8 = ()=>{
    const { setOptionsColumns: setOptionsColumns, setOptionsIssueTypeFields: setOptionsIssueTypeFields, setLoadingIssueTypeFields: setLoadingIssueTypeFields, setColumnToFieldMappings: setColumnToFieldMappings, setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings, addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping, deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping, saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping, setColumnOffset: setColumnOffset, setFieldAllowedValues: setFieldAllowedValues, setMappingWorkItemTypes: setMappingWorkItemTypes, setMappingValidParentCandidates: setMappingValidParentCandidates, setMappingAvailableComponents: setMappingAvailableComponents } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsColumns: setOptionsColumns,
        setOptionsIssueTypeFields: setOptionsIssueTypeFields,
        setLoadingIssueTypeFields: setLoadingIssueTypeFields,
        setColumnToFieldMappings: setColumnToFieldMappings,
        initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings,
        setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings,
        addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping,
        deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping,
        saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping,
        setColumnOffset: setColumnOffset,
        setFieldAllowedValues: setFieldAllowedValues,
        setMappingWorkItemTypes: setMappingWorkItemTypes,
        setMappingValidParentCandidates: setMappingValidParentCandidates,
        setMappingAvailableComponents: setMappingAvailableComponents
    };
};
const $bb8ecfce0aa3278d$export$c8eb692d6965a0dd = (0, $kBr4q.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsColumns: optionsColumns, optionsIssueTypeFields: optionsIssueTypeFields, loadingIssueTypeFields: loadingIssueTypeFields, columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, columnOffset: columnOffset, mappingFieldAllowedValues: mappingFieldAllowedValues, mappingWorkItemTypes: mappingWorkItemTypes, mappingValidParentCandidates: mappingValidParentCandidates, mappingAvailableComponents: mappingAvailableComponents })=>({
            optionsColumns: optionsColumns,
            optionsIssueTypeFields: optionsIssueTypeFields,
            loadingIssueTypeFields: loadingIssueTypeFields,
            columnToFieldMappings: columnToFieldMappings,
            unsavedColumnToFieldMappings: unsavedColumnToFieldMappings,
            columnOffset: columnOffset,
            mappingFieldAllowedValues: mappingFieldAllowedValues,
            mappingWorkItemTypes: mappingWorkItemTypes,
            mappingValidParentCandidates: mappingValidParentCandidates,
            mappingAvailableComponents: mappingAvailableComponents
        })
});
const $bb8ecfce0aa3278d$export$2577d7c75421da7d = ()=>{
    const { resetAll: resetAll } = $bb8ecfce0aa3278d$var$useActions();
    return resetAll;
};
module.exports["FieldType"] = $bb8ecfce0aa3278d$export$ed12481c953b8653;
module.exports["BulkConfigureContextContainer"] = $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c;
module.exports["useAvailableSitesActions"] = $bb8ecfce0aa3278d$export$34f182b55b8247e5;
module.exports["useAvailableSitesState"] = $bb8ecfce0aa3278d$export$b6149499a5c58797;
module.exports["useProjectsActions"] = $bb8ecfce0aa3278d$export$af9c52e036827f6;
module.exports["useProjectsState"] = $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd;
module.exports["useIssueTypesActions"] = $bb8ecfce0aa3278d$export$8748a77548356db8;
module.exports["useIssueTypesState"] = $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1;
module.exports["useIsConfigureLoading"] = $bb8ecfce0aa3278d$export$fd383356e1d8436d;
module.exports["useMappingsActions"] = $bb8ecfce0aa3278d$export$d70d2e57670622a8;
module.exports["useMappingsState"] = $bb8ecfce0aa3278d$export$c8eb692d6965a0dd;
module.exports["useResetConfigureState"] = $bb8ecfce0aa3278d$export$2577d7c75421da7d;

});

parcelRegister("2ViZo", function(module, exports) {

var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $9uzSK = parcelRequire("9uzSK");

var $2f9600f9f25e1b5c$export$fdc86e92bb21a7 = /*#__PURE__*/ function(BulkSelectionResult) {
    BulkSelectionResult["None"] = "none";
    BulkSelectionResult["Table"] = "table";
    BulkSelectionResult["ActionItems"] = "actionItems";
    return BulkSelectionResult;
}({});
const $2f9600f9f25e1b5c$export$37727a36204b884e = ({ actions: actions, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, pageMode: pageMode, hasEditPermission: hasEditPermission, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageMode);
    const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const hasTableSelection = shouldUseSelectionAdf ? (0, $9uzSK.isTableSelectionAdf)(selectionAdfResult) && !!selectedTable : !!selectedTable;
    const hasActionItemsSelection = shouldUseSelectionAdf ? (0, $9uzSK.isActionItemsSelectionAdf)(selectionAdfResult) && !!selectedActionList : !!selectedActionList;
    if (!hasTableSelection && !hasActionItemsSelection) // If the selection is not for a table or action items, we shouldn't set any state and return none
    return "none";
    actions.setContentId(contentId);
    actions.setPageMode(pageMode);
    actions.setHasEditPermission(hasEditPermission);
    if (hasTableSelection && selectedTable) return $2f9600f9f25e1b5c$var$prepareFromTableSelection({
        actions: actions,
        selectedTable: selectedTable,
        activeSelection: activeSelection,
        contentId: contentId,
        container: container,
        lastModified: lastModified,
        setIsCreatedFromTable: setIsCreatedFromTable,
        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
        convertSelectionToLegacyFormat: convertSelectionToLegacyFormat
    });
    if (hasActionItemsSelection) return $2f9600f9f25e1b5c$var$prepareFromActionItemsSelection({
        actions: actions,
        selectedActionList: selectedActionList,
        contentId: contentId,
        container: container,
        lastModified: lastModified,
        setIsCreatedFromTable: setIsCreatedFromTable,
        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
        convertSelectionToLegacyFormat: convertSelectionToLegacyFormat
    });
    return "none";
};
const $2f9600f9f25e1b5c$var$prepareFromTableSelection = ({ actions: actions, selectedTable: selectedTable, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    actions.setSelectedTable(selectedTable);
    const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, convertSelectionToLegacyFormat, (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
    actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
    setIsCreatedFromTable(true);
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
    return "table";
};
const $2f9600f9f25e1b5c$var$prepareFromActionItemsSelection = ({ actions: actions, selectedActionList: selectedActionList, contentId: contentId, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    actions.setSelectedActionItems(selectedActionList);
    // Skip if any child has data-task-list-local-id -> avoid double counting nested action items
    const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""]):not(:has([data-task-list-local-id]))');
    const ranges = [];
    actionItems.forEach((actionItem)=>{
        const range = new Range();
        range.selectNodeContents(actionItem);
        const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
        if (validRange) ranges.push(validRange);
    });
    const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, convertSelectionToLegacyFormat, ranges, container, lastModified);
    actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
    setIsCreatedFromActionItems(true);
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
    return "actionItems";
};
const $2f9600f9f25e1b5c$export$6ff73f32211bfd03 = (isCreatedFromTable, isCreatedFromActionItems, selectedTable, selectedActionItems)=>{
    if (isCreatedFromTable && selectedTable) return (0, $euVTc.getRowIndicesWithContent)(selectedTable.rows);
    if (isCreatedFromActionItems && selectedActionItems) return (0, $cSSgB.mapActionItemsToIssues)(selectedActionItems).map((issue)=>issue.rowIndex ?? -1);
    return [];
};
module.exports["BulkSelectionResult"] = $2f9600f9f25e1b5c$export$fdc86e92bb21a7;
module.exports["prepareBulkCreateFromSelection"] = $2f9600f9f25e1b5c$export$37727a36204b884e;
module.exports["calculateExpectedIssueIndices"] = $2f9600f9f25e1b5c$export$6ff73f32211bfd03;

});

parcelRegister("6fW2K", function(module, exports) {
const $10452e13953ff67b$export$a6cf0354d3df720c = 'bulk-issue-create-side-panel';
const $10452e13953ff67b$export$8f4d251ee889c2c8 = 320;
const $10452e13953ff67b$export$b40c2dab90d99521 = 439;
module.exports["BULK_ISSUE_CREATE_SIDE_PANEL_ID"] = $10452e13953ff67b$export$a6cf0354d3df720c;
module.exports["BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $10452e13953ff67b$export$8f4d251ee889c2c8;
module.exports["ROVO_BULK_CREATE_SIDE_PANEL_WIDTH"] = $10452e13953ff67b$export$b40c2dab90d99521;

});

parcelRegister("lpGuF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $988c838c2543c991$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT = '/wiki/api/v2/trello/inbox/card';
const $988c838c2543c991$var$CARD_NAME_MAX_LENGTH = 254;
const $988c838c2543c991$var$HORIZONTAL_ELLIPSIS = "\u2026";
const $988c838c2543c991$var$toPayloadSafeName = (raw, maxLength = $988c838c2543c991$var$CARD_NAME_MAX_LENGTH)=>{
    const normalized = String(raw).replace(/[\r\n\t]+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    const firstPartLength = Math.max(0, maxLength - $988c838c2543c991$var$HORIZONTAL_ELLIPSIS.length);
    return normalized.substring(0, firstPartLength) + $988c838c2543c991$var$HORIZONTAL_ELLIPSIS;
};
const $988c838c2543c991$export$750e0c983aee1f51 = async ({ text: text, contentId: contentId })=>{
    const payload = {
        name: $988c838c2543c991$var$toPayloadSafeName(text, $988c838c2543c991$var$CARD_NAME_MAX_LENGTH),
        description: text || 'Created via Confluence',
        sourceContentId: contentId,
        sourceUrl: typeof location !== 'undefined' ? location.href : undefined
    };
    try {
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        const resp = await fetch($988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) {
            $988c838c2543c991$var$logger.error`Failed to create Trello card for contentId=${contentId} status=${resp.status}`;
            return null;
        }
        const data = await resp.json();
        const idCandidate = data.cardId;
        const urlCandidate = data.cardUrl;
        if (!idCandidate || !urlCandidate) {
            $988c838c2543c991$var$logger.error`Invalid Trello response for contentId=${contentId}`;
            return null;
        }
        const response = {
            cardId: idCandidate || '',
            cardUrl: urlCandidate || '',
            success: true
        };
        return response;
    } catch  {
        $988c838c2543c991$var$logger.error`Error creating Trello card for contentId=${contentId}`;
        return null;
    }
};
module.exports["createTrelloCardHandle"] = $988c838c2543c991$export$750e0c983aee1f51;

});

parcelRegister("dMbwP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $QJ7O4 = parcelRequire("QJ7O4");

/**
 * Monochrome Trello board icon matching the design system icon style
 * used by other items in the highlight actions menu (e.g. WorkItemIcon).
 *
 * Path data sourced from design-team-provided Trello-14px.svg,
 * translated from a 24x24 viewBox (offset 4,4) to 16x16 with 1px inset
 * for optical alignment with other menu icons.
 */ const $aa74cc1d9c17d5e2$var$TRELLO_INBOX_GLYPH = '<path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z"/>';
const $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.default), {
            name: "TrelloInboxIcon",
            dangerouslySetGlyph: $aa74cc1d9c17d5e2$var$TRELLO_INBOX_GLYPH,
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.default), {
        name: "TrelloInboxIcon",
        dangerouslySetGlyph: $aa74cc1d9c17d5e2$var$TRELLO_INBOX_GLYPH,
        ...props
    });
module.exports["TrelloInboxIcon"] = $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7;

});

parcelRegister("9ujb2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7W8i8 = parcelRequire("7W8i8");

const $26b2f47c8bb8be0c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT = '/wiki/api/v2/trello/inbox/has-access';
let $26b2f47c8bb8be0c$var$cachedResult = null;
let $26b2f47c8bb8be0c$var$fetchPromise = null;
function $26b2f47c8bb8be0c$export$66160e11912cf1e6() {
    $26b2f47c8bb8be0c$var$cachedResult = null;
    $26b2f47c8bb8be0c$var$fetchPromise = null;
}
function $26b2f47c8bb8be0c$var$cacheErrorResult() {
    const result = {
        hasTrelloAccess: false,
        loading: false,
        error: true
    };
    $26b2f47c8bb8be0c$var$cachedResult = result;
    return result;
}
function $26b2f47c8bb8be0c$export$52c51aee2d49bb7f() {
    if (!$26b2f47c8bb8be0c$var$fetchPromise) $26b2f47c8bb8be0c$var$fetchPromise = Promise.resolve().then(()=>// oxlint-disable-next-line eslint-core/no-restricted-syntax
        fetch($26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        })).then(async (response)=>{
        if (!response.ok) {
            $26b2f47c8bb8be0c$var$logger.warn`Failed to check Trello access: status=${response.status}`;
            return $26b2f47c8bb8be0c$var$cacheErrorResult();
        }
        const data = await response.json();
        const result = {
            hasTrelloAccess: Boolean(data.hasTrelloAccess),
            loading: false,
            error: false
        };
        $26b2f47c8bb8be0c$var$cachedResult = result;
        return result;
    }).catch((error)=>{
        $26b2f47c8bb8be0c$var$logger.error`Error checking Trello access: ${error}`;
        return $26b2f47c8bb8be0c$var$cacheErrorResult();
    });
    return $26b2f47c8bb8be0c$var$fetchPromise;
}
const $26b2f47c8bb8be0c$export$955874e1badc4683 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [state, setState] = (0, $cozmU.useState)($26b2f47c8bb8be0c$var$_temp);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if ($26b2f47c8bb8be0c$var$cachedResult) {
                setState($26b2f47c8bb8be0c$var$cachedResult);
                return;
            }
            let cancelled = false;
            $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
                if (!cancelled) setState(result);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return state;
} : ()=>{
    const [state, setState] = (0, $cozmU.useState)(()=>$26b2f47c8bb8be0c$var$cachedResult ?? {
            hasTrelloAccess: false,
            loading: true,
            error: false
        });
    (0, $cozmU.useEffect)(()=>{
        if ($26b2f47c8bb8be0c$var$cachedResult) {
            setState($26b2f47c8bb8be0c$var$cachedResult);
            return;
        }
        let cancelled = false;
        $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
            if (!cancelled) setState(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    return state;
};
function $26b2f47c8bb8be0c$var$_temp() {
    return $26b2f47c8bb8be0c$var$cachedResult ?? {
        hasTrelloAccess: false,
        loading: true,
        error: false
    };
}
module.exports["prefetchTrelloAccess"] = $26b2f47c8bb8be0c$export$52c51aee2d49bb7f;
module.exports["useTrelloAccess"] = $26b2f47c8bb8be0c$export$955874e1badc4683;

});

parcelRegister("lEDve", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9kbTQ = parcelRequire("9kbTQ");


var $9GVkD = parcelRequire("9GVkD");


var $bR6es = parcelRequire("bR6es");


var $id4ij = parcelRequire("id4ij");


var $bEdUx = parcelRequire("bEdUx");

const $709c5a5818d3675c$var$popupAnimation = null;
const $709c5a5818d3675c$var$popupPanelStyles = null;
const $709c5a5818d3675c$var$popupTransition = null;
const $709c5a5818d3675c$var$toolbarContainerStyle = null;
const $709c5a5818d3675c$var$i18n = (0, $kSwu1.defineMessages)({
    toolbarAlert: {
        id: "highlight-actions.toolbar.alert",
        defaultMessage: "Floating toolbar is available. Press tab to access it"
    }
});
const $709c5a5818d3675c$export$129a32eedafa97c5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, top: top, left: left, needTransition: t1, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition } = t0;
    const needTransition = t1 === undefined ? true : t1;
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
    } else t2 = $[0];
    (0, $cozmU.useEffect)($709c5a5818d3675c$var$_temp2, t2);
    let t3;
    if ($[1] !== children || $[2] !== formatMessage || $[3] !== needTransition || $[4] !== onMouseEnter || $[5] !== onMouseLeave || $[6] !== popupLeft || $[7] !== top) {
        const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        let t4;
        if ($[9] !== onMouseEnter || $[10] !== onMouseLeave) {
            t4 = onMouseEnter && onMouseLeave && {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            };
            $[9] = onMouseEnter;
            $[10] = onMouseLeave;
            $[11] = t4;
        } else t4 = $[11];
        const mouseMoveHandlers = t4;
        t3 = portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupContainerRef,
            style: {
                top: top
            },
            ...mouseMoveHandlers,
            className: (0, $hekY6.default)([
                "_2fBhteUZyi _1mT5xdWVPG",
                needTransition && "_23rrnHpBgU"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
            id: "toolbar-alert"
        }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), /*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $hekY6.default)([
                "_1VJPcaQMLl _1mT5xdWVPG _2IhTondnbC"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
            label: "Renderer toolbar"
        }, children))), portalContainer_0) : null;
        $[1] = children;
        $[2] = formatMessage;
        $[3] = needTransition;
        $[4] = onMouseEnter;
        $[5] = onMouseLeave;
        $[6] = popupLeft;
        $[7] = top;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, top: top, left: left, needTransition: needTransition = true, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition })=>{
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
        if (!portalContainer) return;
        const screenreaderCb = (_mutationsList, observer)=>{
            //These accessibility attributes are added dynamically here rather than directly on the VisuallyHidden element because it did not get read by the NVDA screenreader properly on Firefox. This is due to the screenreader sometimes only reading content when there has been a dynamic change to an element
            const accessibleDiv = document.getElementById('toolbar-alert');
            if (accessibleDiv instanceof HTMLElement) {
                accessibleDiv?.setAttribute('role', 'alert');
                accessibleDiv?.setAttribute('aria-live', 'polite');
                observer.disconnect();
            }
        };
        const observer_0 = new MutationObserver(screenreaderCb);
        observer_0.observe(portalContainer, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer_0.disconnect();
        };
    }, []); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
    const mouseMoveHandlers = onMouseEnter && onMouseLeave && {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupContainerRef,
        style: {
            top: top
        },
        ...mouseMoveHandlers,
        className: (0, $hekY6.default)([
            "_2fBhteUZyi _1mT5xdWVPG",
            needTransition && "_23rrnHpBgU"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        id: "toolbar-alert"
    }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $hekY6.default)([
            "_1VJPcaQMLl _1mT5xdWVPG _2IhTondnbC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
        label: "Renderer toolbar"
    }, children))), portalContainer_0) : null;
};
const $709c5a5818d3675c$var$useAdjustedLeft = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedLeft(left, popupRef) {
    const $ = (0, $bDgLe.c)(4);
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    let t0;
    let t1;
    if ($[0] !== left || $[1] !== popupRef) {
        t0 = ()=>{
            if (!popupRef.current) return;
            const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
            const windowWidth = window.innerWidth;
            let containerBounds = {
                left: 0,
                right: windowWidth
            };
            const nav4ContentContainer = document.getElementById("AkMainContent");
            if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
            if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + 20);
            else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - 20);
            else setAdjustedLeft(left);
            setAdjustedLeftOrigin(left);
        };
        t1 = [
            left,
            popupRef
        ];
        $[0] = left;
        $[1] = popupRef;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    return adjustedLeftOrigin === left ? adjustedLeft : left;
} : function useAdjustedLeft(left, popupRef) {
    const WINDOW_PADDING = 20;
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!popupRef.current) return;
        const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
        const windowWidth = window.innerWidth;
        let containerBounds = {
            left: 0,
            right: windowWidth
        }; // When nav4 container doesn't exist, the window is the container
        const nav4ContentContainer = document.getElementById('AkMainContent');
        if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
         // WS-1703 - If the popup menu is off either side of the screen or outside of the scrollable content area
        // set it so it's inside the WINDOW_PADDING
        if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + WINDOW_PADDING);
        else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - WINDOW_PADDING);
        else setAdjustedLeft(left);
        setAdjustedLeftOrigin(left);
    }, [
        left,
        popupRef
    ]); // Only use the adjustedLeft if it was calculated relative to the current left prop
    return adjustedLeftOrigin === left ? adjustedLeft : left;
};
/**
 * `popupPortalContainerId` is after the ADF renderer in the HTML DOM.
 * Consequently, when there is vertical layout shift before `popupPortalContainerId` such as in the ADF renderer, the `Popup` will automatically shift away from the selected range.
 * This automatic shift is undesirable and `useAdjustedTop` is attempting to undo it in a way as imperceptible to the user as possible.
 *
 * Inspired by {@link https://floating-ui.com/} which is "The Future of Popper". Both Popper and Floating UI are used by Design System to deal with popups including to reposition them.
 */ const $709c5a5818d3675c$var$useAdjustedTop = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedTop(updatePosition, popupContainerRef) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        $[0] = t0;
    } else t0 = $[0];
    const portalContainer = t0;
    let t1;
    let t2;
    if ($[1] !== popupContainerRef || $[2] !== updatePosition) {
        t1 = ()=>{
            if (!portalContainer || !updatePosition || !("ResizeObserver" in window)) return;
            const { parentElement: parentElement } = portalContainer;
            if (!parentElement) return;
            const observer = new ResizeObserver(()=>{
                if (!popupContainerRef.current) return;
                const newPosition = updatePosition();
                if (!newPosition) return;
                const { style: style } = popupContainerRef.current;
                const newTop = `${newPosition.top}px`;
                if (style.top !== newTop) {
                    style.transition = "none";
                    style.top = newTop;
                }
            });
            observer.observe(parentElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupContainerRef,
            portalContainer,
            updatePosition
        ];
        $[1] = popupContainerRef;
        $[2] = updatePosition;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useAdjustedTop(updatePosition, popupContainerRef) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    (0, $cozmU.useEffect)(()=>{
        if (!portalContainer || !updatePosition || !('ResizeObserver' in window)) return; // The position of `popupPortalContainerId` relative to the selected range will change when the parent element of `popupPortalContainerId` is resized.
        const { parentElement: parentElement } = portalContainer;
        if (!parentElement) return;
        const observer = new ResizeObserver(()=>{
            if (!popupContainerRef.current) return;
            const newPosition = updatePosition();
            if (!newPosition) return;
            const { style: style } = popupContainerRef.current;
            const newTop = `${newPosition.top}px`;
            if (style.top !== newTop) {
                // `popupPortalContainerId` moved and automatically shifted `popupContainerRef` away from the selected range.
                // This automatic shift is undesirable and here we're attempting to undo it in a way as imperceptible to the user as possible.
                // Imperceptible here means that a transition animation cannot be used.
                style.transition = 'none';
                style.top = newTop;
            }
        });
        observer.observe(parentElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupContainerRef,
        portalContainer,
        updatePosition
    ]);
};
function $709c5a5818d3675c$var$_temp(_mutationsList, observer) {
    const accessibleDiv = document.getElementById("toolbar-alert");
    if (accessibleDiv instanceof HTMLElement) {
        accessibleDiv?.setAttribute("role", "alert");
        accessibleDiv?.setAttribute("aria-live", "polite");
        observer.disconnect();
    }
}
function $709c5a5818d3675c$var$_temp2() {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    if (!portalContainer) return;
    const screenreaderCb = $709c5a5818d3675c$var$_temp;
    const observer_0 = new MutationObserver(screenreaderCb);
    observer_0.observe(portalContainer, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer_0.disconnect();
    };
}
module.exports["Popup"] = $709c5a5818d3675c$export$129a32eedafa97c5;

});

parcelRegister("dj3mI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $54a4a16d7bb73c56$export$35ad57ac36645074 = (isContentArchived, canAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unsupported.archive",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Reactions can't be added to archived content"
    });
    else if (!canAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add reactions to this blogpost} page {You do not have permission to add reactions to this page} other {You do not have permission to add reactions to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.needs.update",
        defaultMessage: "Page is outdated, refresh to react"
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unable.to.create",
        defaultMessage: "Unable to react to this element"
    });
};
const $54a4a16d7bb73c56$export$52cdeba2896092f6 = (isContentArchived, userCanAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported.archive",
        defaultMessage: "Comments can\u2019t be added to archived items"
    });
    else if (!userCanAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.needs.update",
        defaultMessage: "Page is outdated, refresh to comment"
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unable.to.create",
        defaultMessage: "Unable to comment on this element"
    });
};
module.exports["getReactionButtonDisabledMessage"] = $54a4a16d7bb73c56$export$35ad57ac36645074;
module.exports["getCreateButtonDisabledMessage"] = $54a4a16d7bb73c56$export$52cdeba2896092f6;

});

parcelRegister("6zmDz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $164fd7006e7d8160$export$d7f009f4a3abb74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYE1Y8M _3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$var$disabledButtonWrapperStyle = null;
const $164fd7006e7d8160$export$b065c4c0e869841d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ])
    });
const $164fd7006e7d8160$var$disabledButtonOverlayStyle = null;
const $164fd7006e7d8160$export$dea79eb12e1f6e1f = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _42Yu6BE7ZR _0KLXrujOvk _0wOv4Qsyl5"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _42Yu6BE7ZR _0KLXrujOvk _0wOv4Qsyl5"
        ])
    });
module.exports["BuiltInActionsSimple"] = $164fd7006e7d8160$export$d7f009f4a3abb74;
module.exports["DisabledButtonWrapper"] = $164fd7006e7d8160$export$b065c4c0e869841d;
module.exports["DisabledButtonOverlay"] = $164fd7006e7d8160$export$dea79eb12e1f6e1f;

});

parcelRegister("3QARf", function(module, exports) {

let $2cd2d1a3be80073f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cd2d1a3be80073f$var$load("hpN5y").then(()=>parcelRequire('jhEjP'));

});

parcelRegister("5UUHQ", function(module, exports) {

let $44ee2b60d0e0b101$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $44ee2b60d0e0b101$var$load("aqs28"),
    $44ee2b60d0e0b101$var$load("6wr18"),
    $44ee2b60d0e0b101$var$load("ffEVr"),
    $44ee2b60d0e0b101$var$load("ckVWI"),
    $44ee2b60d0e0b101$var$load("aSmvL")
]).then(()=>parcelRequire('1TWCG'));

});

parcelRegister("9uzSK", function(module, exports) {

var $4AavA = parcelRequire("4AavA");


var $c8cGy = parcelRequire("c8cGy");


var $fWHe9 = parcelRequire("fWHe9");

const $51e2077cdc43ebd4$var$isTextNode = (node)=>!!node && node.type === 'text' && 'text' in node;
const $51e2077cdc43ebd4$var$INLINE_NODE_TYPES = new Set([
    'inlineCard',
    'mention',
    'emoji',
    'hardBreak',
    'status',
    'date'
]);
const $51e2077cdc43ebd4$var$isInlineNode = (node)=>$51e2077cdc43ebd4$var$isTextNode(node) || $51e2077cdc43ebd4$var$INLINE_NODE_TYPES.has(node.type);
const $51e2077cdc43ebd4$var$extractAllText = (node)=>{
    if (!node) return '';
    if ($51e2077cdc43ebd4$var$isTextNode(node)) return node.text;
    if (Array.isArray(node.content)) {
        const childTexts = node.content.map($51e2077cdc43ebd4$var$extractAllText);
        // Join child texts with a space and then normalise whitespace so we don't end up with merged words
        return childTexts.join(' ').replace(/\s+/g, ' ').trim();
    }
    return '';
};
/**
 * Gets the node by pointer
 * @param root - The root node
 * @param pointer - The pointer
 * @returns The node by pointer
 */ const $51e2077cdc43ebd4$var$getNodeByPointer = (root, pointer)=>{
    const segments = pointer.split('/').filter(Boolean);
    let current = root;
    for(let i = 0; i < segments.length; i += 1){
        const segment = segments[i];
        if (segment === 'content') {
            const index = Number(segments[i + 1]);
            i += 1;
            if (!current) return null;
            const content = current.content;
            if (!Array.isArray(content) || Number.isNaN(index)) return null;
            current = content[index] ?? null;
            continue;
        }
        if (segment === 'text') return current;
    }
    return current;
};
/**
 * Gets the text from the selection range
 * @param selectedNodeAdf - The selected node ADF
 * @param range - The selection range
 * @returns The text from the selection range
 */ const $51e2077cdc43ebd4$var$getTextFromSelectionRange = (selectedNodeAdf, range)=>{
    const { start: start, end: end } = range;
    if (!start?.pointer || !end?.pointer) return null;
    const targetNode = $51e2077cdc43ebd4$var$getNodeByPointer(selectedNodeAdf, start.pointer);
    if (!targetNode) return null;
    const nodeText = $51e2077cdc43ebd4$var$isTextNode(targetNode) ? targetNode.text : $51e2077cdc43ebd4$var$extractAllText(targetNode);
    if (start.position == null && end.position == null) return nodeText;
    const startPos = start.position ?? 0;
    const endPos = end.position ?? nodeText.length;
    if (startPos >= endPos) return '';
    return nodeText.slice(startPos, endPos);
};
/**
 * Extracts the text from the selection ranges
 * @param selectedNodeAdf - The selected node ADF
 * @param selectionRanges - The selection ranges
 * @returns The text from the selection ranges
 */ const $51e2077cdc43ebd4$var$extractTextFromSelectionRanges = (selectedNodeAdf, selectionRanges)=>{
    let firstNonEmpty = null;
    let lastNonEmpty = null;
    const textSegments = [];
    for (const range of selectionRanges){
        const rangeText = $51e2077cdc43ebd4$var$getTextFromSelectionRange(selectedNodeAdf, range);
        if (rangeText === null) return null;
        const trimmed = rangeText.trim();
        if (!trimmed) continue;
        if (firstNonEmpty === null) firstNonEmpty = trimmed;
        lastNonEmpty = trimmed;
        textSegments.push(rangeText);
    }
    const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
    const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
    if (hasActionItems && !hasTable) // If only multiple action items are selected, use the first task's text as selection
    return firstNonEmpty ?? '';
    if (!hasActionItems && !hasTable) {
        // For plain text selections combine all selected ranges
        if (textSegments.length === 0) return '';
        return textSegments.join('').trim();
    }
    // If multiple nodes selected (ex: table and action items), use the last piece of text
    return lastNonEmpty ?? '';
};
/**
 * Clones a text node slice from the start position to the end position
 * @param node - The text node to clone
 * @param from - The start position
 * @param to - The end position
 * @returns The cloned text node slice
 */ const $51e2077cdc43ebd4$var$cloneTextNodeSlice = (node, from, to)=>{
    const slicedText = node.text.slice(from, to);
    if (!slicedText) return null;
    return {
        ...node,
        text: slicedText
    };
};
/**
 * Builds an ADF slice from the selection ranges
 * @param selectedNodeAdf - The selected node ADF
 * @param selectionRanges - The selection ranges
 * @returns The ADF slice
 */ const $51e2077cdc43ebd4$var$buildAdfSliceFromRanges = (selectedNodeAdf, selectionRanges)=>{
    const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
    const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
    const inlineSlices = [];
    for (const range of selectionRanges){
        const { start: start, end: end } = range;
        if (!start?.pointer || !end?.pointer) continue;
        const targetNode = $51e2077cdc43ebd4$var$getNodeByPointer(selectedNodeAdf, start.pointer);
        if (!$51e2077cdc43ebd4$var$isTextNode(targetNode)) continue;
        const fullTextLength = targetNode.text.length;
        const startPos = start.position ?? 0;
        const endPos = end.position ?? fullTextLength;
        if (startPos >= endPos) continue;
        const sliced = $51e2077cdc43ebd4$var$cloneTextNodeSlice(targetNode, startPos, endPos);
        if (!sliced) continue;
        inlineSlices.push(sliced);
    }
    if (inlineSlices.length === 0) return undefined;
    let content;
    if (hasActionItems && !hasTable) content = [
        inlineSlices[0]
    ];
    else if (!hasActionItems && !hasTable) content = inlineSlices;
    else content = [
        inlineSlices[inlineSlices.length - 1]
    ];
    return {
        type: 'paragraph',
        content: content
    };
};
const $51e2077cdc43ebd4$export$9c1aa4b084b580d = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return '';
    const { selectionRanges: selectionRanges } = selectionAdfResult ?? {};
    if (!selectionRanges || selectionRanges.length === 0) {
        const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
        const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
        // Case for multiple action items selection without a selectionRange, only take the first action item text
        if (hasActionItems && !hasTable) {
            const firstActionItemText = $51e2077cdc43ebd4$var$extractAllText($51e2077cdc43ebd4$var$findFirstActionItemNode(selectedNodeAdf));
            if (firstActionItemText) return firstActionItemText;
        }
        return $51e2077cdc43ebd4$var$extractAllText(selectedNodeAdf);
    }
    return $51e2077cdc43ebd4$var$extractTextFromSelectionRanges(selectedNodeAdf, selectionRanges) ?? $51e2077cdc43ebd4$var$extractAllText(selectedNodeAdf);
};
const $51e2077cdc43ebd4$export$3c73e23a024e29a3 = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return undefined;
    const { selectionRanges: selectionRanges } = selectionAdfResult ?? {};
    if (!selectionRanges || selectionRanges.length === 0) {
        const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
        const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
        // Case for multiple action items selection without a selectionRange, only take the first action item text
        if (hasActionItems && !hasTable) {
            const firstActionItemText = $51e2077cdc43ebd4$var$extractAllText($51e2077cdc43ebd4$var$findFirstActionItemNode(selectedNodeAdf));
            if (firstActionItemText) return (0, $4AavA.doc)((0, $c8cGy.paragraph)(firstActionItemText));
        }
        return selectedNodeAdf;
    }
    // Try to build a slice that preserves formatting from original ADF
    const adfSlice = $51e2077cdc43ebd4$var$buildAdfSliceFromRanges(selectedNodeAdf, selectionRanges);
    if (adfSlice) return adfSlice;
    // Fallback is to just use a plain-text slice when we can't construct a ADF slice from the ranges
    const selectionText = $51e2077cdc43ebd4$export$9c1aa4b084b580d(selectionAdfResult);
    return selectionText ? (0, $4AavA.doc)((0, $c8cGy.paragraph)(selectionText)) : selectedNodeAdf;
};
const $51e2077cdc43ebd4$export$a66ab8faf71a3c88 = (adf)=>{
    if (!adf) return (0, $4AavA.doc)((0, $c8cGy.paragraph)(''));
    if (adf.type === 'doc') return adf;
    if ($51e2077cdc43ebd4$var$isInlineNode(adf)) return (0, $4AavA.doc)((0, $c8cGy.paragraph)(adf));
    return {
        type: 'doc',
        version: 1,
        content: [
            adf
        ]
    };
};
/**
 * Splits the text into a summary and a description
 * @param text - The text to split
 * @param maxLength - The maximum length of the summary
 * @returns The summary and the description
 */ const $51e2077cdc43ebd4$var$extractSummary = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $51e2077cdc43ebd4$export$4ab5d7d08a482714 = (selectionAdfResult, maxLength)=>{
    const selectionText = $51e2077cdc43ebd4$export$9c1aa4b084b580d(selectionAdfResult);
    const selectionAdf = $51e2077cdc43ebd4$export$3c73e23a024e29a3(selectionAdfResult) ?? selectionAdfResult?.selectedNodeAdf;
    const [summary] = $51e2077cdc43ebd4$var$extractSummary(selectionText, maxLength);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    return [
        summaryWithoutFormatting,
        $51e2077cdc43ebd4$export$a66ab8faf71a3c88(selectionAdf)
    ];
};
const $51e2077cdc43ebd4$var$TABLE_TYPES = new Set((0, $fWHe9.TABLE_NODE_TYPES));
/**
 * Checks if the node contains a table type
 * @param node - The node to check
 * @returns True if the node contains a table type, false otherwise
 */ const $51e2077cdc43ebd4$var$containsTableType = (node)=>{
    if (!node) return false;
    if ($51e2077cdc43ebd4$var$TABLE_TYPES.has(node.type)) return true;
    const content = node.content;
    if (!content) return false;
    return content.some($51e2077cdc43ebd4$var$containsTableType);
};
/**
 * Finds the first task item node within an ADF tree.
 * @param node - The root node to search from
 * @returns The first encountered taskItem node, or null if none is found
 */ const $51e2077cdc43ebd4$var$findFirstActionItemNode = (node)=>{
    if (!node) return null;
    const nodesToVisit = [
        node
    ];
    for(let i = 0; i < nodesToVisit.length; i += 1){
        const current = nodesToVisit[i];
        if (current.type === 'taskItem') return current;
        const content = current.content;
        if (Array.isArray(content) && content.length > 0) nodesToVisit.push(...content);
    }
    return null;
};
const $51e2077cdc43ebd4$export$513b701e17971c9f = (selectionAdfResult)=>selectionAdfResult?.selectedNodeAdf?.type === 'table' && !!selectionAdfResult.selectionRanges && selectionAdfResult.selectionRanges.length > 1;
const $51e2077cdc43ebd4$var$ACTION_ITEM_TYPES = new Set((0, $fWHe9.ACTION_ITEM_NODE_TYPES));
/**
 * Checks if the node contains an action item type
 * @param node - The node to check
 * @returns True if the node contains an action item type, false otherwise
 */ const $51e2077cdc43ebd4$var$containsActionItemType = (node)=>{
    if (!node) return false;
    if ($51e2077cdc43ebd4$var$ACTION_ITEM_TYPES.has(node.type)) return true;
    const content = node.content;
    return Array.isArray(content) && content.some($51e2077cdc43ebd4$var$containsActionItemType);
};
const $51e2077cdc43ebd4$export$86049b93219a615c = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return false;
    return $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
};
module.exports["extractSelectedAdfSlice"] = $51e2077cdc43ebd4$export$3c73e23a024e29a3;
module.exports["normalizeToDocNode"] = $51e2077cdc43ebd4$export$a66ab8faf71a3c88;
module.exports["getSummaryAndDescriptionFromSelectionAdfResult"] = $51e2077cdc43ebd4$export$4ab5d7d08a482714;
module.exports["isTableSelectionAdf"] = $51e2077cdc43ebd4$export$513b701e17971c9f;
module.exports["isActionItemsSelectionAdf"] = $51e2077cdc43ebd4$export$86049b93219a615c;

});

parcelRegister("fWHe9", function(module, exports) {
const $f093b0f0b5b0aeb7$export$77438d6c10b4e651 = [
    'table',
    'tableRow',
    'tableCell',
    'tableHeader'
];
const $f093b0f0b5b0aeb7$export$e8de71ddb126302c = [
    'taskList',
    'taskItem'
];
module.exports["TABLE_NODE_TYPES"] = $f093b0f0b5b0aeb7$export$77438d6c10b4e651;
module.exports["ACTION_ITEM_NODE_TYPES"] = $f093b0f0b5b0aeb7$export$e8de71ddb126302c;

});


//# sourceMappingURL=FullPageEditorComponent.36765997.js.map
